// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const ColorIdToColor = [
  "#2f3233",
  "#84949c",
  "#8e775e",
  "#f1e7d0",
  "#646f75",
  "#6a5a48",
  "#c9bfa9",
  "#7b8771",
  "#8a5b3b",
  "#6d585f",
  "#612526",
  "#5c6e6f",
  "#b3a65c",
  "#666666",
  "#8c8c8c",
  "#b3b3b3",
  "#cccccc",
  "#e6e6e6",
  "#a4b495",
  "#a0afb7",
  "#af9981",
  "#fbf3e3",
  "#b9caac",
  "#d8976b",
  "#b0939d",
  "#ac595a",
  "#97b1b2",
  "#ffeec0",
  "#ba774a",
  "#ff69b4",
  "#92747e",
  "#832f30",
  "#799395",
  "#f2f2ed",
  "#f2df77",
  "#b2a9a4",
  "#edece6",
  "#121617",
  "#eeecda",
  "#55544e",
  "#e8d9ba",
  "#f7f5e9",
  "#d1c0aa",
  "#050505",
  "#515255",
  "#615c50",
  "#f8fdff",
  "#2F2F30",
  "#676869",
  "#b9b8b2",
  "#53575e",
  "#e3e5e3",
  "#2F2F30",
  "#363535",
  "#585654",
  "#bc6646",
  "#c8d6e5",
  "#bad2db",
  "#e8e5da",
  "#e4dacd",
  "#a0a09e",
  "#605157",
  "#444c57",
  "#86837b",
  "#676869",
  "#b9b8b2",
  "#e9eae7",
  "#53575e",
  "#C8BFB5",
  "#C2C0BB",
  "#4B2929",
  "#303B39",
  "#403330",
  "#C2B6B6",
  "#756761",
  "#5E6259",
  "#727C7F",
  "#596368",
  "#23383F",
  "#BEC1C3",
  "#2F2F30",
  "#313031",
  "#373A3A",
  "#E7E2DA",
  "#EDEAE5",
  "#EDECE6",
  "#E3DED0",
  "#CCC9C0",
  "#4F4842",
  "#CCC5BD",
  "#867A6F",
  "#887B6C",
  "#D1C7B8",
  "#C0B2A2",
  "#BEB5A9",
  "#6B645B",
  "#E0E0D9",
  "#A7A8A2",
  "#7F817E",
  "#636562",
  "#DCD2C3",
  "#60797D",
  "#657B83",
  "#B2ADA4",
  "#9D9887",
  "#979FA5",
  "#939591",
  "#988F85",
  "#e3e5e3",
  "#2F2F30",
  "#676869",
  "#b9b8b2",
  "#53575e",
  "#e3e5e3",
  "#2F2F30",
  "#676869",
  "#949488",
  "#cfcbc2",
  "#F0EADC",
  "#EEEFEA",
  "#8AA3B1",
  "#626970",
  "#b9b8b2",
  "#CFCAC7",
  "#978A7F",
  "#d9d7cb",
  "#CFBEA9",
  "#BAB9B6",
  "#e1d9c5",
  "#D8E0DF",
  "#F5E1A6",
  "#D3CCC4",
  "#4F4D51",
  "#EDECE6",
  "#969eab",
  "#48423C",
  "#53575e",
  "#8e9698",
  "#d6dbd5",
  "#969d95",
  "#2F2F30",
  "#536872",
  "#e3e5e3",
  "#d1c0aa",
  "#2F2F30",
  "#676869",
  "#949488",
  "#cfcbc2",
  "#F0EADC",
  "#EEEFEA",
  "#8AA3B1",
  "#626970",
  "#b9b8b2",
  "#CFCAC7",
  "#978A7F",
  "#d9d7cb",
  "#CFBEA9",
  "#BAB9B6",
  "#e1d9c5",
  "#D8E0DF",
  "#F5E1A6",
  "#D3CCC4",
  "#4F4D51",
  "#EDECE6",
  "#969eab",
  "#48423C",
  "#53575e",
  "#666c78",
  "#bdc5b8",
  "#2F2F30",
  "#536872",
  "#e3e5e3",
  "#62615c",
  "#575b67",
  "#313031",
  "#78736E",
  "#887B6C",
  "#dfdeed",
  "#62615c",
  "#575b67",
  "#313031",
  "#78736E",
  "#887B6C",
  "#dfdeed",
  "#5c8797",
  "#2e292f",
  "#575853",
  "#E7E2DA",
  "#e3e5e3",
  "#efefef",
  "#e9e2d0",
  "#9a8b79",
  "#78736E",
  "#727C7F",
  "#74685A",
  "#4f4e4a",
  "#EDECE6",
  "#867A6F",
  "#6B645B",
  "#7F817E",
  "#e4e5df",
  "#c1ae92",
  "#94908c",
  "#727C7F",
  "#596368",
  "#E7E2DA",
  "#EDECE6",
  "#e4e5df",
  "#ebe8d8",
  "#BEB5A9",
  "#988F7B",
  "#ADA8A5",
  "#EDECE6",
  "#C0B2A2",
  "#636562",
  "#bcbfbf",
  "#d8d4bf",
  "#585654",
  "#e8e5da",
  "#444c57",
  "#EDEAE5",
  "#E0E0D9",
  "#939591",
  "#f1efe2",
  "#b4b296",
  "#78736E",
  "#74685A",
  "#e9eae7",
  "#867A6F",
  "#6B645B",
  "#7F817E",
  "#7E6F59",
  "#f1efe2",
  "#b4b296",
  "#C6BFB3",
  "#b2a9a4",
  "#edece6",
  "#373A3A",
  "#E7E2DA",
  "#EDECE6",
  "#D1C7B8",
  "#B2ADA4",
  "#2f2f30",
  "#c6bfad",
  "#e3e5e3",
  "#EDEAE5",
  "#B0B8B2",
  "#605a5d",
  "#798286",
  "#E2E0D6",
  "#596368",
  "#7F817E",
  "#484C49",
  "#9C8A79",
  "#B2B5AF",
  "#5b6043",
  "#DBD0B9",
  "#616669",
  "#A39B7E",
  "#988977",
  "#CBBCA5",
  "#C2BDB1",
  "#BEBFB2",
  "#244653",
  "#E2DED8",
  "#BCB7AD",
  "#CEC6BB",
  "#A8A093",
  "#7C7D75",
  "#BDBDB7",
  "#BBAB95",
  "#E2DDD0",
  "#B2AC9C",
  "#B7B7B2",
  "#9B9893",
  "#585858",
  "#95978A",
  "#91999C",
  "#979083",
  "#4B3029",
  "#94766C",
  "#BEAC9F",
  "#C59F91",
  "#996C6E",
  "#6D595A",
  "#8B534E",
  "#AC7559",
  "#8D422F",
  "#C28E61",
  "#C19E80",
  "#CBB99B",
  "#C19F6E",
  "#AEB08F",
  "#8F8666",
  "#708672",
  "#45584D",
  "#8CA49C",
  "#627F7B",
  "#A0BBB8",
  "#739694",
  "#C0B6B4",
  "#7E696A",
  "#A39B90",
  "#CC8D84",
  "#E8B9AE",
  "#ECCEB9",
  "#ECD0B1",
  "#CDCDB4",
  "#EFC488",
  "#9AABAB",
  "#546670",
  "#974F49",
  "#C08F80",
  "#EEDAC3",
  "#D9C3A6",
  "#ADA193",
  "#7F7263",
  "#C4957A",
  "#A76251",
  "#3A4A3F",
  "#ACA17D",
  "#AE905E",
  "#E9BF8C",
  "#946644",
  "#F3E5D1",
  "#6D817B",
  "#47626F",
  "#B8B2A2",
  "#F0EADC",
  "#F2E0C3",
  "#CBCEC5",
  "#E9E0D5",
  "#D6BCAA",
  "#9E3E33",
  "#F1BFB1",
  "#CBD0C2",
  "#598C74",
  "#AB7878",
  "#C6B9B8",
  "#ABD1C9",
  "#014E4C",
  "#4B5645",
  "#ACB19F",
  "#F0CDA0",
  "#C2CCC4",
  "#CD9C85",
  "#DEC3B9",
  "#BC9C9E",
  "#623F45",
  "#E1D286",
  "#A489A0",
  "#8AC6BD",
  "#DAB5B4",
  "#888782",
  "#F0D39D",
  "#C9AA98",
  "#CD717B",
  "#F6E3A1",
  "#F4E8B2",
  "#F2EAC3",
  "#51323B",
  "#443735",
  "#3D4450",
  "#515763",
  "#4B2929",
  "#622F2D",
  "#975840",
  "#AF8871",
  "#C3B09D",
  "#7F614A",
  "#6E5241",
  "#5F4D43",
  "#506A67",
  "#738478",
  "#979F7F",
  "#CAAB7D",
  "#A58258",
  "#97896A",
  "#565C4A",
  "#C08650",
  "#8B7D7B",
  "#777F86",
  "#887B67",
  "#A6A397",
  "#9A7E64",
  "#96724C",
  "#A39B7E",
  "#A7947C",
  "#D3B699",
  "#ECE1CB",
  "#EBB875",
  "#B4B9B9",
  "#E8D9BD",
  "#E4C495",
  "#AE9278",
  "#85695B",
  "#6A4238",
  "#432722",
  "#7B3728",
  "#937F68",
  "#A79473",
  "#7A6A51",
  "#988F7B",
  "#575449",
  "#324038",
  "#616564",
  "#797978",
  "#B6B7B0",
  "#73705E",
  "#D9AD7F",
  "#BE795E",
  "#9C8A79",
  "#61463A",
  "#EECF9E",
  "#D9A06A",
  "#DFC8B5",
  "#B3AE95",
  "#857C5D",
  "#89A4AD",
  "#F8D492",
  "#E0DEDA",
  "#BCB8B6",
  "#ADA8A5",
  "#847B77",
  "#6D6562",
  "#E4DBD8",
  "#D4CDCA",
  "#B1A3A1",
  "#867875",
  "#6E615F",
  "#4D3C3C",
  "#D1C5C4",
  "#C1B2B3",
  "#B3A3A5",
  "#8B7C7E",
  "#6F5C5F",
  "#4E3132",
  "#E3D9D5",
  "#D6C2BE",
  "#C9B0AB",
  "#B89D9A",
  "#907676",
  "#76595D",
  "#5F3D3F",
  "#E5DCD6",
  "#D7C8C2",
  "#C3B1AC",
  "#B6A09A",
  "#8C706A",
  "#7A5F5A",
  "#5A3532",
  "#E3DBD4",
  "#D1C5BE",
  "#BFB1AA",
  "#AC9E97",
  "#8C7E78",
  "#56433B",
  "#E5DAD4",
  "#D6C8C0",
  "#C6B3A9",
  "#B8A196",
  "#947569",
  "#806257",
  "#5A382D",
  "#E7DBD3",
  "#DBC7BD",
  "#CFB4A8",
  "#C3A497",
  "#9C6E63",
  "#85594F",
  "#5D3831",
  "#E9DDD4",
  "#DECABD",
  "#D1B7A8",
  "#C1A392",
  "#9D7868",
  "#896656",
  "#694336",
  "#E6DDD5",
  "#D9CDC3",
  "#CBB9AB",
  "#BBA595",
  "#967A6A",
  "#715243",
  "#4F3426",
  "#E5E1D8",
  "#D4CCC3",
  "#C1B6AB",
  "#B7AB9F",
  "#8D7F75",
  "#756861",
  "#4D3930",
  "#E4DCD4",
  "#D3C8BD",
  "#C2B4A7",
  "#B5A597",
  "#907865",
  "#7A6455",
  "#5F4B3F",
  "#E6DDD4",
  "#D6C7B9",
  "#C5B1A2",
  "#B59F8F",
  "#8E725F",
  "#785B47",
  "#634533",
  "#E8DED3",
  "#DAC8B8",
  "#CAB3A0",
  "#BFA38D",
  "#957258",
  "#815D40",
  "#69482C",
  "#E5DDD0",
  "#D7C5B3",
  "#C9B29C",
  "#BCA38B",
  "#947A62",
  "#7D644D",
  "#65503D",
  "#E6DCCD",
  "#D7C5AE",
  "#C7B198",
  "#BAA185",
  "#9E8163",
  "#8A6B4D",
  "#70573F",
  "#EBDDCB",
  "#E4CAAD",
  "#D7B593",
  "#CCA683",
  "#BA8C64",
  "#A57955",
  "#8D623D",
  "#E8DCC6",
  "#DBC7A8",
  "#CDB592",
  "#C5AA85",
  "#B39167",
  "#9C7A56",
  "#8A6645",
  "#E9DCC6",
  "#E4CEAC",
  "#DCBD92",
  "#D2B084",
  "#C19763",
  "#AD8451",
  "#906A3A",
  "#EADFC9",
  "#E0CFB0",
  "#D0BA94",
  "#C6B08A",
  "#AC9571",
  "#9A815E",
  "#7F6743",
  "#E9DECF",
  "#DACAB2",
  "#CCB79B",
  "#C0A98B",
  "#947F65",
  "#867057",
  "#6E543C",
  "#EAE2D4",
  "#D9CFBA",
  "#C8BBA3",
  "#B8A992",
  "#8E7F6A",
  "#786957",
  "#66543E",
  "#E8E2D4",
  "#DBD0B9",
  "#CDBDA2",
  "#C1AE91",
  "#998970",
  "#7E6F59",
  "#5D513E",
  "#DEDDD1",
  "#D1CCB9",
  "#C1BCA7",
  "#B2AC96",
  "#898473",
  "#6B6757",
  "#5E5949",
  "#E2E0D7",
  "#D1CDBF",
  "#BFB9AA",
  "#B0AB9C",
  "#8B8372",
  "#726B5B",
  "#424036",
  "#E2E2D1",
  "#CECEBD",
  "#BBBCA7",
  "#ACAD97",
  "#7F8266",
  "#65684C",
  "#4F523A",
  "#E3E2D9",
  "#D1D0C6",
  "#ABAC9F",
  "#7B8070",
  "#64695C",
  "#4E5147",
  "#DCDFD7",
  "#D1D3C7",
  "#BDC0B3",
  "#9FA694",
  "#7A8775",
  "#626E60",
  "#465448",
  "#DDDDD6",
  "#C9C9C0",
  "#B6B5AB",
  "#A6A69B",
  "#7F7E72",
  "#6D6C62",
  "#64645A",
  "#E4E4DD",
  "#CDD2CA",
  "#BEC3BB",
  "#AEB3A9",
  "#7A8076",
  "#44483D",
  "#D7DFD8",
  "#C2CDC5",
  "#ADBBB2",
  "#9BAAA2",
  "#7C8E87",
  "#5E706A",
  "#343B36",
  "#DAE2E0",
  "#C2CFCF",
  "#ABBEBF",
  "#9BAFB2",
  "#7A9192",
  "#5D7274",
  "#4A5D5F",
  "#BCCBCE",
  "#A4B7BD",
  "#96AAB0",
  "#607D84",
  "#47626A",
  "#DEE1DF",
  "#CDD2D2",
  "#B8BEBE",
  "#A9B0B1",
  "#23383F",
  "#DBDFE0",
  "#BFC9D0",
  "#AABAC6",
  "#98A9B7",
  "#768B9A",
  "#5D6F7F",
  "#2F3D4C",
  "#DDE2E0",
  "#CAD0D2",
  "#B8C0C3",
  "#ADB5B9",
  "#7A848D",
  "#606B75",
  "#586168",
  "#E3E4E1",
  "#D4D8D7",
  "#A8AEB1",
  "#7D848B",
  "#DDDCDB",
  "#CBC9C9",
  "#B5B1B5",
  "#A6A3A9",
  "#736F78",
  "#5D5962",
  "#4A4653",
  "#CEC9CC",
  "#BDB5B9",
  "#AFA7AC",
  "#85777B",
  "#695C62",
  "#4E4247",
  "#CFC9C8",
  "#BDB8B8",
  "#AEA9AA",
  "#7B787D",
  "#605E63",
  "#3A373E",
  "#DBCFD4",
  "#CBB8C0",
  "#AA8E9A",
  "#8B6878",
  "#7E5A6D",
  "#5F3F54",
  "#E0CDD1",
  "#D2B6BE",
  "#B995A1",
  "#9E6D79",
  "#8D5869",
  "#6D344F",
  "#E8D4D5",
  "#DABDC1",
  "#C79EA2",
  "#9E6B75",
  "#895460",
  "#63333E",
  "#EBD1CF",
  "#DCB6B5",
  "#C39393",
  "#995D62",
  "#864C52",
  "#723941",
  "#EDD3D2",
  "#E6BDBD",
  "#CF8A8D",
  "#AD5E65",
  "#974953",
  "#863A42",
  "#EBCECB",
  "#E3B7B1",
  "#CD8E89",
  "#B56966",
  "#A0524E",
  "#8E3738",
  "#F0E1D8",
  "#EBCFC3",
  "#E3B5A8",
  "#CD8E7F",
  "#B3675D",
  "#A0584F",
  "#7B3730",
  "#EEDED5",
  "#EACDC1",
  "#E2B6A7",
  "#CE9382",
  "#A85E53",
  "#8F4438",
  "#83382A",
  "#EFDED1",
  "#EDD2C0",
  "#E4B9A2",
  "#D9987C",
  "#C1785C",
  "#AD654C",
  "#994B35",
  "#EFE1D2",
  "#ECCFBB",
  "#E5B99B",
  "#DB9C7B",
  "#C47B5B",
  "#B46848",
  "#A2583A",
  "#EDDDCA",
  "#EBCCB3",
  "#E0B392",
  "#D4966E",
  "#C38058",
  "#B46C42",
  "#A6613C",
  "#F0E1D0",
  "#EDD0B6",
  "#E8BE9B",
  "#D69969",
  "#CD8C5D",
  "#BB7748",
  "#B06C3E",
  "#F3E5D2",
  "#F3D9BA",
  "#F0CB97",
  "#E3AC72",
  "#D7995D",
  "#C6884A",
  "#B6743B",
  "#F2E3CA",
  "#F2D5B0",
  "#EDC38E",
  "#E5AE6B",
  "#D59858",
  "#C78538",
  "#B67D3C",
  "#F3E6D4",
  "#F5DEBB",
  "#EDC796",
  "#DDAC6D",
  "#D69E59",
  "#CC9249",
  "#BA7F38",
  "#EFDDC1",
  "#E8C89E",
  "#D6AD78",
  "#CC9B5C",
  "#C09056",
  "#A4763C",
  "#EDE0C5",
  "#E9D6B0",
  "#E1C28D",
  "#C99E53",
  "#BC934D",
  "#AA803A",
  "#996F32",
  "#E9E0C5",
  "#E4D0A5",
  "#D2BA83",
  "#C2A462",
  "#B89B59",
  "#9C7F41",
  "#95793D",
  "#E7DFC5",
  "#DDCDA6",
  "#CBB584",
  "#B1975F",
  "#9D8344",
  "#8E773F",
  "#7A6841",
  "#E9E1CA",
  "#DFD4B0",
  "#CFC291",
  "#BBA86A",
  "#9C9152",
  "#8D844D",
  "#655F2D",
  "#ECEAD5",
  "#E0DDBD",
  "#CBC99D",
  "#AEAC7A",
  "#95945C",
  "#71713E",
  "#5F6033",
  "#E4E4CE",
  "#DBDDBD",
  "#C7CDA8",
  "#ABB486",
  "#88915D",
  "#6D7645",
  "#576238",
  "#E4E8DA",
  "#DAE2CD",
  "#C5D1B2",
  "#A3B48C",
  "#788D60",
  "#60724F",
  "#475842",
  "#E0E7DA",
  "#CFDDC7",
  "#B3CBAA",
  "#8BA97F",
  "#5E7F57",
  "#42603C",
  "#405840",
  "#C8D8C4",
  "#ACC2A8",
  "#98B092",
  "#6C8867",
  "#537150",
  "#205134",
  "#D8E2D8",
  "#C6D5C9",
  "#AAC2B3",
  "#91AF9D",
  "#61826C",
  "#4F6A56",
  "#3D5541",
  "#D7E4DB",
  "#C4D9CE",
  "#ACCABC",
  "#94B5A6",
  "#6B927F",
  "#547867",
  "#2A4F43",
  "#BFD2C9",
  "#A8C1B7",
  "#7EA298",
  "#5F887D",
  "#476F65",
  "#124A42",
  "#E0E7E2",
  "#C3D7D3",
  "#B4CCC9",
  "#8CAEAB",
  "#518682",
  "#2E6864",
  "#01554F",
  "#BEDBD8",
  "#9EC6C6",
  "#7BB1B2",
  "#5C9598",
  "#3C797D",
  "#016367",
  "#C7DFE0",
  "#B0D2D6",
  "#84B4BE",
  "#5B96A2",
  "#217786",
  "#015A6B",
  "#D8E7E6",
  "#C5DCE0",
  "#ADCCD3",
  "#83AFBC",
  "#5B92A2",
  "#2F778B",
  "#015D75",
  "#DCE7E8",
  "#C2DAE0",
  "#A9C9D7",
  "#85B0C4",
  "#5389A1",
  "#22657F",
  "#01455E",
  "#E0E8E7",
  "#C5D8DE",
  "#B3C9D3",
  "#97B4C3",
  "#6A8EA1",
  "#43718B",
  "#215772",
  "#CED9DD",
  "#B2C7D3",
  "#8BA7BB",
  "#6A8AA4",
  "#506B84",
  "#25476A",
  "#E1E6E6",
  "#CBD8E1",
  "#B2C8D8",
  "#8EA9C2",
  "#6B8CA9",
  "#4C6B8A",
  "#284A70",
  "#CBD5DB",
  "#BBC7D2",
  "#99A7B8",
  "#6C7F9A",
  "#516582",
  "#3B496D",
  "#D6D9DE",
  "#BDC3CD",
  "#99A0B2",
  "#757C91",
  "#5D657B",
  "#3B3C5A",
  "#DAD6DB",
  "#C5C0C9",
  "#A29BAA",
  "#7E778E",
  "#645E77",
  "#3E385A",
  "#E0DADF",
  "#D1C6D2",
  "#B0A3B6",
  "#7A6B85",
  "#675A75",
  "#443757",
  "#EBD1DB",
  "#E3C0CF",
  "#CB9AAD",
  "#B87E93",
  "#92576F",
  "#7C3655",
  "#EDD5DD",
  "#E8C0CF",
  "#D899B1",
  "#C47B95",
  "#A2566F",
  "#854158",
  "#F1D3DA",
  "#EFC0CB",
  "#E392A1",
  "#D47C8C",
  "#B04B63",
  "#99324E",
  "#F1D2D7",
  "#F0BCC9",
  "#EB92A3",
  "#DD7788",
  "#BD4C5F",
  "#A53A4E",
  "#F2D5D7",
  "#F0C1C6",
  "#ED939D",
  "#D66972",
  "#BB4B51",
  "#9D373C",
  "#F1C6C4",
  "#F0B3B2",
  "#ED9190",
  "#D76C6E",
  "#B74E4F",
  "#A43834",
  "#F2CCC5",
  "#F0AFA8",
  "#EE9489",
  "#D9766C",
  "#B24743",
  "#A13B34",
  "#F2D1C3",
  "#F2B8A7",
  "#E79580",
  "#D87B6A",
  "#C76356",
  "#B85444",
  "#F0D1C3",
  "#F3C1AB",
  "#E49780",
  "#DD7861",
  "#C65F47",
  "#B44B34",
  "#F3D0BD",
  "#F2BDA2",
  "#E2946F",
  "#D67C56",
  "#C4633E",
  "#B1533C",
  "#F3D3BF",
  "#F3C1A3",
  "#E89D6F",
  "#D57E52",
  "#C56639",
  "#BB613E",
  "#F4D3B3",
  "#F4C69F",
  "#F2AC78",
  "#E6955F",
  "#CB7841",
  "#C36F3E",
  "#F2E3CE",
  "#F4D4AF",
  "#F5C894",
  "#EFB57A",
  "#E69F5F",
  "#D88B4D",
  "#D28240",
  "#F3E3CA",
  "#F4D9B1",
  "#F5CF9B",
  "#EFB97B",
  "#EAAA62",
  "#DF984E",
  "#D28233",
  "#F3E2C9",
  "#F5D6A9",
  "#F6CD8E",
  "#F4BF77",
  "#EBAD5E",
  "#DF9938",
  "#D88F32",
  "#F3E6CE",
  "#F5DEAF",
  "#F7D391",
  "#FBCB78",
  "#F7BE5B",
  "#F2AF46",
  "#E39A33",
  "#F4E3BC",
  "#F5E0B1",
  "#F6DDA3",
  "#F6C973",
  "#F1BA55",
  "#EAAE47",
  "#D69835",
  "#F5E5BC",
  "#F4E1AE",
  "#F5D68F",
  "#EEC25F",
  "#E1B047",
  "#D6A02B",
  "#C48919",
  "#F3E8C2",
  "#F5E1AC",
  "#F7D78A",
  "#EAC365",
  "#DBB04A",
  "#D1A436",
  "#C49832",
  "#F3EAC6",
  "#EEE3B2",
  "#E6D88E",
  "#D9C661",
  "#C4B146",
  "#AC9825",
  "#9C8B1F",
  "#E9E5B3",
  "#DAD790",
  "#C4C476",
  "#B4B05A",
  "#989746",
  "#847E35",
  "#DCE1B8",
  "#C5CD8F",
  "#AFB96A",
  "#97A554",
  "#7A8833",
  "#6C7B30",
  "#D3DFC3",
  "#BDD0AB",
  "#9DB682",
  "#85A16A",
  "#648149",
  "#58713F",
  "#D7E3CA",
  "#C0D2AD",
  "#99C285",
  "#7FAC6E",
  "#4F854A",
  "#2F5F3A",
  "#CCE2CA",
  "#AED2B0",
  "#8EC298",
  "#68A678",
  "#498555",
  "#245E36",
  "#D1E3D2",
  "#B7D7BF",
  "#8AC1A1",
  "#57AA80",
  "#348A5D",
  "#016844",
  "#D7EBE2",
  "#C0E3DA",
  "#A1D4C8",
  "#70BAA7",
  "#53A38F",
  "#368976",
  "#016C4F",
  "#C1E6DF",
  "#A1D5CB",
  "#75B9AE",
  "#61A89D",
  "#3B8C80",
  "#016D60",
  "#C2E5E5",
  "#A7DCDC",
  "#6EC2C4",
  "#3AA9AE",
  "#01858B",
  "#017478",
  "#C2E0E3",
  "#A6D0D6",
  "#7DC1CB",
  "#4DA6B2",
  "#08808E",
  "#01717E",
  "#C6E3E8",
  "#A6D4DE",
  "#71B8C7",
  "#34A3B6",
  "#018498",
  "#016E85",
  "#D3E7E9",
  "#B4E0E7",
  "#8FD0DD",
  "#56B5CA",
  "#01A0B8",
  "#01819E",
  "#016081",
  "#B7DFE8",
  "#A2D5E7",
  "#5DB3D4",
  "#289EC4",
  "#017CA7",
  "#015D87",
  "#D6E4E7",
  "#C3DFE8",
  "#B0D6E6",
  "#7DB5D3",
  "#5A9EC0",
  "#2377A2",
  "#094C73",
  "#CCDBE5",
  "#B8CDDD",
  "#97B3D0",
  "#7498BE",
  "#4E739F",
  "#164576",
  "#D8DDE6",
  "#C7D1E2",
  "#A7B2D4",
  "#8B98C4",
  "#6572A5",
  "#3E4371",
  "#DFD9E4",
  "#D1CBDF",
  "#BDB4D4",
  "#968DB8",
  "#716998",
  "#4D426E",
  "#DFDCE5",
  "#D2C8DD",
  "#C0AFD0",
  "#A18AB7",
  "#7E6596",
  "#624977",
  "#E5DBE5",
  "#DAC7DA",
  "#C2A4C2",
  "#A785A7",
  "#7C5A7E",
  "#5D395F",
  "#B54D7F",
  "#953D68",
  "#92345B",
  "#AC4362",
  "#CC617F",
  "#C84F68",
  "#A42E41",
  "#AB3C51",
  "#A82E33",
  "#BF2D32",
  "#C33A36",
  "#AD2C34",
  "#F3D1C8",
  "#C04D35",
  "#C35530",
  "#D7552A",
  "#E16F3E",
  "#E47237",
  "#EC8430",
  "#F4A045",
  "#EB882C",
  "#F7DDA1",
  "#FAD97A",
  "#FDCC4E",
  "#FFC723",
  "#F8AC1D",
  "#FDB702",
  "#FFC801",
  "#F7E594",
  "#FED95D",
  "#FED340",
  "#FECB01",
  "#EDD26F",
  "#DDB835",
  "#CBA901",
  "#C6B836",
  "#B2C216",
  "#9ABA25",
  "#3F8A24",
  "#358C3F",
  "#238652",
  "#017244",
  "#D4E7C3",
  "#87DCCE",
  "#019187",
  "#019196",
  "#017680",
  "#01B0BB",
  "#7FC3E1",
  "#0192C6",
  "#016EA7",
  "#015F97",
  "#015086",
  "#225288",
  "#C2CBE0",
  "#3C4C80",
  "#CAB2D2",
  "#795484",
  "#665385",
  "#514C7E",
  "#019D6E",
  "#3B373C",
  "#353337",
  "#323132",
  "#31363A",
  "#323639",
  "#F2ECE6",
  "#EEE9E0",
  "#EFE8DD",
  "#E9EBE7",
  "#EDEAE0",
  "#E8E3D9",
  "#E5DFD2",
  "#EFE8DB",
  "#ECE5D8",
  "#ACA79E",
  "#908A83",
  "#DFD9D2",
  "#B9B2A9",
  "#ABA39A",
  "#6F6459",
  "#564537",
  "#E3DED7",
  "#D1CBC1",
  "#BFB6AA",
  "#ADA295",
  "#74685A",
  "#5C4D3C",
  "#E3DDD3",
  "#B1A290",
  "#8A7A6A",
  "#716354",
  "#564536",
  "#E6DFD3",
  "#817A6E",
  "#54504A",
  "#E2E0D6",
  "#CFCABD",
  "#BFB6A7",
  "#AFA696",
  "#867E70",
  "#645A4B",
  "#554C3E",
  "#C8CBC4",
  "#B2B5AF",
  "#A3A7A0",
  "#63655F",
  "#484C49",
  "#DEDFDC",
  "#CBCCC9",
  "#434341",
  "#DCDEDC",
  "#C6CACA",
  "#B0B5B5",
  "#A0A5A7",
  "#7F8486",
  "#616669",
  "#44484D",
  "#E2DEDB",
  "#CFC9C8",
  "#BCB6B6",
  "#ADA5A5",
  "#837D7F",
  "#676064",
  "#443E40",
  "#F3EEE7",
  "#EDE6DB",
  "#F4EFE5",
  "#F4EFE4",
  "#F7EFE3",
  "#F7EFDE",
  "#F8EEDB",
  "#AC9A8A",
  "#A18D7D",
  "#A49689",
  "#9E9284",
  "#665D57",
  "#C4B7A5",
  "#B3A491",
  "#9C8A79",
  "#826F5E",
  "#5B4B44",
  "#CDBFB0",
  "#C5B6A4",
  "#A79582",
  "#827466",
  "#6E5F53",
  "#E0D6C8",
  "#DBCEBD",
  "#C9B29C",
  "#AF9781",
  "#6A5143",
  "#AD947C",
  "#9F8267",
  "#7C5C43",
  "#CABAA8",
  "#8A7362",
  "#DFD2BF",
  "#D0BFAA",
  "#C4B49C",
  "#D4C5AD",
  "#C4B39C",
  "#DCD1BF",
  "#CFC0AB",
  "#C0AF97",
  "#B7A48B",
  "#A18E77",
  "#CBB49A",
  "#E3D2B8",
  "#C0A588",
  "#C1A98A",
  "#B09879",
  "#D8CFBE",
  "#CBC0AD",
  "#BCB099",
  "#AC9D83",
  "#63523D",
  "#B1A38E",
  "#CBBFAD",
  "#AD9C85",
  "#907D66",
  "#F0ECE2",
  "#E7DBCC",
  "#E7D7C6",
  "#ECE1D1",
  "#E2D3BF",
  "#F4E8D2",
  "#F4E9D6",
  "#F3E9D7",
  "#F2E5CF",
  "#F4DEC3",
  "#F5EACC",
  "#F6F0E2",
  "#EEE8D7",
  "#E8DFCA",
  "#DBD0BB",
  "#F3EEE3",
  "#E2DACA",
  "#DCCFBA",
  "#DFD9CF",
  "#EDE1CE",
  "#E7D7C2",
  "#E9D9C0",
  "#E7D8BE",
  "#E0D1B8",
  "#533640",
  "#72353D",
  "#81585B",
  "#573E3E",
  "#803532",
  "#7C3239",
  "#6E3637",
  "#692B2B",
  "#813235",
  "#9F4442",
  "#A42E37",
  "#B8473D",
  "#7C453D",
  "#753531",
  "#703229",
  "#6E423E",
  "#5D3736",
  "#E2D3C4",
  "#924E3C",
  "#93402F",
  "#903934",
  "#A0B3BC",
  "#3E5063",
  "#8095A0",
  "#596E79",
  "#35454E",
  "#6591A8",
  "#416D83",
  "#87AAB9",
  "#5B8D9F",
  "#3E758A",
  "#7C9AA0",
  "#679199",
  "#9CB0B3",
  "#577C88",
  "#3E4B54",
  "#A0AEAF",
  "#376167",
  "#314D58",
  "#666D69",
  "#273E3E",
  "#606E74",
  "#3D484C",
  "#E6E1D9",
  "#E7E1D7",
  "#DED8CF",
  "#786E70",
  "#392B2D",
  "#DFDAD1",
  "#D6CEC3",
  "#ADA090",
  "#AA9E95",
  "#E5E2DA",
  "#C0B9A9",
  "#AEA594",
  "#A7A094",
  "#C6C0B6",
  "#A0998F",
  "#57534C",
  "#DAD9D4",
  "#D6D3CC",
  "#D0CEC9",
  "#C2C0BA",
  "#AAA9A4",
  "#CCCCC5",
  "#ABB0AC",
  "#D1D2CB",
  "#CECEC6",
  "#A0A09A",
  "#DEE0DE",
  "#C5C8C4",
  "#A5A9A8",
  "#969A96",
  "#D3D5D3",
  "#C9CCCD",
  "#B8BCBB",
  "#90979B",
  "#656D73",
  "#DCDDD8",
  "#CAC9C6",
  "#959491",
  "#949392",
  "#D0CEC8",
  "#C3C1BC",
  "#F2E0C4",
  "#EABA8A",
  "#EDDBBD",
  "#D9AD7F",
  "#C09972",
  "#F8E4C2",
  "#EABF86",
  "#F1DFC1",
  "#EDD6B1",
  "#E5C28B",
  "#F8DDB7",
  "#E7C7A0",
  "#E1CDAE",
  "#D2BB9D",
  "#C3AA8C",
  "#E3C9A1",
  "#DCBC8E",
  "#CBA97E",
  "#CAAD87",
  "#BD9C77",
  "#DCC6A6",
  "#CCB18B",
  "#DBC8A2",
  "#BA9A67",
  "#8F6C3E",
  "#AC6B53",
  "#B0785C",
  "#A85E39",
  "#D5B59B",
  "#976B53",
  "#C67B57",
  "#B16A37",
  "#A56C4A",
  "#E6D0BD",
  "#DFC8B5",
  "#CCB299",
  "#BFA287",
  "#AA866E",
  "#DBC5A7",
  "#D2B18F",
  "#BB8D6B",
  "#D8C4AE",
  "#C7A485",
  "#EDD1B1",
  "#ECD3B3",
  "#DDC6AB",
  "#B7987B",
  "#AD896A",
  "#9D986F",
  "#B9B292",
  "#A29F80",
  "#827C5A",
  "#4D5346",
  "#A69474",
  "#C8BD98",
  "#B3A479",
  "#857C5D",
  "#635936",
  "#B1A584",
  "#8D8168",
  "#CDC4AE",
  "#A49B82",
  "#7D745E",
  "#AAAD9C",
  "#8EA486",
  "#868578",
  "#99907E",
  "#5A5243",
  "#A19C8F",
  "#BDC0A0",
  "#9A9883",
  "#44493D",
  "#424C44",
  "#F7F7F1",
  "#F0EBE0",
  "#AE8087",
  "#A87376",
  "#BA7176",
  "#C37F7A",
  "#BF796E",
  "#B57466",
  "#F2B88C",
  "#F5C78E",
  "#CC896C",
  "#DBA480",
  "#E3AB7B",
  "#E8B87F",
  "#EEB76B",
  "#FBD187",
  "#FBE4B3",
  "#FDDFA0",
  "#FEDF94",
  "#FBD682",
  "#FBD073",
  "#F4C454",
  "#F6D58F",
  "#F1CD7B",
  "#E1BD8E",
  "#CBA576",
  "#BA9C75",
  "#D5B176",
  "#DCC797",
  "#BEA775",
  "#C4B47D",
  "#CEBC55",
  "#D2D083",
  "#9FAC5C",
  "#ABCA99",
  "#A9C095",
  "#78B185",
  "#9FCDB1",
  "#BBB98A",
  "#9BA373",
  "#8FA277",
  "#75946B",
  "#7D9B89",
  "#81A595",
  "#89C6B7",
  "#8AC5BA",
  "#92D0D0",
  "#97CBD2",
  "#8BC4D1",
  "#73C0D2",
  "#89C6DF",
  "#94B2A6",
  "#A3C0BD",
  "#90BDBD",
  "#9FC5CC",
  "#C7D8DB",
  "#AFC7CD",
  "#9FBBC3",
  "#88ABB4",
  "#68909D",
  "#427584",
  "#175A6C",
  "#9BBFC9",
  "#6F9DB3",
  "#9BC8DE",
  "#7C9AB5",
  "#6487B0",
  "#BBC5DE",
  "#AFA5C7",
  "#B3A1C6",
  "#937496",
  "#83A2B4",
  "#7B99B0",
  "#8595AA",
  "#8990A3",
  "#908A9B",
  "#9A8CA2",
  "#9B7E8B",
  "#A38887",
  "#A08882",
  "#A2877D",
  "#A8857A",
  "#AE8E7E",
  "#A58C7B",
  "#9C8373",
  "#A08E7E",
  "#D5C7BA",
  "#C6B5A7",
  "#B9A796",
  "#A58F7B",
  "#917864",
  "#785F4C",
  "#604C3D",
  "#A3846C",
  "#A88E76",
  "#DCC7B3",
  "#D2B79E",
  "#C5A88D",
  "#B59778",
  "#89674A",
  "#725237",
  "#765138",
  "#DCC7AD",
  "#CFB597",
  "#C1A485",
  "#B99974",
  "#A78361",
  "#946E48",
  "#7B5838",
  "#A78C71",
  "#DFD3C3",
  "#C0AD96",
  "#AF987F",
  "#A08568",
  "#8F7659",
  "#695239",
  "#AB9579",
  "#A4947E",
  "#B9A47E",
  "#DDD0B6",
  "#CDBB9C",
  "#C3B090",
  "#B19F80",
  "#9F8E71",
  "#877459",
  "#665439",
  "#9E9985",
  "#989A82",
  "#909886",
  "#969C92",
  "#8D9E97",
  "#8B9FA0",
  "#80969D",
  "#CBD4D4",
  "#B6C3C4",
  "#A6B2B5",
  "#90A0A6",
  "#6F848C",
  "#204652",
  "#C9D9E0",
  "#B7C9D1",
  "#9EB4C0",
  "#708D9E",
  "#4E7287",
  "#32586E",
  "#899CAA",
  "#979FA5",
  "#949194",
  "#989192",
  "#8F8A91",
  "#9D9093",
  "#9D8D8E",
  "#9F9291",
  "#9E9089",
  "#959BA0",
  "#939899",
  "#92948D",
  "#D3CEC4",
  "#DCD8D0",
  "#9E9793",
  "#A09287",
  "#9E9991",
  "#958D7F",
  "#C8BCAB",
  "#A0907F",
  "#393437",
  "#2B4360",
  "#234058",
  "#283849",
  "#2B3441",
  "#E8DECD",
  "#4B3029",
  "#4C3D31",
  "#454B40",
  "#2E5464",
  "#C29871",
  "#CEC4B8",
  "#ebe0c3",
  "#3e3230",
  "#cec6b6",
  "#85867f",
  "#153b2f",
  "#b6aa9d",
  "#e5e5e5",
  "#f7f5e6",
  "#446964",
  "#faf6ed",
  "#412a1c",
  "#5a331c",
  "#cbc2b0",
  "#ada394",
  "#f2f7f7",
  "#dfdccb",
  "#4F4842",
  "#c1b899",
  "#30332d",
  "#46403d",
  "#ada297",
  "#fcfdff",
  "#4a4f52",
  "#a39785",
  "#6d6c65",
  "#ede7d2",
  "#82735e",
  "#abb4ab",
  "#444542",
  "#616258",
  "#6b7062",
  "#6d3e37",
  "#5f5349",
  "#ffffff",
  "#64747d",
  "#3f5e73",
  "#586162",
  "#c9c0ab",
  "#73796c",
  "#a89885",
  "#333d46",
  "#49453c",
  "#818582",
  "#928e82",
  "#252a2a",
  "#725e4d",
  "#5b5e61",
  "#c5c2ba",
  "#a4a490",
  "#a39f8c",
  "#b2b2ab",
  "#38556b",
  "#673e3c",
  "#cac5b9",
  "#c3c0ab",
  "#cfcece",
  "#727d82",
  "#9c907d",
  "#7a7362",
  "#79736e",
  "#f8f4e9",
  "#65182c",
  "#452a19",
  "#acb297",
  "#7d8284",
  "#13233a",
  "#151312",
  "#ba1f26",
  "#e6e9ee",
  "#19221f",
  "#e9ebee",
  "#b4b2a9",
  "#483c37",
  "#DCB6B5",
  "#D9987C",
  "#EDD0B6",
  "#E4C495",
  "#A58258",
  "#EECF9E",
  "#BEC3BB",
  "#6d6b58",
  "#405840",
  "#788b81",
  "#9EC6C6",
  "#B8CDDD",
  "#4C6B8A",
  "#6E543C",
  "#C0A98B",
  "#E2E0D6",
  "#B2B5AF",
  "#988F7B",
  "#74685A",
  "#727C7F",
  "#484C49",
  "#BEB5A9",
  "#596368",
  "#7E6F59",
  "#E8D9BD",
  "#DBD0B9",
  "#C1AE91",
  "#6A4238",
  "#7B3728",
  "#DEDDD1",
  "#DEDDD1",
  "#E2E0D6",
  "#7B3728",
  "#6A4238",
  "#DCB6B5",
  "#D9987C",
  "#EDD0B6",
  "#A58258",
  "#EECF9E",
  "#E4C495",
  "#E8D9BD",
  "#C1AE91",
  "#A39B7E",
  "#6d6b58",
  "#405840",
  "#9EC6C6",
  "#B8CDDD",
  "#4C6B8A",
  "#74685A",
  "#C0A98B",
  "#9C8A79",
  "#7E6F59",
  "#BEB5A9",
  "#DBD0B9",
  "#6E543C",
  "#988F7B",
  "#BEC3BB",
  "#B2B5AF",
  "#788b81",
  "#596368",
  "#727C7F",
  "#484C49",
  "#EECF9E",
  "#B8CDDD",
  "#E8D9BD",
  "#C0A98B",
  "#A58258",
  "#EDD0B6",
  "#D9987C",
  "#6A4238",
  "#DCB6B5",
  "#9EC6C6",
  "#788b81",
  "#405840",
  "#9C8A79",
  "#E2E0D6",
  "#6E543C",
  "#727C7F",
  "#596368",
  "#484C49",
  "#BEC3BB",
  "#DEDDD1",
  "#6A4238",
  "#4E3132",
  "#D9987C",
  "#E6DDD5",
  "#BA8C64",
  "#E4C495",
  "#E8D9BD",
  "#A58258",
  "#A57955",
  "#727C7F",
  "#596368",
  "#ADA8A5",
  "#7F817E",
  "#616669",
  "#4E5147",
  "#788b81",
  "#DEDDD1",
  "#BEC3BB",
  "#E2E0D6",
  "#B2B5AF",
  "#7F817E",
  "#C1AE91",
  "#2F3D4C",
  "#78736E",
  "#4F4842",
  "#564536",
  "#4C6B8A",
  "#74685A",
  "#9C8A79",
  "#DBD0B9",
  "#7B3728",
  "#A39B7E",
  "#988F7B",
  "#6d6b58",
  "#EECF9E",
  "#B8CDDD",
  "#DCB6B5",
  "#9EC6C6",
  "#EECF9E",
  "#D9987C",
  "#E8D9BD",
  "#C0A98B",
  "#BA8C64",
  "#EDD0B6",
  "#C1AE91",
  "#7E6F59",
  "#9EC6C6",
  "#E6DDD5",
  "#B8CDDD",
  "#DEDDD1",
  "#DCB6B5",
  "#BEC3BB",
  "#405840",
  "#4E5147",
  "#4C6B8A",
  "#2F3D4C",
  "#E4C495",
  "#A58258",
  "#6E543C",
  "#4E3132",
  "#7B3728",
  "#6A4238",
  "#A57955",
  "#7F817E",
  "#564536",
  "#6E543C",
  "#D9987C",
  "#DCB6B5",
  "#6A4238",
  "#E2E0D6",
  "#BEC3BB",
  "#BEB5A9",
  "#B2B5AF",
  "#484C49",
  "#7B3728",
  "#9EC6C6",
  "#EECF9E",
  "#727C7F",
  "#596368",
  "#A39B7E",
  "#E8D9BD",
  "#C0A98B",
  "#B8CDDD",
  "#DEDDD1",
  "#405840",
  "#4C6B8A",
  "#C1AE91",
  "#74685A",
  "#9C8A79",
  "#E4C495",
  "#EDD0B6",
  "#DBD0B9",
  "#646753",
  "#68887b",
  "#B7AB9F",
  "#674721",
  "#d5c3ad",
  "#5c5753",
  "#423f40",
  "#f0ece3",
  "#dfdcd5",
  "#cac7c0",
  "#acaa9d",
  "#76716d",
  "#666c68",
  "#b0a08d",
  "#d1caba",
  "#f2f3ee",
  "#a3a59f",
  "#2f374a",
  "#5f4c42",
  "#191815",
  "#948d7d",
  "#74766b",
  "#3e3a37",
  "#fffefa",
  "#5f5345",
  "#e1ddc0",
  "#e0d1b4",
  "#c4bea2",
  "#b0ae9a",
  "#514d41",
  "#525658",
  "#fffef9",
  "#c8bca6",
  "#b4a49f",
  "#c2b89c",
  "#f0f7fa",
  "#2d4647",
  "#DBDBDB",
  "#161513",
  "#E7E8E2",
  "#ACA298",
  "#C3C2BD",
  "#8E8E8C",
  "#29303A",
  "#19363D",
  "#7D8E98",
  "#EDEDED",
  "#817765",
  "#0C0006",
  "#0C0006",
  "#A1A1A1",
  "#5B8095",
  "#3F3E41",
  "#554541",
  "#5D5E5B",
  "#7F7E7A",
  "#6A6965",
  "#4A545C",
  "#F0ECDB",
  "#ABA796",
  "#F9FAF5",
  "#CCB9B1",
  "#C2B89C",
  "#040707",
  "#332A22",
  "#B4A49F",
  "#2E2822",
  "#A6AEAD",
  "#CEC8B4",
  "#524535",
  "#E4E8CF",
  "#0F3F67",
  "#3D6C80",
  "#857F69",
  "#452727",
  "#464A49",
  "#9AA3AA",
  "#6D2B2D",
  "#4B392B",
  "#3C382F",
  "#A12034",
  "#365C45",
  "#37624F",
  "#38483E",
  "#5C7C6D",
  "#282B30",
  "#5C4B39",
  "#FDFEF9",
  "#D4D0C7",
  "#629881",
  "#004961",
  "#DCE0DF",
  "#A79C7E",
  "#3F776E",
  "#A64F3B",
  "#778083",
  "#D1C8B7",
  "#000000",
  "#716E69",
  "#48382C",
  "#C7BFA7",
  "#08402E",
  "#646263",
  "#969897",
  "#978B7E",
  "#FFFFFF",
  "#F4E8D6",
  "#9FA6AA",
  "#DFDCD3",
  "#65615D",
  "#53524F",
  "#A39584",
  "#81837B",
  "#85514D",
  "#F2F1EC",
  "#e5d8bd",
  "#695e50",
  "#38211d",
  "#302f30",
  "#434f51",
  "#bec0c0",
  "#e7e8e9",
  "#a99d8a",
  "#4F5455",
  "#C9BFB0",
  "#788387",
  "#7c7463",
  "#A2A298",
  "#B2AFAD",
  "#B6AB9F",
  "#4b4b4d",
  "#06060a",
  "#66211c",
  "#373229",
  "#f0dfb7",
  "#a49f90",
  "#a49f90",
  "#faf8f4",
  "#2f2a22",
  "#6d6158",
  "#385546",
  "#c3b9a3",
  "#06060a",
  "#4c4036",
  "#f1edd6",
  "#4f2e26",
  "#c3b9a3",
  "#a4a7a6",
  "#b2b8b4",
  "#665c52",
  "#fff9f0",
  "#F5F4EE",
  "#EAEBE7",
  "#DED6C6",
  "#E3D3C8",
  "#D4CBB4",
  "#C8AF99",
  "#B79E86",
  "#242424",
  "#8E7C6C",
  "#B09B8B",
  "#9FA193",
  "#F0E5DC",
  "#9E9286",
  "#9E9686",
  "#9F684F",
  "#F3E9D2",
  "#6E4B50",
  "#F7EBD4",
  "#4C443E",
  "#858281",
  "#D2CBBB",
  "#707377",
  "#192A21",
  "#EFEFEF",
  "#939698",
  "#49544A",
  "#A89D8D",
  "#DAD1C7",
  "#55413E",
  "#F1E5D1",
  "#5E6C68",
  "#686261",
  "#D9CAB7",
  "#E0D7CA",
  "#EBEBEB",
  "#3B393A",
  "#554A47",
  "#1B2A41",
  "#A69790",
  "#959288",
  "#59626E",
  "#A0A09D",
  "#B7B4B3",
  "#CACED2",
  "#AFA797",
  "#4D4442",
  "#5C5653",
  "#CBBFB8",
  "#F3ECDF",
  "#BAAA9E",
  "#764A4A",
  "#A8ADB3",
  "#E9E4DD",
  "#F0F0EE",
  "#E7DFC6",
  "#696561",
  "#605D59",
  "#515154",
  "#C8B9A8",
  "#BCADA0",
  "#5F2D2C",
  "#3B4B46",
  "#F7F7F7",
  "#F6F5E4",
  "#DAD3C5",
  "#F1EDEC",
  "#F8EDD8",
  "#C3C3BE",
  "#DFCEC6",
  "#B8B3AC",
  "#D8C7A2",
  "#CEAE90",
  "#C8B8A1",
  "#BBBCB2",
  "#DBDED6",
  "#737373",
  "#928C83",
  "#E0DDD4",
  "#ACACAC",
  "#BBB3AA",
  "#BBB8AD",
  "#998F86",
  "#D6DADD",
  "#E7F0F2",
  "#DFE1D5",
  "#CDC8BC",
  "#E1DFD4",
  "#CABA9F",
  "#ACA291",
  "#D4C298",
  "#9C8462",
  "#A18B72",
  "#C8CAC9",
  "#D4A97D",
  "#D7B588",
  "#ECE7BC",
  "#F3F3E3",
  "#A59C88",
  "#D7B385",
  "#A59A7C",
  "#C6AF97",
  "#F4F4EB",
  "#E3C59B",
  "#E5D3B5",
  "#E1C39C",
  "#CEC4AE",
  "#D4BEAA",
  "#514A46",
  "#edf5f4",
  "#941318",
  "#231f20",
  "#4c191c",
  "#4c4d4f",
  "#636466",
  "#a9a089",
  "#62443d",
  "#ad6c32",
  "#004829",
  "#003663",
  "#f7edc9",
  "#7f6757",
  "#dedbc4",
  "#5d9a8b",
  "#be1228",
  "#bdbdb8",
  "#376b7c",
  "#d6bd9e",
  "#eeeeec",
  "#A89D8E",
  "#aea89c",
  "#d0cbc5",
  "#ffffff",
  "#2f3437",
  "#3d3429",
  "#b0a282",
  "#586151",
  "#593b26",
  "#47393d",
  "#371516",
  "#3a4545",
  "#8b8041",
  "#d5d8d7",
  "#bfc4c5",
  "#a9afb2",
  "#999fa3",
  "#838b91",
  "#6d747a",
  "#575c62",
  "#d4d4cd",
  "#c9cbc6",
  "#bbbcb6",
  "#a8aaa4",
  "#9c9f99",
  "#92958f",
  "#717572",
  "#e0dfdc",
  "#d2d1cd",
  "#c7c6c2",
  "#b9b8b5",
  "#9f9f9d",
  "#7b7a78",
  "#3c3d3d",
  "#ddddd9",
  "#cdccc9",
  "#a8a7a3",
  "#92928f",
  "#81807e",
  "#6f6f6e",
  "#5e5e5d",
  "#d0cfc9",
  "#c4c3bd",
  "#bbbab5",
  "#abaca6",
  "#969794",
  "#7b7c7a",
  "#575957",
  "#f2f0e7",
  "#bfbab0",
  "#afaba1",
  "#a19e97",
  "#949089",
  "#7e7a74",
  "#5c5752",
  "#dedbd2",
  "#c7c2b7",
  "#b2ada2",
  "#9a9387",
  "#8b8376",
  "#746e64",
  "#635f59",
  "#d1c9bc",
  "#c2b9ac",
  "#b1a89c",
  "#a19689",
  "#8e8274",
  "#7d7265",
  "#64584a",
  "#f2f2ee",
  "#e3e4e2",
  "#dadbdb",
  "#acadae",
  "#848585",
  "#5c5d5d",
  "#414040",
  "#edeae7",
  "#e6e3df",
  "#d4cfca",
  "#b9b4b1",
  "#918e8c",
  "#6f6a68",
  "#4b4441",
  "#e1dedd",
  "#d8d3d4",
  "#b8b4b6",
  "#a6a1a3",
  "#908b8e",
  "#69656a",
  "#49454b",
  "#dddada",
  "#d2cecc",
  "#c5bebc",
  "#b3aaaa",
  "#8b8283",
  "#655d5e",
  "#50484a",
  "#e5e2e0",
  "#d4d0ce",
  "#c4bfbc",
  "#b5adaa",
  "#8d847f",
  "#665e59",
  "#4f443f",
  "#eeede5",
  "#e1ded9",
  "#ccc8c1",
  "#b8b1aa",
  "#8c857d",
  "#7c736c",
  "#61574f",
  "#e8e6e1",
  "#d0cbc3",
  "#beb8ae",
  "#afaaa1",
  "#99938d",
  "#827c77",
  "#564d4b",
  "#e6e0d4",
  "#d1c9bd",
  "#b4aca3",
  "#a2978b",
  "#8d8478",
  "#766f67",
  "#615c58",
  "#e1e1dc",
  "#d3d4d0",
  "#c6c8c5",
  "#b9b8b5",
  "#8e908d",
  "#6b6a65",
  "#4e4f48",
  "#eae8e4",
  "#d7d6d2",
  "#bdbeba",
  "#a7a9a5",
  "#8a8b87",
  "#6f716e",
  "#585a5c",
  "#eae9e7",
  "#d2d6d6",
  "#b1b6b8",
  "#9aa0a5",
  "#6f7477",
  "#5c5e61",
  "#454443",
  "#e1e5e3",
  "#dce2e2",
  "#d2d9db",
  "#b8bfc2",
  "#8e9598",
  "#6e7579",
  "#434b4f",
  "#e7e7e6",
  "#dadbdd",
  "#c0c2c4",
  "#adb0b5",
  "#828388",
  "#575960",
  "#404149",
  "#ebe9e7",
  "#e6e3e4",
  "#e1ddde",
  "#c0b2b2",
  "#9c8e8e",
  "#746665",
  "#554747",
  "#f2ebe2",
  "#ede4dc",
  "#e6d7ce",
  "#cdb8b3",
  "#a59491",
  "#826f6b",
  "#5f4a47",
  "#eaded9",
  "#e6d5cf",
  "#ddc8c1",
  "#d2bbb3",
  "#b59b94",
  "#8f746c",
  "#674a41",
  "#ecdfda",
  "#d9cac5",
  "#c9bcb7",
  "#b8a9a3",
  "#8e7d78",
  "#786560",
  "#60504b",
  "#ded6d0",
  "#d5cbc6",
  "#b9b0a8",
  "#aa9f97",
  "#a1928b",
  "#80726b",
  "#5b4c44",
  "#ebe2d8",
  "#d7cbc0",
  "#c8bab1",
  "#aca199",
  "#93857c",
  "#82746c",
  "#645851",
  "#f2eee5",
  "#e3d8cc",
  "#cfc1b5",
  "#b6a393",
  "#a7978a",
  "#857567",
  "#65574c",
  "#e9e3dc",
  "#d2c7b9",
  "#c0b1a2",
  "#ab9a8b",
  "#8d7b6c",
  "#766759",
  "#5f5248",
  "#e7e0d7",
  "#d2c8be",
  "#bdb6ae",
  "#a3968c",
  "#9a8e83",
  "#746a5e",
  "#5d5043",
  "#e8e3d6",
  "#dad0c2",
  "#cabfb2",
  "#b7ac9e",
  "#9f9484",
  "#827566",
  "#594e40",
  "#e9e3d6",
  "#e2daca",
  "#dacfbf",
  "#d1c9bb",
  "#a89d8e",
  "#8b7d6b",
  "#5f5241",
  "#e7e9e7",
  "#dcd7cf",
  "#d2ccc3",
  "#b2aa9c",
  "#8c8475",
  "#7a6c5e",
  "#615544",
  "#e3d6bc",
  "#d7c7a7",
  "#c1b295",
  "#b4a284",
  "#a59171",
  "#927f63",
  "#766851",
  "#dfdbcd",
  "#d3cbb7",
  "#c1b8a2",
  "#afa78d",
  "#8f876b",
  "#7b6b53",
  "#5f563f",
  "#e7e6d6",
  "#d3d0bc",
  "#bbb8a5",
  "#a1a190",
  "#827e6e",
  "#776e5d",
  "#5c5644",
  "#e7e5dc",
  "#dbd8c9",
  "#cac8b6",
  "#aead96",
  "#928c7a",
  "#777162",
  "#676357",
  "#d4d3c2",
  "#c6c6b3",
  "#b5b7a3",
  "#9e9f87",
  "#928e74",
  "#78725d",
  "#6a6758",
  "#d0ccbc",
  "#c2c1b2",
  "#a8a897",
  "#969481",
  "#87836f",
  "#676455",
  "#5c594c",
  "#ceccbf",
  "#bfbbae",
  "#b0ab9b",
  "#999382",
  "#878170",
  "#716c5e",
  "#5f5a4d",
  "#e0e3d9",
  "#dbdcd2",
  "#c5c8bf",
  "#aaafa8",
  "#89928a",
  "#646c64",
  "#474e44",
  "#e4ece9",
  "#dfebea",
  "#d5e1e1",
  "#b4c7c9",
  "#8b9fa1",
  "#6a7e81",
  "#334448",
  "#d2e0df",
  "#c8d7d8",
  "#a4babd",
  "#8ca2a8",
  "#6d868b",
  "#5d7076",
  "#455257",
  "#e1e5e5",
  "#ccd3d3",
  "#adb7b8",
  "#93a0a2",
  "#7c8787",
  "#707b7d",
  "#585f60",
  "#d7dddd",
  "#cbd3d4",
  "#a8b4b8",
  "#92a2a9",
  "#67787e",
  "#525e63",
  "#464b4f",
  "#e4e9e8",
  "#dde3e4",
  "#d4dcdb",
  "#adb6ba",
  "#858f94",
  "#5e686d",
  "#3a484f",
  "#ced3d2",
  "#bcc1c1",
  "#aab1b3",
  "#919a9f",
  "#7d868a",
  "#666f73",
  "#445056",
  "#d0dce0",
  "#c1d0d8",
  "#b2c0c8",
  "#a1b1ba",
  "#8f9fa9",
  "#667884",
  "#515e69",
  "#eceded",
  "#e1e5eb",
  "#dadde3",
  "#bcc5cf",
  "#939fa9",
  "#6a7680",
  "#3f4c5a",
  "#e6e9ed",
  "#dfdac8",
  "#212424",
  "#212424",
  "#42372a",
  "#7c7d7c",
  "#c2bcae",
  "#6d6c61",
  "#dfdac8",
  "#004327",
  "#f1f1f1",
  "#42372a",
  "#d6d0c1",
  "#c2bcae",
  "#6d6c61",
  "#f1f1f1",
  "#9cb1bf",
  "#aca38b",
  "#513b36",
  "#8b9d89",
  "#a2a298",
  "#595c53",
  "#8f8d85",
  "#ada69a",
  "#255d79",
  "#3d4445",
  "#f5efe4",
  "#2c3c55",
  "#475662",
  "#a39382",
  "#7b2c06",
  "#646c6f",
  "#868683",
  "#d3cdbc",
  "#576c58",
  "#87a2a7",
  "#e3d4bb",
  "#ced0cb",
  "#838a91",
  "#968a76",
  "#969784",
  "#58554f",
  "#fff1cd",
  "#937d68",
  "#595c53",
  "#253739",
  "#f2f3ee",
  "#c6b9a0",
  "#425b65",
  "#677f86",
  "#738a8b",
  "#a1aeac",
  "#f0eae0",
  "#7d8681",
  "#ced0c6",
  "#bec6bf",
  "#47545d",
  "#3b4550",
  "#64707c",
  "#9fa5b3",
  "#a3adb2",
  "#aebbc0",
  "#bcc0bf",
  "#6a828c",
  "#bcc5d9",
  "#ccd0dd",
  "#71787f",
  "#919ea7",
  "#8092a3",
  "#657687",
  "#d4dae2",
  "#9eadbb",
  "#d4dcdb",
  "#cedde7",
  "#cfdbe0",
  "#a1b2bb",
  "#848982",
  "#bcc5b6",
  "#c4d0c6",
  "#2a4a6f",
  "#e3e6eb",
  "#d4dce3",
  "#adb4c4",
  "#828b9c",
  "#5c6576",
  "#404d62",
  "#e9e9ea",
  "#e2e1e2",
  "#dedfe2",
  "#b1b2be",
  "#8b8d98",
  "#656874",
  "#484b5a",
  "#f2ebea",
  "#ebdde1",
  "#e3c8d2",
  "#d7b3c0",
  "#c58ba1",
  "#a8647e",
  "#86455c",
  "#f1edeb",
  "#eee0e3",
  "#e4d0d5",
  "#d0aebb",
  "#b28692",
  "#9a6a79",
  "#6f4052",
  "#eae1e0",
  "#eadbe1",
  "#dac2ca",
  "#cbb7c0",
  "#a48b93",
  "#866c76",
  "#5d4450",
  "#efe7e4",
  "#e5d8d6",
  "#d6c5c2",
  "#d1c1c3",
  "#ac9b9c",
  "#877578",
  "#5b484b",
  "#f0eae7",
  "#f0dddf",
  "#e4c9ce",
  "#d5b6ba",
  "#aa8a8d",
  "#8e6c6f",
  "#624046",
  "#f2eeeb",
  "#f0dadd",
  "#d7b8bd",
  "#c9a1a9",
  "#ad7982",
  "#905c67",
  "#73424a",
  "#f3e6e7",
  "#ecced4",
  "#e3b9c2",
  "#d494a0",
  "#c47281",
  "#ad586c",
  "#9a3c55",
  "#f3ddd8",
  "#eec9ca",
  "#ebb3b4",
  "#dc9294",
  "#c67276",
  "#af545d",
  "#943e45",
  "#f0e0d7",
  "#f5e2dd",
  "#dfbeba",
  "#c59191",
  "#af7271",
  "#95555a",
  "#853e44",
  "#f2ede5",
  "#edd4d2",
  "#e5c7c6",
  "#d9b1b2",
  "#b78e8b",
  "#976a66",
  "#6e403e",
  "#f2e4dd",
  "#f2dcd8",
  "#e7cdca",
  "#dbbebc",
  "#b49997",
  "#90716e",
  "#694848",
  "#f3ebe7",
  "#f5dbd9",
  "#ddb9b6",
  "#c99d9b",
  "#ab7673",
  "#905959",
  "#7a4041",
  "#e9dad7",
  "#e4d2ce",
  "#dabcb7",
  "#cf9f9a",
  "#b87770",
  "#9e5b55",
  "#89423e",
  "#efe3dd",
  "#edd1cd",
  "#e8c1bb",
  "#e0a79f",
  "#ce7c74",
  "#b4635e",
  "#a53f3e",
  "#f2e0db",
  "#edcfc9",
  "#e9cac3",
  "#dfb1a8",
  "#ca887f",
  "#ae6056",
  "#a0413f",
  "#efded9",
  "#ead2cd",
  "#dcc0ba",
  "#caa6a1",
  "#af7e76",
  "#95625b",
  "#7d453e",
  "#edd8d0",
  "#e5d1cc",
  "#dfcac5",
  "#cfaea5",
  "#ac8880",
  "#8c5e55",
  "#6f4741",
  "#f0e7df",
  "#ebddd7",
  "#e3cbc2",
  "#c4a297",
  "#b6897d",
  "#996c61",
  "#715045",
  "#f0e3da",
  "#ecd6ce",
  "#e4cec6",
  "#d8b1a5",
  "#bc8675",
  "#9e6757",
  "#884f3e",
  "#f5e5dd",
  "#f2ded3",
  "#f4d1c4",
  "#efbdb0",
  "#d5917c",
  "#b06e5b",
  "#a2543e",
  "#f3e4de",
  "#f5ded9",
  "#f3d2c9",
  "#efbcb2",
  "#e19789",
  "#ca7363",
  "#a8483d",
  "#f2e2df",
  "#eed8d3",
  "#eacfc8",
  "#e4bcb3",
  "#cc9487",
  "#b16456",
  "#94493e",
  "#f2e6e0",
  "#f2ddd8",
  "#f3d3cb",
  "#dfbaab",
  "#bd8675",
  "#ae6f60",
  "#8f4f42",
  "#eedbd3",
  "#ead3c9",
  "#e9cac0",
  "#e2b5a4",
  "#b4715a",
  "#9d6454",
  "#924c3a",
  "#f0e4db",
  "#eddfd6",
  "#e4c9be",
  "#dbb19f",
  "#c08973",
  "#ab715a",
  "#945b41",
  "#f0dbce",
  "#edccb9",
  "#e7bca5",
  "#d5a084",
  "#be886a",
  "#a26949",
  "#965f43",
  "#f0dacc",
  "#eed5c7",
  "#e9c3ac",
  "#d6a284",
  "#c78d6a",
  "#a86e49",
  "#986544",
  "#ebdfd2",
  "#ebd5c7",
  "#e2c7b8",
  "#dbbbaa",
  "#bc947d",
  "#9a6e5c",
  "#805a48",
  "#f1e8e0",
  "#eadad2",
  "#d7bfb5",
  "#c4a79a",
  "#a4816f",
  "#8a6757",
  "#6e483a",
  "#f1e7d9",
  "#e9d9ce",
  "#e4d1c8",
  "#d1bbb0",
  "#a68f85",
  "#8b7265",
  "#64493e",
  "#eee6dc",
  "#ebdfd5",
  "#dbcbbf",
  "#bfa999",
  "#977d6f",
  "#6e554b",
  "#604b43",
  "#f0ebe4",
  "#ebe2d8",
  "#dfd4c9",
  "#beada4",
  "#978379",
  "#736157",
  "#604a3f",
  "#ebe3dc",
  "#e5ded5",
  "#d1c2b5",
  "#b19e90",
  "#9a8172",
  "#7d675c",
  "#64544a",
  "#f1e0d0",
  "#ecdac9",
  "#c6ad97",
  "#b29a86",
  "#9b806a",
  "#826a56",
  "#6c5a4d",
  "#efe9dd",
  "#e8e1d6",
  "#e4cdb9",
  "#c3a98f",
  "#ab886b",
  "#8e705a",
  "#775f4f",
  "#ece3d8",
  "#e9e0d8",
  "#dcc8b7",
  "#c4ab98",
  "#ac8f7b",
  "#8d6e54",
  "#76563d",
  "#eddac7",
  "#e6c6aa",
  "#d9b391",
  "#cba282",
  "#bc8d68",
  "#a57b5b",
  "#8e684b",
  "#f2e6d6",
  "#e8cfb8",
  "#e3c5a9",
  "#d5b092",
  "#ba8b69",
  "#a06f50",
  "#946448",
  "#efe2d6",
  "#ebd9cc",
  "#e5d0bf",
  "#e1c0a7",
  "#ca9b75",
  "#b47e50",
  "#9a653c",
  "#f1e8dd",
  "#f3e8db",
  "#f0d8c2",
  "#e8ceb5",
  "#d4ad87",
  "#b28a61",
  "#936c43",
  "#f0e8dd",
  "#ede2d4",
  "#decfbc",
  "#ceb69c",
  "#b29577",
  "#987b5d",
  "#77593d",
  "#ece5d8",
  "#e5d9c6",
  "#deccb6",
  "#c6b199",
  "#ac9379",
  "#90775d",
  "#7b624d",
  "#eeeade",
  "#ebe1d2",
  "#e2cfb2",
  "#d3bc9b",
  "#b99e78",
  "#a88767",
  "#987659",
  "#efe6db",
  "#f0e5d9",
  "#ebd8c2",
  "#e2ceb8",
  "#d2b088",
  "#ad865a",
  "#987043",
  "#f0e8da",
  "#f0ddc9",
  "#edd4b8",
  "#dbb78e",
  "#c89e73",
  "#af8159",
  "#9d7149",
  "#f6e7d2",
  "#f7e6cc",
  "#f0d6b7",
  "#e4c39d",
  "#ca9d6d",
  "#be9064",
  "#a2784e",
  "#f5e6d0",
  "#edcda5",
  "#deb583",
  "#d7aa77",
  "#c69b6a",
  "#b4865a",
  "#9e7247",
  "#f3ebd4",
  "#f2e9d0",
  "#f2dbba",
  "#e4c093",
  "#d3a771",
  "#b88d5a",
  "#a87a4b",
  "#f3eddf",
  "#f2ebd7",
  "#e9d0ae",
  "#d4b288",
  "#c3996b",
  "#b2885c",
  "#99744e",
  "#f5edd9",
  "#f0e1c3",
  "#e2c8a2",
  "#ceb28a",
  "#c2a379",
  "#b49167",
  "#a68053",
  "#e8dcc8",
  "#e5d1b6",
  "#dcc2a2",
  "#d8ba95",
  "#bc976c",
  "#b29169",
  "#8e6e4b",
  "#f2e8d8",
  "#f0e3d2",
  "#e6d3b9",
  "#d9c39f",
  "#c3a377",
  "#a88759",
  "#896a3f",
  "#eee6d5",
  "#ece2cc",
  "#dfc8aa",
  "#ceb697",
  "#b6936c",
  "#a1855c",
  "#816640",
  "#eae5d8",
  "#e4dfd1",
  "#dbcfba",
  "#cabba3",
  "#ad9a7e",
  "#8b795f",
  "#766245",
  "#efe9d9",
  "#e9ddc6",
  "#dfcfb3",
  "#ceba9a",
  "#ae9774",
  "#947b56",
  "#725d3d",
  "#ece4d4",
  "#e6ddc9",
  "#dfcdae",
  "#d3bc96",
  "#b29774",
  "#9f8766",
  "#897052",
  "#eed39b",
  "#eccf94",
  "#dbbe74",
  "#d2bc88",
  "#b79e6a",
  "#a28651",
  "#947f4e",
  "#71684c",
  "#dcd2a9",
  "#cecaa1",
  "#e9e6b8",
  "#bca96f",
  "#b2ae7f",
  "#9a9764",
  "#8a8646",
  "#777d54",
  "#9e8f72",
  "#b2a282",
  "#c3b498",
  "#aea995",
  "#d6d7bd",
  "#c6bda0",
  "#9e9f87",
  "#828678",
  "#676357",
  "#878263",
  "#d0c6a1",
  "#8d856a",
  "#b0a582",
  "#b5aa85",
  "#b2a57b",
  "#9e8f68",
  "#f3efe2",
  "#f3ebd9",
  "#ddc9ab",
  "#bca27b",
  "#ac926b",
  "#9e835f",
  "#8b6f4d",
  "#eae6d9",
  "#e5ddc8",
  "#d1c1a7",
  "#c0ab8f",
  "#af9778",
  "#887154",
  "#695c4c",
  "#ece7dc",
  "#e4ddcd",
  "#c7b9a2",
  "#b9ab90",
  "#a0906e",
  "#847551",
  "#665c46",
  "#f0eada",
  "#e6dbc5",
  "#d9cbad",
  "#c6b28c",
  "#a68e61",
  "#927747",
  "#77633a",
  "#efe9da",
  "#ece5d0",
  "#e9dac2",
  "#d5be9a",
  "#b3976b",
  "#91774f",
  "#866e4d",
  "#f1e9d7",
  "#f1e9d2",
  "#ead3ad",
  "#e2caa1",
  "#d0b486",
  "#be9c6b",
  "#aa8650",
  "#f7e8cc",
  "#f3d5a8",
  "#e9bf84",
  "#d5a463",
  "#daa863",
  "#c39458",
  "#b28243",
  "#f6edce",
  "#f9eac2",
  "#efdaa4",
  "#eed39b",
  "#e1ba75",
  "#cfa357",
  "#c49e43",
  "#f6eed4",
  "#f7eac8",
  "#f3e1b5",
  "#e9ce98",
  "#d5b373",
  "#bf9e62",
  "#b39150",
  "#f0e3be",
  "#ebdab0",
  "#e6cf9e",
  "#cea36e",
  "#cdac67",
  "#ba9c56",
  "#a68734",
  "#f1e3b5",
  "#e9d59e",
  "#d8c482",
  "#cdb668",
  "#ad9555",
  "#a48d49",
  "#917c3b",
  "#e9e6da",
  "#e5ddc6",
  "#d0c6a1",
  "#bcac7d",
  "#9c8f60",
  "#897747",
  "#75693d",
  "#ede6d9",
  "#e2dac9",
  "#d7ccb6",
  "#c9ba9d",
  "#b1a582",
  "#9e9067",
  "#726647",
  "#dfdac6",
  "#d4cdb5",
  "#c6bda0",
  "#b0a582",
  "#9c946f",
  "#7a744d",
  "#5e573e",
  "#e9e7d7",
  "#dedbc4",
  "#d1ccaa",
  "#bcb58b",
  "#a39d70",
  "#8c8752",
  "#797547",
  "#eaebdd",
  "#e7e5d5",
  "#dfdcc7",
  "#c8c5a5",
  "#a19d77",
  "#918c66",
  "#756f4d",
  "#edebd5",
  "#e4e2ca",
  "#e5dfc1",
  "#dcd2a9",
  "#bfac78",
  "#ab955d",
  "#927f4a",
  "#eeebc2",
  "#e9e7b3",
  "#dcdb94",
  "#c3c67e",
  "#b5b364",
  "#a1a057",
  "#8e8849",
  "#e9e5c6",
  "#dfdbb6",
  "#d3d0a3",
  "#c0bc8a",
  "#a8a268",
  "#908a4f",
  "#7d7943",
  "#ece7d1",
  "#e7e1c5",
  "#dfdab9",
  "#cec99f",
  "#bab381",
  "#a59f6c",
  "#8d8753",
  "#edeee0",
  "#e3ead9",
  "#dce4cb",
  "#ccd1ac",
  "#b6be96",
  "#99a374",
  "#717a4e",
  "#e3e8da",
  "#dae1d0",
  "#cfdbc4",
  "#bac6a4",
  "#98a77d",
  "#7d8e61",
  "#5d6d3c",
  "#e9e8d8",
  "#dfe3d0",
  "#cfd2b5",
  "#b8bd97",
  "#9da073",
  "#7f8353",
  "#6c7344",
  "#eeece1",
  "#ebe9dd",
  "#e2e0d3",
  "#cecab6",
  "#a9a484",
  "#8f8a6b",
  "#6f6b4d",
  "#e1e5d8",
  "#d8decf",
  "#c7cebf",
  "#b2b9a5",
  "#92987e",
  "#6c765b",
  "#566049",
  "#e2e0d6",
  "#d2d4c3",
  "#c8cab6",
  "#acaf96",
  "#909374",
  "#6d704f",
  "#57593f",
  "#eaebe0",
  "#e7e6d8",
  "#dedccd",
  "#c3c2af",
  "#a1a187",
  "#7c7c64",
  "#6a6b58",
  "#dfe5d9",
  "#dbddcd",
  "#d1d2c1",
  "#afb29f",
  "#85866f",
  "#656552",
  "#5f5e4b",
  "#dcddd4",
  "#d1d2c8",
  "#c8cac0",
  "#bec4b8",
  "#929a8a",
  "#727b6c",
  "#515746",
  "#dfe5db",
  "#cad5c8",
  "#d0d5c8",
  "#b8bfb0",
  "#929b89",
  "#798372",
  "#52584e",
  "#e1e8dc",
  "#dbe5d8",
  "#cfddcd",
  "#b9d1b6",
  "#8faf88",
  "#709068",
  "#4c663e",
  "#e3ede3",
  "#d1e5d3",
  "#cdddc4",
  "#aac5a3",
  "#93b087",
  "#6e8b63",
  "#5c724c",
  "#dae9df",
  "#c5decf",
  "#a8d0ba",
  "#83bb9e",
  "#60a182",
  "#438866",
  "#20654a",
  "#dde7df",
  "#c7dace",
  "#bcd0c3",
  "#9cb7a6",
  "#789583",
  "#54745f",
  "#3d5948",
  "#e6eae0",
  "#e2e8df",
  "#deeae0",
  "#b2c5b9",
  "#899a8c",
  "#697b6c",
  "#405241",
  "#e6e9e3",
  "#e0e4dd",
  "#d9e0d7",
  "#b6c4bb",
  "#87988c",
  "#758478",
  "#57645c",
  "#e0e9e4",
  "#dee8e3",
  "#d5e2de",
  "#b9cac5",
  "#90a49d",
  "#70837d",
  "#495a51",
  "#ecf1ec",
  "#e6efea",
  "#dcece7",
  "#acc7c0",
  "#809f97",
  "#627d74",
  "#375549",
  "#d7e5dd",
  "#c3d7d0",
  "#aec7c0",
  "#8aaea4",
  "#6b9085",
  "#447266",
  "#3b564e",
  "#d3e5dc",
  "#bed5c8",
  "#a1c2b1",
  "#7eaa96",
  "#608f7b",
  "#3b6c55",
  "#2e594b",
  "#d7e7e0",
  "#badad1",
  "#9fcdc0",
  "#7cb5a5",
  "#559c8a",
  "#277a67",
  "#006852",
  "#d7e7e1",
  "#c2dcd6",
  "#acd0ca",
  "#87b9b2",
  "#5d9c92",
  "#42857c",
  "#106157",
  "#d5e7e4",
  "#cde2df",
  "#bbd6d5",
  "#99c1be",
  "#6fa39f",
  "#4a8582",
  "#0f5f5c",
  "#e1ebe5",
  "#c7d6d2",
  "#b6ccc8",
  "#92b1a9",
  "#73978f",
  "#4a726b",
  "#2d5951",
  "#d0dbd8",
  "#cad9d7",
  "#becfcd",
  "#a1b7b5",
  "#7b9793",
  "#547370",
  "#355856",
  "#e8eee8",
  "#d9e6e4",
  "#d6e5e3",
  "#a7bbba",
  "#7f9392",
  "#566b6b",
  "#3b4f4f",
  "#dce6e4",
  "#d3e0df",
  "#c7dada",
  "#9fbfbf",
  "#6b9a9b",
  "#467a7b",
  "#155d61",
  "#dbe6e5",
  "#cfe2e1",
  "#bbdbdb",
  "#8ac2c3",
  "#53a0a1",
  "#1f7d82",
  "#00666f",
  "#d4e3e3",
  "#d5e1e1",
  "#cad9db",
  "#a0bcc0",
  "#79989c",
  "#497279",
  "#2a535c",
  "#dbe4e5",
  "#cedee3",
  "#c2d3d7",
  "#95afb7",
  "#6f8d96",
  "#496772",
  "#2c5261",
  "#d2e4e6",
  "#cde0e4",
  "#b6d7de",
  "#8dbbc4",
  "#4b99a9",
  "#167b8f",
  "#00687d",
  "#d9e3e6",
  "#cbdee2",
  "#b3d0d9",
  "#86b5c4",
  "#5c96a9",
  "#31778c",
  "#02617b",
  "#dae3e6",
  "#d1dee4",
  "#a8c0ce",
  "#7e9daf",
  "#618396",
  "#355c74",
  "#2b516b",
  "#e9eeed",
  "#e3eaea",
  "#d7dfe2",
  "#acbfc9",
  "#7b8f99",
  "#516772",
  "#334a59",
  "#ecefeb",
  "#d4e2e6",
  "#cddce3",
  "#adc6d3",
  "#7f9daa",
  "#5c7a89",
  "#2c5268",
  "#e1e9ec",
  "#dfeaef",
  "#cedde7",
  "#bbcddc",
  "#8da7b9",
  "#5f7b8e",
  "#2d5069",
  "#dee6e8",
  "#c9d7de",
  "#a1b9cb",
  "#7494ac",
  "#52778f",
  "#2b5876",
  "#2c4c6a",
  "#d7e1e5",
  "#c5d8e3",
  "#aac8d8",
  "#81acc4",
  "#5491b2",
  "#32759a",
  "#005d89",
  "#d8e4e8",
  "#c3d8e4",
  "#a3c3d7",
  "#77a6c3",
  "#508aab",
  "#266c94",
  "#175788",
  "#dfe7e9",
  "#c4d2dd",
  "#a3bbce",
  "#779bb6",
  "#4f7b9a",
  "#1a5b84",
  "#255269",
  "#dae1e4",
  "#c1ceda",
  "#aabed0",
  "#8ca8bf",
  "#587f9e",
  "#395e7d",
  "#2a4a6f",
  "#dae3e8",
  "#bdd0e1",
  "#a1bed9",
  "#719cc3",
  "#4d83af",
  "#266393",
  "#224d88",
  "#d8e0e8",
  "#c7d3e0",
  "#adbfd6",
  "#7d9dc3",
  "#5b83b2",
  "#2f6295",
  "#304a77",
  "#dde3e8",
  "#c7d1dc",
  "#b6c3d2",
  "#9dafc2",
  "#6b8096",
  "#4b6077",
  "#2e5268",
  "#e9ecef",
  "#dae4ee",
  "#d6dfe8",
  "#adbad0",
  "#8290a6",
  "#627188",
  "#384966",
  "#e0e2e5",
  "#d1d6df",
  "#c0c6d4",
  "#a5afc4",
  "#7c8ba8",
  "#566682",
  "#3a3f5b",
  "#dee1e6",
  "#d4dae2",
  "#bcc5d9",
  "#9aa9c8",
  "#6c86b7",
  "#4e6897",
  "#364875",
  "#e3e5e8",
  "#dcdfe6",
  "#ccd0dd",
  "#a7b0cc",
  "#818db3",
  "#617099",
  "#455383",
  "#e6e6e8",
  "#dadbdf",
  "#c7ccd9",
  "#a4abbf",
  "#838ba4",
  "#606a88",
  "#3c486d",
  "#e4e3e5",
  "#dcdbe2",
  "#d1d2dc",
  "#afb2c4",
  "#898ca3",
  "#6b6d85",
  "#454b6a",
  "#e2e3ec",
  "#dee0ea",
  "#d1d3e1",
  "#b1b2cb",
  "#8f90b4",
  "#686b93",
  "#4c517f",
  "#e5e7e9",
  "#e5e6ea",
  "#dadde6",
  "#b8b9cb",
  "#9090a2",
  "#6e6f82",
  "#464960",
  "#efedeb",
  "#ebe8ec",
  "#d6d2d9",
  "#bab3bf",
  "#928a98",
  "#6b6472",
  "#4a4353",
  "#dfdee5",
  "#e0dde3",
  "#d4d1dc",
  "#bfbbc9",
  "#9c95a9",
  "#79738b",
  "#544f66",
  "#e5e1e5",
  "#dbd6df",
  "#cec8d2",
  "#bab3c2",
  "#9c8fa6",
  "#736a86",
  "#4e4360",
  "#e6e2e7",
  "#dfdbe5",
  "#d3d0dd",
  "#bfb8ce",
  "#998eb4",
  "#736993",
  "#534b77",
  "#e7dee6",
  "#e6dde7",
  "#d6cbdb",
  "#c3b1c8",
  "#a487ac",
  "#896792",
  "#6a4877",
  "#e7e3e7",
  "#e1d8e0",
  "#d7c7d6",
  "#c3aec3",
  "#a689a3",
  "#7f667f",
  "#604560",
  "#e8dfe4",
  "#e6d8e1",
  "#ddcad8",
  "#d0b7ca",
  "#b08ea5",
  "#88657e",
  "#674160",
  "#e8e1e3",
  "#e2d9dc",
  "#dbccd3",
  "#cfbac4",
  "#b695a4",
  "#906277",
  "#623f52",
  "#e6dae2",
  "#e7d8e3",
  "#e7cede",
  "#dab7cf",
  "#c291b2",
  "#a36c93",
  "#824874",
  "#f4dfe4",
  "#f5d8e0",
  "#f6c8d5",
  "#f2a8bf",
  "#ea85a4",
  "#e06c90",
  "#cb567c",
  "#f0e1e5",
  "#f1d6dd",
  "#f0c8d3",
  "#e6a4b8",
  "#da859f",
  "#cb6787",
  "#b0446a",
  "#f2dee1",
  "#f3d3d9",
  "#eebfc9",
  "#ea9dac",
  "#d5768b",
  "#cc607a",
  "#b13e5e",
  "#f5e4e5",
  "#f7cdd2",
  "#f8b3bc",
  "#f892a0",
  "#e76b81",
  "#da5770",
  "#d04a64",
  "#f5dbd9",
  "#f9cccd",
  "#f9b5b6",
  "#f8949b",
  "#eb6a76",
  "#e05164",
  "#cb384b",
  "#f3dbdb",
  "#f5cacb",
  "#f4b3b7",
  "#ea8e96",
  "#d56d76",
  "#c04f5b",
  "#ad3d4c",
  "#f4d9d7",
  "#f5d2cf",
  "#f4c1c0",
  "#f09b9d",
  "#dc7678",
  "#c8585c",
  "#b1393e",
  "#f5e3e0",
  "#f7d8d7",
  "#fac2bf",
  "#faa09d",
  "#f27777",
  "#e75f64",
  "#cb484c",
  "#f6e2de",
  "#f7dcd3",
  "#facac2",
  "#fbb1a6",
  "#f3867c",
  "#d7584c",
  "#b94940",
  "#f4e0db",
  "#f4dbd6",
  "#f6c8c3",
  "#eeaaa2",
  "#df8079",
  "#c76157",
  "#ae413a",
  "#f4ece7",
  "#f3e3dd",
  "#f1c5bb",
  "#e8a091",
  "#db8675",
  "#c06f60",
  "#b35941",
  "#f4e4dc",
  "#f5e0d8",
  "#f2d1c8",
  "#f2c2b6",
  "#e79c86",
  "#dc8267",
  "#c35b3c",
  "#f4e8e1",
  "#f7e2d8",
  "#f8dfd7",
  "#f4c8be",
  "#fda48d",
  "#e4745b",
  "#cf533a",
  "#f5e8e1",
  "#f6e4dc",
  "#f5ded4",
  "#eeb9ab",
  "#e68f75",
  "#e57757",
  "#c15339",
  "#f3eae2",
  "#f6e2d5",
  "#f3d4c5",
  "#f3b598",
  "#f6a37c",
  "#ec8a5b",
  "#dd6f3b",
  "#f4ddcd",
  "#f5d9c9",
  "#f7d5c2",
  "#f8be9d",
  "#fba270",
  "#f49056",
  "#ea874f",
  "#f3e9df",
  "#f3e1d2",
  "#f8d8be",
  "#fac6a0",
  "#feac71",
  "#fa9a54",
  "#f39349",
  "#f5decc",
  "#f5d4bf",
  "#f5c6a7",
  "#f0ab80",
  "#e08d59",
  "#d27638",
  "#c66b35",
  "#f5e2d6",
  "#f5dfd4",
  "#efc7b6",
  "#e7b095",
  "#d28d6c",
  "#c77c5a",
  "#b05f3a",
  "#d6bc8e",
  "#f2dabb",
  "#e8ba6c",
  "#d9b280",
  "#f6e4c0",
  "#e2bc8b",
  "#efd1a7",
  "#e9b072",
  "#f3e6cf",
  "#ceb9a5",
  "#c4a47f",
  "#dcbf98",
  "#eadbc6",
  "#d4b288",
  "#e2c8a2",
  "#c3aa87",
  "#f0d2a4",
  "#e1c193",
  "#c2a379",
  "#ccb38b",
  "#e2caa1",
  "#d0b486",
  "#efdaa4",
  "#ac8955",
  "#f6e2c8",
  "#e0ccaf",
  "#f0e1c3",
  "#e7d5b6",
  "#e1cba9",
  "#cfb695",
  "#ecd7ba",
  "#ebd6ba",
  "#f4e4d5",
  "#f6d9c6",
  "#f2c3a7",
  "#e9a580",
  "#d2885e",
  "#c47444",
  "#b96a3c",
  "#f2e4d7",
  "#f0dcca",
  "#f1cdb4",
  "#eab794",
  "#d89466",
  "#cf8149",
  "#bf7037",
  "#f2e9dd",
  "#f5e3d1",
  "#f4dcc6",
  "#f0c9aa",
  "#e4ac78",
  "#d29358",
  "#c58038",
  "#f3ecdd",
  "#f6e8d6",
  "#f5debf",
  "#fbd19f",
  "#fcbc7d",
  "#f5ae61",
  "#f09c43",
  "#f4eedd",
  "#f4ead3",
  "#fbe4c2",
  "#fdd9aa",
  "#fcc584",
  "#fabb72",
  "#fbb153",
  "#f4f0de",
  "#f7eed6",
  "#fae6c4",
  "#ffdba5",
  "#ffd892",
  "#ffc963",
  "#ffbd32",
  "#f6efda",
  "#f8eece",
  "#f8eccb",
  "#fce5af",
  "#ffda77",
  "#ffd25a",
  "#ffc72f",
  "#f2ede1",
  "#f5e7d2",
  "#f4e2c6",
  "#f0cea0",
  "#e3b270",
  "#ce974d",
  "#bb8132",
  "#f2eee2",
  "#f4e9cf",
  "#f4dfb7",
  "#edc482",
  "#e1ad59",
  "#cf9943",
  "#bd862e",
  "#f3edd9",
  "#f5e5c6",
  "#f6deaf",
  "#f4c775",
  "#eeb955",
  "#e2a94b",
  "#c99233",
  "#f6ead3",
  "#f8e2bb",
  "#f8dcab",
  "#f9cf8e",
  "#eeb865",
  "#e5ac4f",
  "#d8a431",
  "#f6eed7",
  "#f7edcf",
  "#fbe7b7",
  "#ffe19c",
  "#fed27d",
  "#ffc85e",
  "#ffc047",
  "#f2efd7",
  "#f5efc3",
  "#f5edb2",
  "#f7eca1",
  "#feeb83",
  "#ffdf37",
  "#ffcb3b",
  "#f0efe1",
  "#f3efcd",
  "#f5eeba",
  "#f6edae",
  "#f9eb97",
  "#fcd361",
  "#f6c545",
  "#f2ecdb",
  "#f2ead2",
  "#f9e5ba",
  "#f5e3a7",
  "#f8d86e",
  "#e5c14c",
  "#d9ad38",
  "#f3f0e6",
  "#f0edd2",
  "#f0e7a9",
  "#f0df75",
  "#e3c74e",
  "#cfb128",
  "#b8a029",
  "#efefd6",
  "#eaeece",
  "#e9edbd",
  "#ececa7",
  "#ede777",
  "#e6da42",
  "#e0be36",
  "#f1edd3",
  "#efe8bb",
  "#ebe3a9",
  "#e0e2a9",
  "#d8d68e",
  "#d6ce81",
  "#d4c44b",
  "#f0eac6",
  "#f1e7b5",
  "#e7d890",
  "#ddc76a",
  "#c6b156",
  "#ae9c3f",
  "#a3923e",
  "#eeeed7",
  "#e9e7af",
  "#e1e0a0",
  "#d5d17b",
  "#c9c664",
  "#bab242",
  "#99a32a",
  "#eeefdc",
  "#f0edcc",
  "#eae9b8",
  "#e4e5ab",
  "#d9e29a",
  "#cace66",
  "#b7c04e",
  "#ecf1e2",
  "#ebedd1",
  "#e2e9bf",
  "#dde7ad",
  "#ccd98a",
  "#b3c667",
  "#a7b53c",
  "#e6ebd7",
  "#e6eccc",
  "#dbe5ba",
  "#cddda2",
  "#adc571",
  "#95af54",
  "#78973b",
  "#e2ede1",
  "#ddead9",
  "#d2e3cd",
  "#b8d7ae",
  "#93bf84",
  "#73a55b",
  "#558c3b",
  "#ecf0e5",
  "#e8f0e2",
  "#e4efdf",
  "#d6eccd",
  "#bde4b1",
  "#9bd687",
  "#74be58",
  "#e3efe2",
  "#dbeedb",
  "#cceace",
  "#bce5be",
  "#8fd49a",
  "#65c171",
  "#37a84f",
  "#dae9dd",
  "#d0e6d6",
  "#b7dcc4",
  "#97cda9",
  "#64b082",
  "#4c9d6f",
  "#007845",
  "#daeee1",
  "#c2ead6",
  "#a4e0c3",
  "#74cfa8",
  "#3eb989",
  "#25a975",
  "#00935f",
  "#dceee2",
  "#bfe5d6",
  "#a0d4be",
  "#7cc4aa",
  "#4ca787",
  "#1f8f6e",
  "#007859",
  "#d4ede3",
  "#bbe7d9",
  "#95dcc6",
  "#57c9b0",
  "#04b296",
  "#00a285",
  "#00896f",
  "#d8eae5",
  "#bce1d9",
  "#a3d8ce",
  "#73c2b5",
  "#40a696",
  "#089080",
  "#007c6d",
  "#e2ebe5",
  "#c4e5e3",
  "#b3deda",
  "#8cccc8",
  "#5ab1ac",
  "#239692",
  "#007a77",
  "#e1ede6",
  "#d3ece7",
  "#a9e3df",
  "#7cd5d1",
  "#3abdb7",
  "#00a29d",
  "#00918d",
  "#deeeed",
  "#d1ebeb",
  "#c2e7e9",
  "#b3e3e5",
  "#6ccacf",
  "#38b8be",
  "#0099a0",
  "#e5f1ef",
  "#d3e7e6",
  "#bededf",
  "#8cced1",
  "#4ab2b4",
  "#0e9498",
  "#007681",
  "#e8efed",
  "#d2e5e9",
  "#c3dde3",
  "#92c7d3",
  "#52a5b7",
  "#168da2",
  "#007893",
  "#deeced",
  "#d3e8ec",
  "#c5e3eb",
  "#9ad4e2",
  "#56b8cd",
  "#1fa3bc",
  "#008ea9",
  "#e4edee",
  "#cee4ee",
  "#add6eb",
  "#7ec0e3",
  "#44a6d1",
  "#1091c0",
  "#007bae",
  "#dae6ea",
  "#d0e1e8",
  "#accfe0",
  "#7cb5d0",
  "#5096b7",
  "#1e80a9",
  "#006994",
  "#d6e1e4",
  "#ccdfe9",
  "#9ec8e5",
  "#63a8d3",
  "#3a8ebc",
  "#1877ac",
  "#00609e",
  "#d3e5ec",
  "#cbe3ef",
  "#a2d0ec",
  "#67b3e1",
  "#2e96d0",
  "#1389ca",
  "#0071b6",
  "#d9e6ee",
  "#c7ddee",
  "#9ac6eb",
  "#5fa4e0",
  "#388dd1",
  "#177fc8",
  "#0262af",
  "#dae3ea",
  "#c2d7ea",
  "#96bde2",
  "#71a3d0",
  "#3984be",
  "#166eae",
  "#175799",
  "#e1e8ed",
  "#d3e0ed",
  "#aac9ea",
  "#7bade2",
  "#4e8ed2",
  "#3879c2",
  "#2463ad",
  "#e0e6eb",
  "#d0dbe9",
  "#a2bcdb",
  "#7da2d2",
  "#5287c0",
  "#326ead",
  "#18569a",
  "#dde0e9",
  "#dadee9",
  "#cbd1e1",
  "#abb6d8",
  "#8293c5",
  "#6174ab",
  "#415397",
  "#dfe2ec",
  "#d7ddec",
  "#cad1ea",
  "#adb9e3",
  "#8496d2",
  "#7287c6",
  "#5668ae",
  "#e9e5e9",
  "#e5e1ea",
  "#dcd7e4",
  "#c7bedd",
  "#a698c7",
  "#8378ad",
  "#5a4e87",
  "#edeced",
  "#e9e5ed",
  "#e4dfed",
  "#d1c8e6",
  "#9898bc",
  "#7b7da7",
  "#5d5d88",
  "#eae1e9",
  "#e5d6e5",
  "#ddcae0",
  "#caafd0",
  "#aa85b5",
  "#9769a2",
  "#7a5188",
  "#ecdfea",
  "#e9ddea",
  "#e0cae5",
  "#d1b1d8",
  "#b68bc2",
  "#a675b1",
  "#855994",
  "#ece2e8",
  "#ebe0e8",
  "#ead2e3",
  "#e3bed9",
  "#cf94be",
  "#b06ea0",
  "#935284",
  "#eee5e8",
  "#efe1ec",
  "#efdae8",
  "#eac2de",
  "#dea3cd",
  "#c67cb2",
  "#a05a8e",
  "#8e575d",
  "#79413a",
  "#6e403e",
  "#753e45",
  "#8b585d",
  "#5f4345",
  "#614142",
  "#6a4f61",
  "#a04848",
  "#6d1d14",
  "#983d4d",
  "#8b4548",
  "#72271e",
  "#a84f5c",
  "#a04f45",
  "#a23d3f",
  "#575561",
  "#5f5358",
  "#7a6c74",
  "#715d79",
  "#4a4353",
  "#6b6472",
  "#9e9fa8",
  "#807d85",
  "#364875",
  "#2d5069",
  "#295167",
  "#196a76",
  "#1c3c2d",
  "#3b5a54",
  "#52634f",
  "#526a4d",
  "#8c817b",
  "#7b675a",
  "#e1ded9",
  "#b9b0a8",
  "#3d4646",
  "#7e756b",
  "#e1dacd",
  "#eeeade",
  "#c0ab8f",
  "#d8cab2",
  "#d5d1c0",
  "#cbc1be",
  "#a1917e",
  "#c8b8a4",
  "#ebe3d6",
  "#f0ece2",
  "#d7c5ae",
  "#d2b89c",
  "#e4d2b9",
  "#eee6d7",
  "#e0d4c4",
  "#cbbab0",
  "#efe7da",
  "#eae6de",
  "#d5d0bf",
  "#c8bea8",
  "#b9ac97",
  "#aaa190",
  "#d1c9bb",
  "#dbd1c6",
  "#e6e1d8",
  "#cec7b8",
  "#bb987b",
  "#9b6f45",
  "#b08661",
  "#c7a78b",
  "#efebde",
  "#e7dbca",
  "#bc9f85",
  "#a58056",
  "#baa286",
  "#ae9273",
  "#c8a987",
  "#c3a98f",
  "#705746",
  "#5e3f1e",
  "#b29577",
  "#c6b199",
  "#8d847f",
  "#6d5f53",
  "#a39080",
  "#87796c",
  "#766759",
  "#635141",
  "#462406",
  "#381b04",
  "#c9bcac",
  "#dbcfba",
  "#f7f0e2",
  "#cabfb2",
  "#b6a393",
  "#9c8a7a",
  "#a38e72",
  "#8d7868",
  "#d3ac9a",
  "#a38064",
  "#c88f68",
  "#b58365",
  "#ba8a74",
  "#a16f52",
  "#9f6f59",
  "#7a4d42",
  "#ccb9ad",
  "#ddba87",
  "#c5944f",
  "#af7800",
  "#ae814e",
  "#ce9859",
  "#ae7b44",
  "#aa7f5e",
  "#977652",
  "#cea886",
  "#c88b5a",
  "#b1703a",
  "#b27547",
  "#a96c3f",
  "#855842",
  "#574542",
  "#eacbb4",
  "#d6a284",
  "#bd8675",
  "#b06e5b",
  "#96534a",
  "#743618",
  "#772f0f",
  "#692300",
  "#92b3dc",
  "#4d7cb2",
  "#345578",
  "#6c86b7",
  "#5668ae",
  "#7a8ab7",
  "#826d95",
  "#b18aae",
  "#cc6e94",
  "#c65a87",
  "#aa4875",
  "#9e4749",
  "#cb484c",
  "#eb6a76",
  "#e4745b",
  "#de624e",
  "#ffce6a",
  "#f3c16d",
  "#edad57",
  "#e2ac71",
  "#fba971",
  "#ec8e3f",
  "#ce7b51",
  "#da7953",
  "#ddcb6b",
  "#a9ac31",
  "#aaa44c",
  "#7a8e68",
  "#94d3c1",
  "#bae6d2",
  "#8dc9c0",
  "#00948b",
  "#f3f0e7",
  "#d7cbc1",
  "#c9b6a9",
  "#c4bab9",
  "#b99d99",
  "#c69b9e",
  "#ad929f",
  "#9f898c",
  "#ece8de",
  "#f1e7d9",
  "#f3ebe4",
  "#f5e4da",
  "#efdacf",
  "#e1c4b9",
  "#e3b9ab",
  "#c59688",
  "#ede2e4",
  "#ebd7d9",
  "#dbb7bc",
  "#b98290",
  "#a67479",
  "#9d686c",
  "#9f6071",
  "#7f3f55",
  "#cfbeb7",
  "#e4caba",
  "#e5c0a9",
  "#dfbaab",
  "#ca7976",
  "#c1727c",
  "#b0676d",
  "#af5959",
  "#545049",
  "#c2b8ac",
  "#eddcc9",
  "#1a1917",
  "#000000",
  "#ffffff",
  "#eaeace",
  "#bfbfb6",
  "#e8e8e8",
  "#373025",
  "#a1a191",
  "#383838",
  "#354c3b",
  "#6b3d31",
  "#96683b",
  "#51524d",
  "#aa988a",
  "#757d82",
  "#8f9da8",
  "#3c4a53",
  "#4f4135",
  "#2b2b2b",
  "#524b3e",
  "#002e45",
  "#da2122",
  "#ebebeb",
  "#112e57",
  "#cccfbe",
  "#959595",
  "#4f6e7d",
  "#848484",
  "#9d4e2f",
  "#9aa1a3",
  "#BEB5A9",
  "#C8BCAB",
  "#EDECE6",
  "#bbb2a3",
  "#efece3",
  "#e3dbcd",
  "#2a3037",
  "#313233",
  "#433f34",
  "#E7e7e9",
  "#f6f5fa",
  "#6b5d50",
  "#d4d3ce",
  "#778375",
  "#afb2a3",
  "#b8bab2",
  "#31353a",
  "#323234",
  "#757257",
  "#5c5c4f",
  "#c5baa5",
  "#ccc8c0",
  "#90948b",
  "#c5c2b8",
  "#b3b0a6",
  "#54523b",
  "#8b8370",
  "#d8d5cf",
  "#1a181a",
  "#4d412f",
  "#e2ded4",
  "#b2ad98",
  "#f4f6f2",
  "#aaa69a",
  "#2f2f30",
  "#303d4d",
  "#4d3d30",
  "#797979",
  "#870000",
  "#edece7",
  "#d7d7d1",
  "#143d1e",
  "#040708",
  "#ffffff",
  "#4a3321",
  "#361721",
  "#35352d",
  "#4e4d48",
  "#6a7a55",
  "#8a5121",
  "#928e34",
  "#d7d7d2",
  "#bf2726",
  "#840a2d",
  "#4a3321",
  "#830b0d",
  "#8b8776",
  "#133f1f",
  "#053752",
  "#979292",
  "#4e4d48",
  "#999492",
  "#b7ac97",
  "#1e4922",
  "#d3ccab",
  "#bdb68f",
  "#bdb790",
  "#999492",
  "#4d4d47",
  "#315d74",
  "#221f1f",
  "#999492",
  "#edefeb",
  "#a22320",
  "#7a2a28",
  "#49331f",
  "#bdb68f",
  "#9f8777",
  "#221f1f",
  "#bc9369",
  "#9f8776",
  "#040708",
  "#23302c",
  "#63707c",
  "#4e413a",
  "#322c2d",
  "#304654",
  "#2a3d3a",
  "#6c6f6a",
  "#3b564b",
  "#e7e2cb",
  "#5c6461",
  "#a58966",
  "#726158",
  "#a09b9a",
  "#8d877c",
  "#dcc28f",
  "#4b504c",
  "#8b8e8c",
  "#9aa098",
  "#4f5f67",
  "#466279",
  "#5f767a",
  "#78484a",
  "#927564",
  "#475960",
  "#958b75",
  "#c3cbb8",
  "#e0d0b4",
  "#ccd0c7",
  "#986953",
  "#7b7162",
  "#bbc2aa",
  "#9e7960",
  "#c9bca7",
  "#aaa891",
  "#24211f",
  "#734136",
  "#f1edcf",
  "#606659",
  "#999b93",
  "#3a4650",
  "#46443c",
  "#5b3e2f",
  "#673440",
  "#7a7265",
  "#5d3e41",
  "#514e47",
  "#d3c6b4",
  "#f7f1cc",
  "#acaeb2",
  "#cbd0c9",
  "#fff7e3",
  "#a0aa9a",
  "#f0ead6",
  "#d2cab6",
  "#e0d0b4",
  "#a6c1c9",
  "#d8d4bf",
  "#a1ab8b",
  "#bbc2aa",
  "#8f5937",
  "#73645b",
  "#7a7474",
  "#3f4748",
  "#585c67",
  "#8c898c",
  "#dfd5c3",
  "#5f6a62",
  "#c9af8c",
  "#9d9ba1",
  "#908171",
  "#333932",
  "#999a92",
  "#ac9988",
  "#485061",
  "#5c5e63",
  "#6b6866",
  "#c9c0b8",
  "#867f7d",
  "#4d3b33",
  "#c0b19d",
  "#6e767f",
  "#614e42",
  "#a67c64",
  "#7f4642",
  "#9d8071",
  "#877563",
  "#cabbaa",
  "#9f9584",
  "#978b7e",
  "#55554f",
  "#f8f8f7",
  "#a8967c",
  "#84786d",
  "#eddcc9",
  "#1a1917",
  "#423124",
  "#a9a092",
  "#847362",
  "#ede0c9",
  "#224a4f",
  "#a5a6aa",
  "#fbf9f4",
  "#f0ebd1",
  "#f7f5f5",
  "#2f2e2e",
  "#756346",
  "#5c4d29",
  "#40311c",
  "#e0d8c5",
  "#6e6968",
  "#c4b591",
  "#928b7c",
  "#949594",
  "#8e988c",
  "#7c7463",
  "#59534c",
  "#79888e",
  "#988977",
  "#e8b9ae",
  "#946644",
  "#47626f",
  "#e9e0d5",
  "#598c74",
  "#c2ccc4",
  "#92576f",
  "#b87e93",
  "#cb9aad",
  "#e3c0cf",
  "#ebd1db",
  "#7c3655",
  "#854158",
  "#a2566f",
  "#c47b95",
  "#d899b1",
  "#99324e",
  "#b04b63",
  "#d47c8c",
  "#e392a1",
  "#efc0cb",
  "#f1d3da",
  "#f0bcc9",
  "#f1d2d7",
  "#a42e37",
  "#bb4b51",
  "#d66972",
  "#ed939d",
  "#f0c1c6",
  "#f2d5d7",
  "#813235",
  "#a43834",
  "#d76c6e",
  "#ed9190",
  "#f0b3b2",
  "#f1c6c4",
  "#903934",
  "#a13b34",
  "#d9766c",
  "#ee9489",
  "#f0afa8",
  "#f2ccc5",
  "#b8473d",
  "#b85444",
  "#d87b6a",
  "#e79580",
  "#f2b8a7",
  "#f2d1c3",
  "#b44b34",
  "#c65f47",
  "#dd7861",
  "#e49780",
  "#f3c1ab",
  "#f0d1c3",
  "#c4633e",
  "#d67c56",
  "#e2946f",
  "#c35530",
  "#f3c1a3",
  "#f3d3bf",
  "#c36f3e",
  "#cb7841",
  "#e6955f",
  "#f2b88c",
  "#f4c69f",
  "#f4d3b3",
  "#e69f5f",
  "#efb57a",
  "#f5c894",
  "#f4d4af",
  "#df9938",
  "#ebad5e",
  "#eeb76b",
  "#f4bf77",
  "#f5d6a9",
  "#e39a33",
  "#f2af46",
  "#f7be5b",
  "#fbcb78",
  "#fbd187",
  "#f5deaf",
  "#ffc723",
  "#f4c454",
  "#fbd073",
  "#fbd682",
  "#fedf94",
  "#f5e5bc",
  "#fecb01",
  "#fed340",
  "#ffd566",
  "#fad97a",
  "#f5e1a6",
  "#f3e8c2",
  "#f1ead8",
  "#f6dda3",
  "#f5e0b1",
  "#c48919",
  "#d6a02b",
  "#eec25f",
  "#f5d68f",
  "#c49832",
  "#d1a436",
  "#dbb04a",
  "#eac365",
  "#f7d78a",
  "#f5e1ac",
  "#cba901",
  "#ddb835",
  "#edd26f",
  "#f7e594",
  "#f2eac3",
  "#9c8b1f",
  "#ac9825",
  "#c4b146",
  "#d9c661",
  "#e6d88e",
  "#eee3b2",
  "#847e35",
  "#b4b05a",
  "#c4c476",
  "#d2d083",
  "#dad790",
  "#e9e5b3",
  "#2f5f3a",
  "#4f854a",
  "#7fac6e",
  "#99c285",
  "#abca99",
  "#c0d2ad",
  "#245e36",
  "#68a678",
  "#78b185",
  "#8ec298",
  "#aed2b0",
  "#cce2ca",
  "#016844",
  "#57aa80",
  "#8ac1a1",
  "#9fcdb1",
  "#b7d7bf",
  "#d1e3d2",
  "#368976",
  "#53a38f",
  "#70baa7",
  "#89c6b7",
  "#a1d4c8",
  "#c0e3da",
  "#3b8c80",
  "#75b9ae",
  "#8ac5ba",
  "#a1d5cb",
  "#c1e6df",
  "#017478",
  "#01858b",
  "#3aa9ae",
  "#6ec2c4",
  "#92d0d0",
  "#a7dcdc",
  "#c2e5e5",
  "#01717e",
  "#08808e",
  "#4da6b2",
  "#7dc1cb",
  "#97cbd2",
  "#a6d0d6",
  "#016e85",
  "#34a3b6",
  "#71b8c7",
  "#8bc4d1",
  "#a6d4de",
  "#c6e3e8",
  "#016081",
  "#01819e",
  "#01a0b8",
  "#56b5ca",
  "#8fd0dd",
  "#b4e0e7",
  "#015d87",
  "#017ca7",
  "#289ec4",
  "#5db3d4",
  "#89c6df",
  "#a2d5e7",
  "#b7dfe8",
  "#2377a2",
  "#5a9ec0",
  "#7db5d3",
  "#b0d6e6",
  "#c3dfe8",
  "#4c6b8a",
  "#6b8ca9",
  "#8ea9c2",
  "#b2c8d8",
  "#cbd8e1",
  "#164576",
  "#4e739f",
  "#7498be",
  "#97b3d0",
  "#b8cddd",
  "#ccdbe5",
  "#3e4371",
  "#6572a5",
  "#8b98c4",
  "#a7b2d4",
  "#bbc5de",
  "#d8dde6",
  "#4d426e",
  "#716998",
  "#968db8",
  "#bdb4d4",
  "#d1cbdf",
  "#dfd9e4",
  "#624977",
  "#7e6596",
  "#a18ab7",
  "#c0afd0",
  "#d2c8dd",
  "#dfdce5",
  "#5d395f",
  "#7c5a7e",
  "#a785a7",
  "#c2a4c2",
  "#dac7da",
  "#e5dbe5",
  "#2f2f30",
  "#7d848b",
  "#a8aeb1",
  "#bec1c3",
  "#d4d8d7",
  "#656d73",
  "#90979b",
  "#b8bcbb",
  "#d3d5d3",
  "#dbdfe0",
  "#44484d",
  "#616669",
  "#7f8486",
  "#939899",
  "#a0a5a7",
  "#b0b5b5",
  "#c6caca",
  "#606e74",
  "#969a96",
  "#abb0ac",
  "#a5a9a8",
  "#c5c8c4",
  "#dad9d4",
  "#434341",
  "#636562",
  "#7f817e",
  "#939591",
  "#a7a8a2",
  "#bdbdb7",
  "#cbccc9",
  "#585858",
  "#7f7b73",
  "#b2ada4",
  "#beb9b0",
  "#cbc7bf",
  "#484c49",
  "#63655f",
  "#7c7d75",
  "#92948d",
  "#a3a7a0",
  "#b2b5af",
  "#c8cbc4",
  "#f2eac3",
  "#9e6b75",
  "#ae8087",
  "#c79ea2",
  "#dabdc1",
  "#e8d4d5",
  "#864c52",
  "#995d62",
  "#a87376",
  "#c39393",
  "#dcb6b5",
  "#ebd1cf",
  "#974953",
  "#ad5e65",
  "#ba7176",
  "#cf8a8d",
  "#e6bdbd",
  "#edd3d2",
  "#8e3738",
  "#b56966",
  "#c37f7a",
  "#cd8e89",
  "#ebcecb",
  "#7b3730",
  "#a0584f",
  "#bf796e",
  "#cd8e7f",
  "#e3b5a8",
  "#ebcfc3",
  "#83382a",
  "#a85e53",
  "#b57466",
  "#ce9382",
  "#e2b6a7",
  "#eacdc1",
  "#994b35",
  "#c1785c",
  "#d9987c",
  "#e4b9a2",
  "#edd2c0",
  "#a2583a",
  "#b46848",
  "#c47b5b",
  "#db9c7b",
  "#e5b99b",
  "#eccfbb",
  "#a6613c",
  "#c38058",
  "#d4966e",
  "#dba480",
  "#e0b392",
  "#ebccb3",
  "#cd8c5d",
  "#d69969",
  "#e3ab7b",
  "#e8be9b",
  "#edd0b6",
  "#b16a37",
  "#f0cb97",
  "#f3d9ba",
  "#b67d3c",
  "#c78538",
  "#d59858",
  "#e8b87f",
  "#edc38e",
  "#f2d5b0",
  "#ba7f38",
  "#cc9249",
  "#d69e59",
  "#ddac6d",
  "#edc796",
  "#a57955",
  "#ba8c64",
  "#cca683",
  "#e4caad",
  "#a4763c",
  "#c09056",
  "#efddc1",
  "#906a3a",
  "#ad8451",
  "#c19763",
  "#cba576",
  "#d2b084",
  "#dcbd92",
  "#e4ceac",
  "#9c7a56",
  "#b39167",
  "#ba9c75",
  "#c5aa85",
  "#cdb592",
  "#dbc7a8",
  "#996f32",
  "#aa803a",
  "#c99e53",
  "#d5b176",
  "#e1c28d",
  "#e9d6b0",
  "#9c7f41",
  "#b89b59",
  "#c2a462",
  "#d2ba83",
  "#dcc797",
  "#e4d0a5",
  "#7a6841",
  "#9d8344",
  "#b1975f",
  "#bea775",
  "#cbb584",
  "#ddcda6",
  "#655f2d",
  "#8d844d",
  "#9c9152",
  "#c4b47d",
  "#cfc291",
  "#dfd4b0",
  "#71713e",
  "#95945c",
  "#aeac7a",
  "#bbb98a",
  "#cbc99d",
  "#e0ddbd",
  "#576238",
  "#6d7645",
  "#88915d",
  "#9ba373",
  "#dbddbd",
  "#475842",
  "#60724f",
  "#8fa277",
  "#a3b48c",
  "#c5d1b2",
  "#dae2cd",
  "#42603c",
  "#5e7f57",
  "#75946b",
  "#8ba97f",
  "#b3cbaa",
  "#cfddc7",
  "#205134",
  "#537150",
  "#6c8867",
  "#98b092",
  "#acc2a8",
  "#c8d8c4",
  "#3d5541",
  "#61826c",
  "#7d9b89",
  "#91af9d",
  "#aac2b3",
  "#c6d5c9",
  "#2a4f43",
  "#547867",
  "#94b5a6",
  "#accabc",
  "#c4d9ce",
  "#124a42",
  "#476f65",
  "#7ea298",
  "#94b2a6",
  "#a8c1b7",
  "#bfd2c9",
  "#01554f",
  "#2e6864",
  "#518682",
  "#8caeab",
  "#a3c0bd",
  "#b4ccc9",
  "#c3d7d3",
  "#016367",
  "#3c797d",
  "#5c9598",
  "#7bb1b2",
  "#bedbd8",
  "#015a6b",
  "#217786",
  "#5b96a2",
  "#84b4be",
  "#b0d2d6",
  "#c7dfe0",
  "#175a6c",
  "#427584",
  "#68909d",
  "#88abb4",
  "#9fbbc3",
  "#c7d8db",
  "#015d75",
  "#2f778b",
  "#5b92a2",
  "#83afbc",
  "#9bbfc9",
  "#c5dce0",
  "#01455e",
  "#22657f",
  "#5389a1",
  "#85b0c4",
  "#a9c9d7",
  "#c2dae0",
  "#215772",
  "#43718b",
  "#6a8ea1",
  "#97b4c3",
  "#b3c9d3",
  "#506b84",
  "#6a8aa4",
  "#8ba7bb",
  "#b2c7d3",
  "#ced9dd",
  "#3b496d",
  "#6c7f9a",
  "#8595aa",
  "#99a7b8",
  "#cbd5db",
  "#3b3c5a",
  "#5d657b",
  "#757c91",
  "#99a0b2",
  "#bdc3cd",
  "#d6d9de",
  "#3e385a",
  "#645e77",
  "#7e778e",
  "#a29baa",
  "#c5c0c9",
  "#dad6db",
  "#7a6b85",
  "#9a8ca2",
  "#b0a3b6",
  "#d1c6d2",
  "#e0dadf",
  "#5f3f54",
  "#7e5a6d",
  "#8b6878",
  "#aa8e9a",
  "#cbb8c0",
  "#dbcfd4",
  "#665d57",
  "#6d6562",
  "#847b77",
  "#9e9793",
  "#ada8a5",
  "#cfcac7",
  "#48423c",
  "#dcd8d0",
  "#564537",
  "#6f6459",
  "#867a6f",
  "#aba39a",
  "#b9b2a9",
  "#ccc5bd",
  "#756861",
  "#a09287",
  "#b7ab9f",
  "#c1b6ab",
  "#d4ccc3",
  "#564536",
  "#716354",
  "#8a7a6a",
  "#a0907f",
  "#b1a290",
  "#c0b2a2",
  "#d1c7b8",
  "#4d3930",
  "#826f5e",
  "#917c6a",
  "#c5b6a4",
  "#cdbfb0",
  "#dbcebd",
  "#443735",
  "#755c48",
  "#a48d77",
  "#d8c4ae",
  "#443735",
  "#5f3d3f",
  "#76595d",
  "#907676",
  "#b89d9a",
  "#c9b0ab",
  "#d6c2be",
  "#5a3532",
  "#7a5f5a",
  "#a08882",
  "#b6a09a",
  "#c3b1ac",
  "#d7c8c2",
  "#5a382d",
  "#806257",
  "#a2877d",
  "#b8a196",
  "#c6b3a9",
  "#d6c8c0",
  "#5d3831",
  "#9c6e63",
  "#a8857a",
  "#cfb4a8",
  "#dbc7bd",
  "#694336",
  "#896656",
  "#ae8e7e",
  "#c1a392",
  "#d1b7a8",
  "#decabd",
  "#4f3426",
  "#715243",
  "#967a6a",
  "#a58c7b",
  "#bba595",
  "#cbb9ab",
  "#634533",
  "#785b47",
  "#8e725f",
  "#9c8373",
  "#b59f8f",
  "#d6c7b9",
  "#403330",
  "#7a6455",
  "#907865",
  "#a08e7e",
  "#b5a597",
  "#c2b4a7",
  "#d3c8bd",
  "#604c3d",
  "#785f4c",
  "#917864",
  "#a58f7b",
  "#b9a796",
  "#c6b5a7",
  "#d5c7ba",
  "#69482c",
  "#815d40",
  "#a3846c",
  "#bfa38d",
  "#cab3a0",
  "#dac8b8",
  "#65503d",
  "#947a62",
  "#bca38b",
  "#c9b29c",
  "#d7c5b3",
  "#765138",
  "#c5a88d",
  "#dcc7b3",
  "#b99974",
  "#cfb597",
  "#dcc7ad",
  "#70573f",
  "#9e8163",
  "#a78c71",
  "#baa185",
  "#c7b198",
  "#d7c5ae",
  "#695239",
  "#8f7659",
  "#a08568",
  "#c0ad96",
  "#cfbea9",
  "#dfd3c3",
  "#855d42",
  "#ab8b6e",
  "#caad87",
  "#dabe9e",
  "#e1cdae",
  "#f1dbbd",
  "#6e543c",
  "#867057",
  "#947f65",
  "#ccb79b",
  "#dacab2",
  "#786957",
  "#8e7f6a",
  "#a4947e",
  "#b8a992",
  "#c8bba3",
  "#d9cfba",
  "#9a815e",
  "#ac9571",
  "#b9a47e",
  "#c6b08a",
  "#d0ba94",
  "#e0cfb0",
  "#665439",
  "#877459",
  "#9f8e71",
  "#b19f80",
  "#cdbb9c",
  "#ddd0b6",
  "#5d513e",
  "#7e6f59",
  "#998970",
  "#ac9d83",
  "#c1ae91",
  "#cdbda2",
  "#5a5243",
  "#726b5b",
  "#b0ab9c",
  "#bfb9aa",
  "#d1cdbf",
  "#5e5949",
  "#898473",
  "#b2ac96",
  "#d1ccb9",
  "#4f523a",
  "#65684c",
  "#7f8266",
  "#acad97",
  "#bbbca7",
  "#cecebd",
  "#465448",
  "#626e60",
  "#7a8775",
  "#9fa694",
  "#bdc0b3",
  "#d1d3c7",
  "#4e5147",
  "#7b8070",
  "#95978a",
  "#abac9f",
  "#bebfb2",
  "#d1d0c6",
  "#64645a",
  "#7f7e72",
  "#949488",
  "#a6a69b",
  "#b6b5ab",
  "#c9c9c0",
  "#5e6259",
  "#7a8076",
  "#969c92",
  "#bec3bb",
  "#cdd2ca",
  "#343b36",
  "#5e706a",
  "#7c8e87",
  "#8d9e97",
  "#9baaa2",
  "#adbbb2",
  "#4a5d5f",
  "#5d7274",
  "#7a9192",
  "#8b9fa0",
  "#9bafb2",
  "#abbebf",
  "#c2cfcf",
  "#244653",
  "#607d84",
  "#80969d",
  "#96aab0",
  "#a4b7bd",
  "#bccbce",
  "#204652",
  "#536872",
  "#6f848c",
  "#90a0a6",
  "#a6b2b5",
  "#b6c3c4",
  "#cbd4d4",
  "#23383f",
  "#596368",
  "#91999c",
  "#a9b0b1",
  "#b8bebe",
  "#cdd2d2",
  "#32586e",
  "#4e7287",
  "#708d9e",
  "#8aa3b1",
  "#9eb4c0",
  "#b7c9d1",
  "#c9d9e0",
  "#2f3d4c",
  "#5d6f7f",
  "#768b9a",
  "#98a9b7",
  "#aabac6",
  "#bfc9d0",
  "#606b75",
  "#7a848d",
  "#979fa5",
  "#adb5b9",
  "#b8c0c3",
  "#cad0d2",
  "#605e63",
  "#7b787d",
  "#949194",
  "#bdb8b8",
  "#cfc9c8",
  "#443e40",
  "#676064",
  "#837d7f",
  "#989192",
  "#ada5a5",
  "#4a4653",
  "#5d5962",
  "#736f78",
  "#8f8a91",
  "#a6a3a9",
  "#b5b1b5",
  "#cbc9c9",
  "#4e4247",
  "#695c62",
  "#9d9093",
  "#afa7ac",
  "#bdb5b9",
  "#cec9cc",
  "#4e3132",
  "#6f5c5f",
  "#8b7c7e",
  "#b3a3a5",
  "#c1b2b3",
  "#d1c5c4",
  "#4d3c3c",
  "#6e615f",
  "#867875",
  "#9f9291",
  "#b1a3a1",
  "#c2b6b6",
  "#56433b",
  "#756761",
  "#8c7e78",
  "#ac9e97",
  "#bfb1aa",
  "#d1c5be",
  "#827466",
  "#9c8a79",
  "#a79582",
  "#b3a491",
  "#c4b7a5",
  "#5f4b3f",
  "#907d66",
  "#b7a48b",
  "#c0af97",
  "#dfd2bf",
  "#74685a",
  "#9e9284",
  "#ada295",
  "#bfb6aa",
  "#d1cbc1",
  "#4f4842",
  "#78736e",
  "#908a83",
  "#aca79e",
  "#bcb7ad",
  "#ccc9c0",
  "#54504a",
  "#6b645b",
  "#817a6e",
  "#979083",
  "#a8a093",
  "#cec6bb",
  "#645a4b",
  "#867e70",
  "#958d7f",
  "#cfcabd",
  "#7d745e",
  "#bcb099",
  "#cbc0ad",
  "#dbd0bb",
  "#f7f7f1",
  "#f5f2e9",
  "#f3eee3",
  "#eeece3",
  "#eeefea",
  "#edece6",
  "#e5e2da",
  "#e3ddd3",
  "#e3ded0",
  "#e5dfd2",
  "#e6dfd3",
  "#e2daca",
  "#dcd1bf",
  "#dcd2c3",
  "#dfd9cf",
  "#e3ded7",
  "#e2ded8",
  "#e7e2da",
  "#eeefeb",
  "#ecece7",
  "#f6f0e2",
  "#f0ece2",
  "#edeae0",
  "#f0eadc",
  "#efe8db",
  "#e8e2d4",
  "#e8dfca",
  "#f4e8d2",
  "#f2e3ca",
  "#f2e5cf",
  "#ede1ce",
  "#dccfba",
  "#e6dccd",
  "#e9decf",
  "#e9dcc6",
  "#e8dcc6",
  "#eadfc9",
  "#e2d3bf",
  "#e7d7c2",
  "#e9ebe7",
  "#f1eee6",
  "#f4efe5",
  "#f7efe3",
  "#f0ebe0",
  "#e3e4e1",
  "#dedfdc",
  "#d8e0df",
  "#e3e2d9",
  "#e2e0d6",
  "#e8e3d9",
  "#edeae5",
  "#eee9e0",
  "#e6ddd5",
  "#f2ece6",
  "#e7dbd3",
  "#edddca",
  "#f0e1d0",
  "#f3e9d7",
  "#efe8dd",
  "#cfcac7",
  "#ada8a5",
  "#847b77",
  "#6d6562",
  "#403330",
  "#c2b6b6",
  "#b1a3a1",
  "#867875",
  "#6e615f",
  "#4d3c3c",
  "#d1c5c4",
  "#c1b2b3",
  "#b3a3a5",
  "#8b7c7e",
  "#6f5c5f",
  "#4e3132",
  "#d6c2be",
  "#c9b0ab",
  "#b89d9a",
  "#907676",
  "#76595d",
  "#5f3d3f",
  "#d7c8c2",
  "#c3b1ac",
  "#b6a09a",
  "#7a5f5a",
  "#5a3532",
  "#d1c5be",
  "#bfb1aa",
  "#ac9e97",
  "#8c7e78",
  "#756761",
  "#56433b",
  "#d6c8c0",
  "#c6b3a9",
  "#b8a196",
  "#806257",
  "#5a382d",
  "#e7dbd3",
  "#dbc7bd",
  "#cfb4a8",
  "#9c6e63",
  "#5d3831",
  "#decabd",
  "#d1b7a8",
  "#c1a392",
  "#896656",
  "#694336",
  "#e6ddd5",
  "#cbb9ab",
  "#bba595",
  "#967a6a",
  "#715243",
  "#4f3426",
  "#d4ccc3",
  "#c1b6ab",
  "#b7ab9f",
  "#756861",
  "#4d3930",
  "#d3c8bd",
  "#c2b4a7",
  "#b5a597",
  "#907865",
  "#7a6455",
  "#5f4b3f",
  "#d6c7b9",
  "#b59f8f",
  "#8e725f",
  "#785b47",
  "#634533",
  "#dac8b8",
  "#cab3a0",
  "#bfa38d",
  "#815d40",
  "#69482c",
  "#d7c5b3",
  "#c9b29c",
  "#bca38b",
  "#947a62",
  "#65503d",
  "#e6dccd",
  "#d7c5ae",
  "#c7b198",
  "#baa185",
  "#9e8163",
  "#70573f",
  "#e4caad",
  "#cca683",
  "#ba8c64",
  "#a57955",
  "#e8dcc6",
  "#dbc7a8",
  "#cdb592",
  "#c5aa85",
  "#b39167",
  "#9c7a56",
  "#e9dcc6",
  "#e4ceac",
  "#dcbd92",
  "#d2b084",
  "#c19763",
  "#ad8451",
  "#906a3a",
  "#eadfc9",
  "#e0cfb0",
  "#d0ba94",
  "#c6b08a",
  "#ac9571",
  "#9a815e",
  "#e9decf",
  "#dacab2",
  "#ccb79b",
  "#947f65",
  "#867057",
  "#6e543c",
  "#d9cfba",
  "#c8bba3",
  "#b8a992",
  "#8e7f6a",
  "#786957",
  "#e8e2d4",
  "#cdbda2",
  "#c1ae91",
  "#998970",
  "#7e6f59",
  "#5d513e",
  "#d1ccb9",
  "#b2ac96",
  "#898473",
  "#5e5949",
  "#d1cdbf",
  "#bfb9aa",
  "#b0ab9c",
  "#726b5b",
  "#cecebd",
  "#bbbca7",
  "#acad97",
  "#7f8266",
  "#65684c",
  "#4f523a",
  "#e3e2d9",
  "#d1d0c6",
  "#bebfb2",
  "#abac9f",
  "#7b8070",
  "#4e5147",
  "#d1d3c7",
  "#bdc0b3",
  "#9fa694",
  "#7a8775",
  "#626e60",
  "#465448",
  "#c9c9c0",
  "#b6b5ab",
  "#a6a69b",
  "#7f7e72",
  "#64645a",
  "#cdd2ca",
  "#bec3bb",
  "#7a8076",
  "#5e6259",
  "#adbbb2",
  "#9baaa2",
  "#7c8e87",
  "#5e706a",
  "#343b36",
  "#c2cfcf",
  "#abbebf",
  "#9bafb2",
  "#7a9192",
  "#5d7274",
  "#4a5d5f",
  "#d8e0df",
  "#bccbce",
  "#a4b7bd",
  "#96aab0",
  "#607d84",
  "#244653",
  "#cdd2d2",
  "#b8bebe",
  "#a9b0b1",
  "#596368",
  "#23383f",
  "#dbdfe0",
  "#bfc9d0",
  "#aabac6",
  "#98a9b7",
  "#768b9a",
  "#5d6f7f",
  "#2f3d4c",
  "#cad0d2",
  "#b8c0c3",
  "#adb5b9",
  "#7a848d",
  "#606b75",
  "#e3e4e1",
  "#d4d8d7",
  "#bec1c3",
  "#a8aeb1",
  "#7d848b",
  "#2f2f30",
  "#cbc9c9",
  "#b5b1b5",
  "#a6a3a9",
  "#736f78",
  "#5d5962",
  "#4a4653",
  "#cec9cc",
  "#bdb5b9",
  "#afa7ac",
  "#695c62",
  "#4e4247",
  "#cfc9c8",
  "#bdb8b8",
  "#7b787d",
  "#605e63",
  "#dbcfd4",
  "#cbb8c0",
  "#aa8e9a",
  "#8b6878",
  "#7e5a6d",
  "#5f3f54",
  "#e8d4d5",
  "#dabdc1",
  "#c79ea2",
  "#9e6b75",
  "#ebd1cf",
  "#dcb6b5",
  "#c39393",
  "#995d62",
  "#864c52",
  "#edd3d2",
  "#e6bdbd",
  "#cf8a8d",
  "#ad5e65",
  "#974953",
  "#ebcecb",
  "#cd8e89",
  "#b56966",
  "#8e3738",
  "#ebcfc3",
  "#e3b5a8",
  "#cd8e7f",
  "#a0584f",
  "#7b3730",
  "#eacdc1",
  "#e2b6a7",
  "#ce9382",
  "#a85e53",
  "#83382a",
  "#edd2c0",
  "#e4b9a2",
  "#d9987c",
  "#c1785c",
  "#994b35",
  "#eccfbb",
  "#e5b99b",
  "#db9c7b",
  "#c47b5b",
  "#b46848",
  "#a2583a",
  "#edddca",
  "#ebccb3",
  "#e0b392",
  "#d4966e",
  "#c38058",
  "#a6613c",
  "#f0e1d0",
  "#edd0b6",
  "#e8be9b",
  "#d69969",
  "#cd8c5d",
  "#f3d9ba",
  "#f0cb97",
  "#f2e3ca",
  "#f2d5b0",
  "#edc38e",
  "#d59858",
  "#c78538",
  "#b67d3c",
  "#edc796",
  "#ddac6d",
  "#d69e59",
  "#cc9249",
  "#ba7f38",
  "#f0eadc",
  "#efddc1",
  "#c09056",
  "#a4763c",
  "#e9d6b0",
  "#e1c28d",
  "#c99e53",
  "#aa803a",
  "#996f32",
  "#e4d0a5",
  "#d2ba83",
  "#c2a462",
  "#b89b59",
  "#9c7f41",
  "#ddcda6",
  "#cbb584",
  "#b1975f",
  "#9d8344",
  "#7a6841",
  "#dfd4b0",
  "#cfc291",
  "#9c9152",
  "#8d844d",
  "#655f2d",
  "#e0ddbd",
  "#cbc99d",
  "#aeac7a",
  "#95945c",
  "#71713e",
  "#dbddbd",
  "#88915d",
  "#6d7645",
  "#576238",
  "#dae2cd",
  "#c5d1b2",
  "#a3b48c",
  "#60724f",
  "#475842",
  "#cfddc7",
  "#b3cbaa",
  "#8ba97f",
  "#5e7f57",
  "#42603c",
  "#c8d8c4",
  "#acc2a8",
  "#98b092",
  "#6c8867",
  "#537150",
  "#205134",
  "#c6d5c9",
  "#aac2b3",
  "#91af9d",
  "#61826c",
  "#3d5541",
  "#c4d9ce",
  "#accabc",
  "#94b5a6",
  "#547867",
  "#2a4f43",
  "#bfd2c9",
  "#a8c1b7",
  "#7ea298",
  "#476f65",
  "#124a42",
  "#c3d7d3",
  "#b4ccc9",
  "#8caeab",
  "#518682",
  "#2e6864",
  "#01554f",
  "#bedbd8",
  "#7bb1b2",
  "#5c9598",
  "#3c797d",
  "#016367",
  "#c7dfe0",
  "#b0d2d6",
  "#84b4be",
  "#5b96a2",
  "#217786",
  "#015a6b",
  "#c5dce0",
  "#83afbc",
  "#5b92a2",
  "#2f778b",
  "#015d75",
  "#c2dae0",
  "#a9c9d7",
  "#85b0c4",
  "#5389a1",
  "#22657f",
  "#01455e",
  "#b3c9d3",
  "#97b4c3",
  "#6a8ea1",
  "#43718b",
  "#215772",
  "#ced9dd",
  "#b2c7d3",
  "#8ba7bb",
  "#6a8aa4",
  "#506b84",
  "#cbd8e1",
  "#b2c8d8",
  "#8ea9c2",
  "#6b8ca9",
  "#4c6b8a",
  "#cbd5db",
  "#99a7b8",
  "#6c7f9a",
  "#3b496d",
  "#d6d9de",
  "#bdc3cd",
  "#99a0b2",
  "#757c91",
  "#5d657b",
  "#3b3c5a",
  "#dad6db",
  "#c5c0c9",
  "#a29baa",
  "#7e778e",
  "#645e77",
  "#3e385a",
  "#e0dadf",
  "#d1c6d2",
  "#b0a3b6",
  "#7a6b85",
  "#ebd1db",
  "#e3c0cf",
  "#cb9aad",
  "#b87e93",
  "#92576f",
  "#7c3655",
  "#d899b1",
  "#c47b95",
  "#a2566f",
  "#854158",
  "#f1d3da",
  "#efc0cb",
  "#e392a1",
  "#d47c8c",
  "#b04b63",
  "#99324e",
  "#f1d2d7",
  "#f0bcc9",
  "#f2d5d7",
  "#f0c1c6",
  "#ed939d",
  "#d66972",
  "#bb4b51",
  "#f1c6c4",
  "#f0b3b2",
  "#ed9190",
  "#d76c6e",
  "#a43834",
  "#f2ccc5",
  "#f0afa8",
  "#ee9489",
  "#d9766c",
  "#a13b34",
  "#f2d1c3",
  "#f2b8a7",
  "#e79580",
  "#d87b6a",
  "#b85444",
  "#f0d1c3",
  "#f3c1ab",
  "#e49780",
  "#dd7861",
  "#c65f47",
  "#b44b34",
  "#e2946f",
  "#d67c56",
  "#c4633e",
  "#f3d3bf",
  "#f3c1a3",
  "#f4d3b3",
  "#f4c69f",
  "#e6955f",
  "#cb7841",
  "#c36f3e",
  "#f4d4af",
  "#f5c894",
  "#efb57a",
  "#e69f5f",
  "#f5d6a9",
  "#f4bf77",
  "#ebad5e",
  "#df9938",
  "#f5deaf",
  "#fbcb78",
  "#f7be5b",
  "#f2af46",
  "#e39a33",
  "#f5e0b1",
  "#f6dda3",
  "#f5e5bc",
  "#f5d68f",
  "#eec25f",
  "#d6a02b",
  "#c48919",
  "#f3e8c2",
  "#f5e1ac",
  "#f7d78a",
  "#eac365",
  "#dbb04a",
  "#d1a436",
  "#c49832",
  "#eee3b2",
  "#e6d88e",
  "#d9c661",
  "#c4b146",
  "#ac9825",
  "#9c8b1f",
  "#e9e5b3",
  "#dad790",
  "#c4c476",
  "#b4b05a",
  "#847e35",
  "#c0d2ad",
  "#99c285",
  "#7fac6e",
  "#4f854a",
  "#2f5f3a",
  "#cce2ca",
  "#aed2b0",
  "#8ec298",
  "#68a678",
  "#245e36",
  "#d1e3d2",
  "#b7d7bf",
  "#8ac1a1",
  "#57aa80",
  "#016844",
  "#c0e3da",
  "#a1d4c8",
  "#70baa7",
  "#53a38f",
  "#368976",
  "#c1e6df",
  "#a1d5cb",
  "#75b9ae",
  "#3b8c80",
  "#c2e5e5",
  "#a7dcdc",
  "#6ec2c4",
  "#3aa9ae",
  "#01858b",
  "#017478",
  "#a6d0d6",
  "#7dc1cb",
  "#4da6b2",
  "#08808e",
  "#01717e",
  "#c6e3e8",
  "#a6d4de",
  "#71b8c7",
  "#34a3b6",
  "#016e85",
  "#b4e0e7",
  "#8fd0dd",
  "#56b5ca",
  "#01a0b8",
  "#01819e",
  "#016081",
  "#b7dfe8",
  "#a2d5e7",
  "#5db3d4",
  "#289ec4",
  "#017ca7",
  "#015d87",
  "#c3dfe8",
  "#b0d6e6",
  "#7db5d3",
  "#5a9ec0",
  "#2377a2",
  "#ccdbe5",
  "#b8cddd",
  "#97b3d0",
  "#7498be",
  "#4e739f",
  "#164576",
  "#d8dde6",
  "#a7b2d4",
  "#8b98c4",
  "#6572a5",
  "#3e4371",
  "#dfd9e4",
  "#d1cbdf",
  "#bdb4d4",
  "#968db8",
  "#716998",
  "#4d426e",
  "#dfdce5",
  "#d2c8dd",
  "#c0afd0",
  "#a18ab7",
  "#7e6596",
  "#624977",
  "#e5dbe5",
  "#dac7da",
  "#c2a4c2",
  "#a785a7",
  "#7c5a7e",
  "#5d395f",
  "#c35530",
  "#f5e1a6",
  "#fad97a",
  "#ffc723",
  "#f7e594",
  "#fed340",
  "#fecb01",
  "#edd26f",
  "#ddb835",
  "#cba901",
  "#3b373c",
  "#313031",
  "#f2ece6",
  "#eee9e0",
  "#efe8dd",
  "#e7e2da",
  "#edeae5",
  "#edece6",
  "#eeefea",
  "#e9ebe7",
  "#edeae0",
  "#e8e3d9",
  "#e5dfd2",
  "#e3ded0",
  "#efe8db",
  "#e2ded8",
  "#ccc9c0",
  "#bcb7ad",
  "#aca79e",
  "#908a83",
  "#78736e",
  "#4f4842",
  "#ccc5bd",
  "#b9b2a9",
  "#aba39a",
  "#867a6f",
  "#6f6459",
  "#564537",
  "#e3ded7",
  "#d1cbc1",
  "#bfb6aa",
  "#ada295",
  "#74685a",
  "#e3ddd3",
  "#d1c7b8",
  "#c0b2a2",
  "#b1a290",
  "#8a7a6a",
  "#716354",
  "#564536",
  "#e6dfd3",
  "#cec6bb",
  "#a8a093",
  "#817a6e",
  "#6b645b",
  "#54504a",
  "#e2e0d6",
  "#cfcabd",
  "#867e70",
  "#645a4b",
  "#c8cbc4",
  "#b2b5af",
  "#a3a7a0",
  "#7c7d75",
  "#63655f",
  "#484c49",
  "#dedfdc",
  "#cbccc9",
  "#bdbdb7",
  "#a7a8a2",
  "#7f817e",
  "#636562",
  "#434341",
  "#c6caca",
  "#b0b5b5",
  "#a0a5a7",
  "#7f8486",
  "#616669",
  "#44484d",
  "#ada5a5",
  "#837d7f",
  "#676064",
  "#443e40",
  "#f4efe5",
  "#f7efe3",
  "#9e9284",
  "#665d57",
  "#c4b7a5",
  "#b3a491",
  "#9c8a79",
  "#826f5e",
  "#cdbfb0",
  "#c5b6a4",
  "#a79582",
  "#827466",
  "#6e5f53",
  "#dbcebd",
  "#dfd2bf",
  "#d4c5ad",
  "#dcd1bf",
  "#c0af97",
  "#b7a48b",
  "#cbc0ad",
  "#bcb099",
  "#ac9d83",
  "#63523d",
  "#907d66",
  "#f0ece2",
  "#e2d3bf",
  "#f4e8d2",
  "#f3e9d7",
  "#f2e5cf",
  "#f6f0e2",
  "#e8dfca",
  "#dbd0bb",
  "#f3eee3",
  "#dcd2c3",
  "#e2daca",
  "#dccfba",
  "#dfd9cf",
  "#ede1ce",
  "#e7d7c2",
  "#72353d",
  "#813235",
  "#a42e37",
  "#b8473d",
  "#7c453d",
  "#903934",
  "#3e5063",
  "#b0b8b2",
  "#606e74",
  "#e5e2da",
  "#c0b9a9",
  "#aea594",
  "#c6c0b6",
  "#b2ada4",
  "#dad9d4",
  "#abb0ac",
  "#c5c8c4",
  "#a5a9a8",
  "#969a96",
  "#d3d5d3",
  "#b8bcbb",
  "#90979b",
  "#656d73",
  "#585858",
  "#48423c",
  "#e1cdae",
  "#cba97e",
  "#caad87",
  "#ac6b53",
  "#b0785c",
  "#b16a37",
  "#d8c4ae",
  "#b9b292",
  "#857c5d",
  "#7d745e",
  "#5a5243",
  "#bdc0a0",
  "#f7f7f1",
  "#ae8087",
  "#a87376",
  "#ba7176",
  "#c37f7a",
  "#bf796e",
  "#b57466",
  "#f2b88c",
  "#dba480",
  "#e3ab7b",
  "#e8b87f",
  "#eeb76b",
  "#fbd187",
  "#fedf94",
  "#fbd682",
  "#fbd073",
  "#f4c454",
  "#cba576",
  "#ba9c75",
  "#d5b176",
  "#dcc797",
  "#bea775",
  "#c4b47d",
  "#d2d083",
  "#abca99",
  "#78b185",
  "#9fcdb1",
  "#bbb98a",
  "#9ba373",
  "#8fa277",
  "#75946b",
  "#7d9b89",
  "#89c6b7",
  "#8ac5ba",
  "#92d0d0",
  "#97cbd2",
  "#8bc4d1",
  "#89c6df",
  "#94b2a6",
  "#a3c0bd",
  "#c7d8db",
  "#9fbbc3",
  "#88abb4",
  "#68909d",
  "#427584",
  "#175a6c",
  "#9bbfc9",
  "#bbc5de",
  "#8595aa",
  "#9a8ca2",
  "#a08882",
  "#a2877d",
  "#a8857a",
  "#ae8e7e",
  "#a58c7b",
  "#9c8373",
  "#a08e7e",
  "#d5c7ba",
  "#c6b5a7",
  "#b9a796",
  "#a58f7b",
  "#917864",
  "#785f4c",
  "#604c3d",
  "#a3846c",
  "#dcc7b3",
  "#c5a88d",
  "#765138",
  "#dcc7ad",
  "#cfb597",
  "#b99974",
  "#a78c71",
  "#dfd3c3",
  "#cfbea9",
  "#c0ad96",
  "#a08568",
  "#8f7659",
  "#695239",
  "#a4947e",
  "#b9a47e",
  "#ddd0b6",
  "#cdbb9c",
  "#b19f80",
  "#9f8e71",
  "#877459",
  "#665439",
  "#95978a",
  "#949488",
  "#969c92",
  "#8d9e97",
  "#8b9fa0",
  "#80969d",
  "#cbd4d4",
  "#b6c3c4",
  "#a6b2b5",
  "#90a0a6",
  "#6f848c",
  "#536872",
  "#204652",
  "#91999c",
  "#c9d9e0",
  "#b7c9d1",
  "#9eb4c0",
  "#8aa3b1",
  "#708d9e",
  "#4e7287",
  "#32586e",
  "#979fa5",
  "#949194",
  "#989192",
  "#8f8a91",
  "#9d9093",
  "#9f9291",
  "#939899",
  "#939591",
  "#92948d",
  "#dcd8d0",
  "#9e9793",
  "#a09287",
  "#979083",
  "#958d7f",
  "#a0907f",
  "#2b4360",
  "#234058",
  "#cbc6b7",
  "#aaa28b",
  "#dbd6b9",
  "#ffffff",
  "#292929",
  "#46423a",
  "#c6c2be",
  "#c4b499",
  "#f3f3f3",
  "#dccebe",
  "#3e3d40",
  "#5f251f",
  "#514432",
  "#eeece8",
  "#b1a698",
  "#00412d",
  "#454b4d",
  "#7b685a",
  "#9c8e7e",
  "#ededec",
  "#a8a6a2",
  "#c2b4a0",
  "#c2b4a0",
  "#554f49",
  "#030303",
  "#a59989",
  "#fefffc",
  "#3e2d0f",
  "#776154",
  "#7e8285",
  "#ffffff",
  "#40190a",
  "#a09174",
  "#c9c6b5",
  "#fcecd2",
  "#e8dccd",
  "#d5c8b0",
  "#2c2b2a",
  "#593033",
  "#f4f6f7",
  "#743d36",
  "#d3cdbd",
  "#2c4452",
  "#9d9388",
  "#beae99",
  "#a1917f",
  "#a49789",
  "#fdf1d4",
  "#e2cca9",
  "#513c35",
  "#3c574b",
  "#cabb9f",
  "#bdbebf",
  "#e5e3d2",
  "#16363f",
  "#254035",
  "#3b3837",
  "#d1d2d4",
  "#f7f3e4",
  "#d3c5ad",
  "#fff6e4",
  "#e0c5a1",
  "#c6b09a",
  "#4c4846",
  "#587278",
  "#f5f5f4",
  "#f5faf2",
  "#c1ae9a",
  "#602c30",
  "#f5eace",
  "#212121",
  "#4b392f",
  "#e0d6bd",
  "#2d4e43",
  "#bbac97",
  "#656158",
  "#f8fcff",
  "#63574c",
  "#8d9093",
  "#5e6567",
  "#925f42",
  "#cccec8",
  "#a5a8a3",
  "#f6f1e6",
  "#c0c7bc",
  "#efe9e0",
  "#fff3d1",
  "#a7aa9e",
  "#a4aaad",
  "#5a5850",
  "#a59c87",
  "#63554f",
  "#b5a091",
  "#8d9484",
  "#948671",
  "#798689",
  "#e2e3e4",
  "#9aa29b",
  "#567d96",
  "#c2b59b",
  "#9ab5c6",
  "#4f5736",
  "#a99573",
  "#343c44",
  "#baaf9b",
  "#534f4e",
  "#98afc1",
  "#c06050",
  "#edeee6",
  "#51605b",
  "#c6b89e",
  "#74676e",
  "#747c65",
  "#616161",
  "#e98b43",
  "#a1965c",
  "#dccaa2",
  "#736f66",
  "#7e6958",
  "#3d5847",
  "#f5cf46",
  "#9f978c",
  "#c3914c",
  "#8d473d",
  "#aca39c",
  "#a1a29d",
  "#41504d",
  "#8f6b51",
  "#6a7780",
  "#ebe2d3",
  "#675e59",
  "#4a494e",
  "#544645",
  "#e5e5e3",
  "#9c8a74",
  "#98887b",
  "#6f4b4b",
  "#e1dbcb",
  "#a79b8d",
  "#ac393e",
  "#70403e",
  "#e6e6de",
  "#00639c",
  "#e9c66c",
  "#3e3e3e",
  "#455f6e",
  "#c6bdac",
  "#0b8a93",
  "#414f69",
  "#f3dfc6",
  "#12221d",
  "#60605e",
  "#422b19",
  "#a29788",
  "#66685e",
  "#f0efee",
  "#ada590",
  "#52504d",
  "#567d96",
  "#934f45",
  "#6b7669",
  "#616c64",
  "#36393A",
  "#E6E7D8",
  "#832930",
  "#B23643",
  "#AA5154",
  "#C23F4B",
  "#D86165",
  "#4D3F33",
  "#52463B",
  "#6A4E36",
  "#70563E",
  "#7F5832",
  "#956133",
  "#986735",
  "#906A46",
  "#A96B2B",
  "#C07722",
  "#C27B2E",
  "#CE8121",
  "#D88A30",
  "#E09851",
  "#E6A96F",
  "#C5B5A7",
  "#DFC6B0",
  "#D8CBC0",
  "#ECDBCD",
  "#F0E8DF",
  "#EFE5DC",
  "#EFE4DA",
  "#F1E4D7",
  "#F4E5D7",
  "#B4CBD9",
  "#005E63",
  "#2D3D33",
  "#97D5B1",
  "#9D4F84",
  "#603231",
  "#86252B",
  "#EB8621",
  "#F2ECE5",
  "#E1E7EA",
  "#008C5D",
  "#BDBBDA",
  "#D185B7",
  "#862A2E",
  "#DCA29E",
  "#7C2829",
  "#D4C5B6",
  "#DFD0C2",
  "#E1CFBE",
  "#F2E6DB",
  "#67A0C1",
  "#A1C9E3",
  "#BEE1E2",
  "#EEEFE8",
  "#DBD8E7",
  "#867E7D",
  "#B97A77",
  "#EAE8E5",
  "#D9974C",
  "#E3901A",
  "#AACCE3",
  "#9390BE",
  "#722F2E",
  "#B83944",
  "#F3951B",
  "#FEA93A",
  "#F9D1AA",
  "#83A8C1",
  "#C7D9E3",
  "#E2E5E6",
  "#086845",
  "#008356",
  "#A6272F",
  "#8A7662",
  "#FFA405",
  "#B2D1E7",
  "#19563E",
  "#3C3A48",
  "#BF7AA4",
  "#99282C",
  "#BE5B59",
  "#98B6CB",
  "#D9DAD8",
  "#717366",
  "#838A65",
  "#94968A",
  "#9AA07D",
  "#DBD7D5",
  "#D4BEA8",
  "#E6D9CC",
  "#EDE1D5",
  "#F6E5D4",
  "#FAE7D3",
  "#585568",
  "#84747C",
  "#6B3136",
  "#A1876A",
  "#DDA667",
  "#FFAF3E",
  "#EEBF8B",
  "#25485C",
  "#005476",
  "#006392",
  "#006B9B",
  "#6C97B3",
  "#95A7B4",
  "#B8C4CC",
  "#A9CCE6",
  "#D7DDE1",
  "#E8EAE9",
  "#E8EAE9",
  "#386A6D",
  "#308A91",
  "#699093",
  "#88ABAD",
  "#6AB1B6",
  "#63B3B9",
  "#98B9BB",
  "#90CCD0",
  "#89CED2",
  "#ACD6D8",
  "#9FD8DB",
  "#C6E1E1",
  "#DCEDEC",
  "#207856",
  "#41795F",
  "#757E78",
  "#009461",
  "#41AA7D",
  "#1CAD78",
  "#9DA5A0",
  "#8CAC9B",
  "#5FC094",
  "#83C7A5",
  "#A5C1B2",
  "#8AD3AF",
  "#C0D7C8",
  "#D5DAD5",
  "#B4E5CA",
  "#C7E8D4",
  "#E6EAE4",
  "#DDEBDF",
  "#D2EDDB",
  "#63664F",
  "#72813A",
  "#8D9275",
  "#A3AC74",
  "#98B33E",
  "#AFC657",
  "#B7C292",
  "#D9DCB8",
  "#D6E0A0",
  "#DFE6B7",
  "#E8E9DC",
  "#E7E7D1",
  "#EAF0D3",
  "#444258",
  "#534F74",
  "#66656D",
  "#6F6C81",
  "#6C698D",
  "#81808B",
  "#8C8B95",
  "#9C98B6",
  "#BEBACF",
  "#D1D1D6",
  "#D4D1DF",
  "#DDDBDC",
  "#E9E8E8",
  "#54414C",
  "#82516F",
  "#7D596E",
  "#A25A85",
  "#A8658C",
  "#977287",
  "#C1669D",
  "#B195A4",
  "#C29AAF",
  "#CB94B3",
  "#CDB9C3",
  "#C8C1C4",
  "#D6BBC9",
  "#D5CECF",
  "#DED1D5",
  "#E1D1D7",
  "#DFDBDA",
  "#E2DCDC",
  "#EAE8E5",
  "#EEE8E8",
  "#783C3A",
  "#8F6360",
  "#DE8E89",
  "#D59B96",
  "#CEB2AF",
  "#C9BFBD",
  "#ECCCC8",
  "#ECE7E3",
  "#54473B",
  "#6B5137",
  "#6D5539",
  "#825E39",
  "#6E6256",
  "#7C6A55",
  "#B0752D",
  "#9C7851",
  "#AB804F",
  "#C88326",
  "#C88626",
  "#AB9279",
  "#D19038",
  "#C59967",
  "#E39931",
  "#C9A887",
  "#BAB3AC",
  "#E8A553",
  "#C2B6A9",
  "#EBAE62",
  "#CCB9A4",
  "#C5BFB9",
  "#D7BEA3",
  "#E9BD8E",
  "#F2C89B",
  "#E3D1BF",
  "#E8D3BD",
  "#F1D6BA",
  "#F5D6B5",
  "#E7DBD0",
  "#F6D8B8",
  "#EBDCCC",
  "#F3DEC8",
  "#F9DBBD",
  "#EFE9E1",
  "#F4E8DA",
  "#006B9F",
  "#57A3D1",
  "#64907A",
  "#575A4C",
  "#ECEDE7",
  "#9A8B92",
  "#B4AAAE",
  "#BA9A77",
  "#E19000",
  "#F6CEA2",
  "#FFCF95",
  "#F6E0C9",
  "#FAE0C3",
  "#F2EBE3",
  "#9A9EA0",
  "#E0EAEF",
  "#D6E8E8",
  "#025E42",
  "#4F5342",
  "#A3A793",
  "#6F68A4",
  "#BCB7D5",
  "#603250",
  "#C1ACA9",
  "#C9AE91",
  "#FDBA61",
  "#B9E3E5",
  "#B9BFA7",
  "#E1E2DD",
  "#9693A1",
  "#5E354C",
  "#744962",
  "#EDD3DF",
  "#EDE4E2",
  "#FBBD71",
  "#6CABD6",
  "#B0C4D3",
  "#A8DEE2",
  "#565C43",
  "#DDE3CB",
  "#B2AFBB",
  "#7D3761",
  "#863B67",
  "#E1A5C3",
  "#91302C",
  "#FBB758",
  "#EFC89B",
  "#F5EEE5",
  "#106086",
  "#457697",
  "#AFC3B9",
  "#8B81BA",
  "#D4CFE3",
  "#AE7995",
  "#BF9B6E",
  "#D8B081",
  "#D7C1A8",
  "#E1D4C6",
  "#007CB6",
  "#858585",
  "#7E8D99",
  "#0096A2",
  "#0098A4",
  "#809158",
  "#A2CA48",
  "#D0D4C3",
  "#625894",
  "#A79DC8",
  "#D8D5E0",
  "#DDDAE4",
  "#5F5654",
  "#B02826",
  "#C33A38",
  "#F5DFDB",
  "#F8DCBB",
  "#EAE4DB",
  "#314655",
  "#9AC2E2",
  "#CFDBE5",
  "#E0E4E8",
  "#004C52",
  "#20ADB8",
  "#8CD5DC",
  "#94ACA0",
  "#858A77",
  "#D4D4D2",
  "#915D79",
  "#A23530",
  "#D8C5C1",
  "#6C6965",
  "#EDD0AE",
  "#F1E1CF",
  "#63707B",
  "#58748B",
  "#B3CADE",
  "#687152",
  "#95A969",
  "#493F6C",
  "#453432",
  "#E18479",
  "#F7ACA1",
  "#F3DEDA",
  "#F3E7E4",
  "#53BFCB",
  "#96D6DD",
  "#CED4BE",
  "#F1DEE6",
  "#AF332E",
  "#BD2F2C",
  "#DFCFCC",
  "#6F614F",
  "#FEAB13",
  "#D2CABF",
  "#FDD29B",
  "#3D454D",
  "#86AD3D",
  "#8EAF54",
  "#634F35",
  "#765935",
  "#8B7A66",
  "#987B54",
  "#B37F28",
  "#978064",
  "#B5812E",
  "#AF8136",
  "#C88A28",
  "#998C7C",
  "#A09180",
  "#AA906F",
  "#C38D38",
  "#D79413",
  "#AB9E8E",
  "#BD9F7B",
  "#B3A18C",
  "#DD9C2C",
  "#C5AA88",
  "#BCAD9A",
  "#E5AA53",
  "#DCB481",
  "#CDBBA6",
  "#D9C1A2",
  "#D1C5B7",
  "#D6C7B5",
  "#DAC8B2",
  "#E5CDAF",
  "#EFC898",
  "#DBCFC0",
  "#EED0AC",
  "#E0D1BF",
  "#E4D2BC",
  "#E8D4BC",
  "#E4DBD0",
  "#EFDFCB",
  "#F5DFC4",
  "#EFE8DF",
  "#F1E8DC",
  "#4E5B66",
  "#A1C0DC",
  "#B0B0AF",
  "#269D78",
  "#728C42",
  "#749639",
  "#B34F83",
  "#D486AC",
  "#973E34",
  "#E3CFCB",
  "#F6D6CF",
  "#786D60",
  "#B0A290",
  "#D7A762",
  "#FCBB58",
  "#EFE7DC",
  "#FAE8D1",
  "#234760",
  "#D2DCBF",
  "#B9483C",
  "#EEA197",
  "#A79278",
  "#FFBA35",
  "#FEE1BC",
  "#C7D8E6",
  "#83C5CE",
  "#605088",
  "#E1DFE4",
  "#6F3B33",
  "#7E3C33",
  "#DCA440",
  "#EAB45D",
  "#FFBA1F",
  "#F7EBDC",
  "#87B1D5",
  "#E9EED7",
  "#D3D0D6",
  "#AC833F",
  "#C39E67",
  "#F6E5D0",
  "#37919D",
  "#164B3C",
  "#CB983B",
  "#C5AF92",
  "#F8AF1C",
  "#F1AA4A",
  "#CEBEA8",
  "#F3BA6F",
  "#F1C184",
  "#FFD090",
  "#EDE1D0",
  "#FBDCAE",
  "#F5E1BE",
  "#F5E6D1",
  "#F4E7CE",
  "#4F5050",
  "#59796C",
  "#C5DE9E",
  "#92486C",
  "#E3DBDC",
  "#B05446",
  "#E16F5F",
  "#DFB778",
  "#E5DFD7",
  "#FADBAF",
  "#105444",
  "#7D7D7C",
  "#DEEBE5",
  "#CC6552",
  "#E16553",
  "#F5CAC1",
  "#E8E3DC",
  "#274C68",
  "#184C6E",
  "#004E76",
  "#005B8E",
  "#1D567C",
  "#3A698D",
  "#57718A",
  "#4883B0",
  "#6790B3",
  "#90969C",
  "#769DC2",
  "#9BB6D1",
  "#BDBFC0",
  "#B2C2D5",
  "#CBCDCC",
  "#C3CFDA",
  "#C2D0DF",
  "#D6DDE5",
  "#E9E9E9",
  "#E8EAEB",
  "#00565F",
  "#39595F",
  "#006E7B",
  "#007585",
  "#4B7278",
  "#008897",
  "#62868B",
  "#49A7B5",
  "#85A6AB",
  "#ADC9CC",
  "#BDD1D3",
  "#B3D7DB",
  "#D6DAD7",
  "#D1DEDF",
  "#C9DDDD",
  "#C4E1E4",
  "#C8E6E9",
  "#47524D",
  "#1C5C4A",
  "#517367",
  "#007C5C",
  "#008763",
  "#008466",
  "#008E6B",
  "#669887",
  "#5DA78F",
  "#31B592",
  "#65B59A",
  "#8CBCAB",
  "#8BC2AE",
  "#B8BBB9",
  "#80D2B6",
  "#95CFBA",
  "#A9D0C1",
  "#ABD5C5",
  "#D7D9D6",
  "#ACE3CD",
  "#C9E1D5",
  "#C4E3D6",
  "#C4E6D7",
  "#E5EAE5",
  "#DBEEE5",
  "#D9EDE3",
  "#D2EBDE",
  "#465439",
  "#53594C",
  "#506436",
  "#5B6C42",
  "#5B7638",
  "#647D43",
  "#648637",
  "#75845D",
  "#8B9973",
  "#919F72",
  "#A4A7A1",
  "#86B34F",
  "#A2AE8E",
  "#AFBE9B",
  "#AAC089",
  "#C1C2BD",
  "#B2CF89",
  "#BFD1A3",
  "#C4CFB0",
  "#B9D594",
  "#D2E0BB",
  "#DBDDD2",
  "#D9E1CC",
  "#D4E6B6",
  "#E0E1DC",
  "#E6EADD",
  "#E5EBD5",
  "#E3ECCE",
  "#5A4D70",
  "#5F507A",
  "#655A7B",
  "#70677F",
  "#7D6D99",
  "#83769B",
  "#8A8692",
  "#9A95A6",
  "#A398B4",
  "#A09DA7",
  "#B8B5BC",
  "#BEB9C5",
  "#C3BACE",
  "#C4C1C6",
  "#D1CFD3",
  "#D8D2E0",
  "#DCDBDB",
  "#DEDBDE",
  "#E0DDE1",
  "#6A4253",
  "#7D395A",
  "#834662",
  "#A14C72",
  "#856772",
  "#A86D86",
  "#BB7191",
  "#A48C95",
  "#B88599",
  "#CB9DB0",
  "#D8B6C3",
  "#E9B9CA",
  "#E5CED4",
  "#E8DADD",
  "#EBE5E5",
  "#5E3B34",
  "#7C3B31",
  "#713E34",
  "#823F33",
  "#79493F",
  "#71554E",
  "#8B4C3F",
  "#7C625C",
  "#B54131",
  "#88625A",
  "#93645B",
  "#CF4D3D",
  "#CA5B4A",
  "#A78A84",
  "#B18B83",
  "#DE8F7F",
  "#B4A4A0",
  "#E19B8D",
  "#C4B1AC",
  "#E3B3A8",
  "#D4CCC9",
  "#D8CCC8",
  "#E9CCC5",
  "#EECCC4",
  "#E6DAD6",
  "#EDE6E2",
  "#EFE7E2",
  "#F2E6E2",
  "#3F3934",
  "#52483B",
  "#645239",
  "#745D36",
  "#7F6948",
  "#7D7974",
  "#8A7455",
  "#9E782E",
  "#967D54",
  "#948062",
  "#9F8662",
  "#9D8B70",
  "#C89319",
  "#B4986D",
  "#B29C7D",
  "#BBA17B",
  "#DBA000",
  "#BCAE9A",
  "#B7B3AC",
  "#E2AC39",
  "#C3B198",
  "#C6BAA8",
  "#CCBDA6",
  "#CEC5B6",
  "#D9C3A4",
  "#D3C6B4",
  "#DACAB3",
  "#E6CAA1",
  "#DFCCB1",
  "#F0CB90",
  "#E4CFB1",
  "#DDD7CD",
  "#EFD5AE",
  "#FFCE7D",
  "#E2D8C9",
  "#E9D8BE",
  "#DEDCD7",
  "#F0DEC2",
  "#F4DDBE",
  "#E6E1D8",
  "#EDE3D5",
  "#F0E3D2",
  "#F3E5CE",
  "#EDE8DF",
  "#ECE9E2",
  "#446A8B",
  "#005765",
  "#878888",
  "#BE5385",
  "#EDA798",
  "#F7E7E3",
  "#005482",
  "#8699AD",
  "#BEE2E7",
  "#A1C777",
  "#E6A7BE",
  "#E58A77",
  "#B4CEEB",
  "#6BB7C4",
  "#F1D5DD",
  "#BEB4B1",
  "#FFCF6E",
  "#FFD997",
  "#D8E7E9",
  "#D7EBE3",
  "#A19B98",
  "#B68D2C",
  "#F5B700",
  "#F9C13B",
  "#FBD388",
  "#F2DEBE",
  "#FBE3BD",
  "#38B9CD",
  "#F1BC59",
  "#EFC076",
  "#ECDFCA",
  "#FADEAA",
  "#F5EFE5",
  "#91B5D8",
  "#E7F1EC",
  "#616160",
  "#F5D8E1",
  "#DBC399",
  "#0095AC",
  "#C99C1D",
  "#C39E4B",
  "#FFC100",
  "#FADAA1",
  "#ECE2D1",
  "#CBD8E6",
  "#00A1B8",
  "#61933A",
  "#675F6D",
  "#676162",
  "#AE5138",
  "#D89683",
  "#E9DBC5",
  "#FADEAE",
  "#F6EBD8",
  "#E4E8EC",
  "#00879E",
  "#D6E8C6",
  "#41393B",
  "#874531",
  "#E7B523",
  "#C4BDB0",
  "#FAD587",
  "#EDDAB9",
  "#EAE0CD",
  "#F4E9D6",
  "#EDE8DD",
  "#F5E5C7",
  "#E7E9EB",
  "#517933",
  "#AD94C2",
  "#BCA5CC",
  "#CDC2C4",
  "#F4D9D0",
  "#AFA490",
  "#B7A78C",
  "#CEA127",
  "#DAA937",
  "#DEB349",
  "#EBBD51",
  "#FFC700",
  "#DDD3C2",
  "#E4D0AB",
  "#E2D5C0",
  "#FFD04A",
  "#E6D7BD",
  "#E3DDD2",
  "#F3DCB4",
  "#F9DFAD",
  "#EBE8E1",
  "#EFE9DF",
  "#F4E9D7",
  "#F5E8D2",
  "#F6E7CD",
  "#F7E6CA",
  "#B1DCCF",
  "#85689E",
  "#9477AC",
  "#A185B7",
  "#E7E0D3",
  "#EFE8D9",
  "#4181BA",
  "#005345",
  "#435736",
  "#74568C",
  "#7F7685",
  "#C8B7D6",
  "#D6C8DE",
  "#A77987",
  "#F39578",
  "#F7C631",
  "#F4E9D4",
  "#F5EBD9",
  "#D5E1E2",
  "#569532",
  "#523B64",
  "#4E4653",
  "#B8537B",
  "#FBCB3B",
  "#F8CD6A",
  "#FED56A",
  "#F7DA99",
  "#EBE6DA",
  "#B2C1D7",
  "#BBCEE3",
  "#384340",
  "#006755",
  "#937B3C",
  "#CECCC3",
  "#DDD6C9",
  "#E3D5BB",
  "#F5E9D4",
  "#EEE9DE",
  "#F6EBD3",
  "#3573AB",
  "#7CA4D3",
  "#E0E6E1",
  "#E7EAE4",
  "#DDEED2",
  "#794532",
  "#F6E3DB",
  "#847558",
  "#E6C780",
  "#F7C500",
  "#E8CC8D",
  "#FACA35",
  "#F6CF6C",
  "#F8D483",
  "#FFD571",
  "#FFDC8C",
  "#F1E7D3",
  "#F3E8D4",
  "#F6E8CF",
  "#F8E8C9",
  "#FCE5B4",
  "#9FD5E2",
  "#00AA8F",
  "#518439",
  "#864833",
  "#F8CEC0",
  "#C3BDB0",
  "#DACCB0",
  "#D4DEEE",
  "#A0D6E3",
  "#8ED3C2",
  "#54494B",
  "#D97A99",
  "#E3B6C2",
  "#806C65",
  "#D6C9AD",
  "#F2EDE3",
  "#8599B4",
  "#B2C5DF",
  "#7FCADB",
  "#007F6E",
  "#4E3A34",
  "#57453E",
  "#D06740",
  "#625841",
  "#665936",
  "#FFD967",
  "#FEE39F",
  "#60666C",
  "#5C7291",
  "#A3BADA",
  "#C9CFD8",
  "#BCBDBB",
  "#DEE2E0",
  "#AE486D",
  "#C199A3",
  "#E7A8BA",
  "#E16233",
  "#F1BCA9",
  "#C4AE73",
  "#D1BE8E",
  "#F2D486",
  "#E9DDC4",
  "#1C3753",
  "#1C4B75",
  "#626F83",
  "#4D73A1",
  "#718EB4",
  "#8FA6C6",
  "#9DB1D0",
  "#B9C1CD",
  "#D7DBE1",
  "#E9E9E7",
  "#245D6A",
  "#3A5E67",
  "#00839D",
  "#547C87",
  "#338193",
  "#519BAD",
  "#009FBE",
  "#7F9DA5",
  "#49B6CE",
  "#9AB4BA",
  "#83B8C5",
  "#B0D3DB",
  "#C9D1D2",
  "#D9DEDF",
  "#C1E3EA",
  "#DBE1E1",
  "#D0E4E8",
  "#2D3D39",
  "#1F564C",
  "#4B9C8C",
  "#AAD4C8",
  "#C6D1CD",
  "#B9DED3",
  "#B2E5D8",
  "#D5DDD8",
  "#CAE3DB",
  "#CFEDE3",
  "#E7EAE6",
  "#E5E9E4",
  "#E2ECE6",
  "#3E4E39",
  "#527143",
  "#497839",
  "#65775B",
  "#6C895B",
  "#7C8D74",
  "#87AC72",
  "#74B559",
  "#A5B29C",
  "#9BB68C",
  "#93C87B",
  "#A5C295",
  "#B3CAA6",
  "#C9D3C3",
  "#C8D6C1",
  "#C6DEBB",
  "#C1E1B2",
  "#DADBD6",
  "#D7DFD1",
  "#D5E2CB",
  "#D2E7C3",
  "#E5E9DF",
  "#E3EBDD",
  "#55455E",
  "#624B6E",
  "#675C6D",
  "#867091",
  "#A493AC",
  "#A29BA6",
  "#BCB6BD",
  "#C6B9CA",
  "#D8D0D9",
  "#DDD2DF",
  "#DFDBDD",
  "#E0DDE0",
  "#E9E7E6",
  "#734150",
  "#8A3F59",
  "#AA516F",
  "#976876",
  "#CC6487",
  "#9F9899",
  "#C68597",
  "#DBA9B6",
  "#D0B5BB",
  "#C4C0C0",
  "#E3C1C9",
  "#DECDD0",
  "#DDDAD8",
  "#E7DADB",
  "#ECE9E7",
  "#EFE6E5",
  "#F0E7E7",
  "#5E3E32",
  "#724232",
  "#994C33",
  "#9A5238",
  "#7F6359",
  "#857873",
  "#B86C51",
  "#DD7B59",
  "#BEB1AB",
  "#E5B4A3",
  "#CDCBC9",
  "#DBCCC6",
  "#E3CCC3",
  "#EACDC2",
  "#DED9D5",
  "#E5D9D4",
  "#F4D8CE",
  "#EFD8CF",
  "#F0E0D9",
  "#EAE8E5",
  "#EDE8E4",
  "#EEE6E2",
  "#EFE7E3",
  "#F0E5DE",
  "#BC9E36",
  "#E0BA25",
  "#EBC65D",
  "#E2CB8F",
  "#EFD077",
  "#F2DCAA",
  "#F0E1BF",
  "#F8E1B2",
  "#EBE7DE",
  "#F3E7CE",
  "#F6E5C3",
  "#1C5789",
  "#628CC0",
  "#3C6158",
  "#C9B1A8",
  "#F3E3DA",
  "#EFC900",
  "#E3DDCF",
  "#FEE089",
  "#EDE6D8",
  "#F4EAD1",
  "#37465C",
  "#39AFC9",
  "#A55E43",
  "#CA5322",
  "#CBC0A7",
  "#FDD84F",
  "#F9E8BC",
  "#F7ECD5",
  "#9E9F9E",
  "#50C7B3",
  "#EFE7E7",
  "#B25431",
  "#968550",
  "#E7E1D4",
  "#F2E7CC",
  "#FDE39F",
  "#9CA5B6",
  "#CBD3E2",
  "#87CEE2",
  "#646967",
  "#A9B7B3",
  "#E6E2E6",
  "#743347",
  "#ECA8B9",
  "#675750",
  "#AE684A",
  "#7F7B73",
  "#B7B2A4",
  "#D3CDBE",
  "#F8D02E",
  "#C3E1E9",
  "#78BEB1",
  "#942D52",
  "#F2D6DA",
  "#F37C4B",
  "#EDE4DE",
  "#233F61",
  "#008DAC",
  "#E2E7E7",
  "#90DDCD",
  "#BEE9DE",
  "#63406E",
  "#F0EDE4",
  "#6D9464",
  "#EFBFC9",
  "#AF7F6B",
  "#B48D7C",
  "#F3EDDD",
  "#165F9C",
  "#F4A481",
  "#E1DAC7",
  "#F7E9C5",
  "#368631",
  "#DBB6A6",
  "#F4D1C1",
  "#007C9A",
  "#48877D",
  "#D8E8E3",
  "#3F3E3E",
  "#DEC7CB",
  "#503E37",
  "#674332",
  "#AE562D",
  "#BE6B44",
  "#A18C82",
  "#A09591",
  "#D8967B",
  "#E5906A",
  "#B5A49D",
  "#EFB499",
  "#F2CEBE",
  "#EDDAD1",
  "#EDEAE6",
  "#EDE8E3",
  "#EFE8E2",
  "#F0E7E1",
  "#F2E2D9",
  "#9F8B33",
  "#9E967E",
  "#B0993F",
  "#C4A91B",
  "#CBB132",
  "#D9B500",
  "#ECC722",
  "#F3D15B",
  "#EFD886",
  "#E8D8AC",
  "#F3DE9C",
  "#F7DF96",
  "#F6E2A9",
  "#F4E7C8",
  "#F4E6C0",
  "#6D8DBE",
  "#CBD7DA",
  "#1C4741",
  "#4F514D",
  "#496343",
  "#F6B99D",
  "#F3C0A9",
  "#B7A44B",
  "#F6ECCC",
  "#F4F0E4",
  "#F6EDD1",
  "#52774D",
  "#4D4A4A",
  "#7C503A",
  "#A75B34",
  "#857A74",
  "#978953",
  "#FCE99C",
  "#E6E9E3",
  "#B5506B",
  "#E0899C",
  "#D4692E",
  "#EEA986",
  "#D5BF19",
  "#F1E4B8",
  "#E7E4D9",
  "#9CB2DF",
  "#D7E5EA",
  "#BC93C1",
  "#D5BAD8",
  "#9D3352",
  "#4F4E49",
  "#B3A236",
  "#AAA48F",
  "#D5D1C2",
  "#ECE9DC",
  "#F4EAC6",
  "#00779B",
  "#DCC5DD",
  "#6C4E3E",
  "#F17831",
  "#9A8B30",
  "#ECD461",
  "#ECD96A",
  "#ECDB8B",
  "#EBE4CC",
  "#EFEAD6",
  "#F0EEE5",
  "#F6F1DE",
  "#F6F2E5",
  "#B4DCEA",
  "#E6CED0",
  "#C2886B",
  "#F7EAB3",
  "#F7EBBD",
  "#F5EFD7",
  "#4E6185",
  "#E3DEE2",
  "#CDC0B9",
  "#EFDCD2",
  "#CCBC37",
  "#F2EFE5",
  "#F7EED4",
  "#A9C4BF",
  "#E56E27",
  "#6F6845",
  "#F7EAA5",
  "#677DAD",
  "#D3E5E9",
  "#83C385",
  "#E68D5A",
  "#354E76",
  "#707992",
  "#898D9B",
  "#8998BC",
  "#979FB2",
  "#A3A7B1",
  "#A6AFC8",
  "#B1B6C4",
  "#BEC2C9",
  "#CCCED3",
  "#CED1D9",
  "#CED3E3",
  "#DADBDC",
  "#DBDDE0",
  "#DBDCE1",
  "#E8E8EB",
  "#2F454D",
  "#0C5C70",
  "#006B88",
  "#0A6C84",
  "#008FB5",
  "#829096",
  "#20A1C3",
  "#599FB7",
  "#9DAAAE",
  "#5DB2CF",
  "#94B5C2",
  "#8DBDCF",
  "#9AC5D5",
  "#B0CED9",
  "#B5D7E2",
  "#C1DDE7",
  "#BBDDE9",
  "#005D56",
  "#90A8A4",
  "#55B7AC",
  "#8BD6CC",
  "#D1DDD9",
  "#E4EBE7",
  "#495A47",
  "#346437",
  "#266A34",
  "#3C6E3E",
  "#536C51",
  "#7C927A",
  "#779B74",
  "#7EB17E",
  "#A1C09F",
  "#C4D2C0",
  "#BDD7BB",
  "#BAD9B8",
  "#D7DAD5",
  "#D3DECF",
  "#CFE2CD",
  "#CCE3C9",
  "#C8E3C6",
  "#E2ECE0",
  "#E0ECDD",
  "#DEEDD9",
  "#7D5F7F",
  "#7D6D7E",
  "#9A729C",
  "#9E919F",
  "#BFB6BF",
  "#D5CFD4",
  "#DCD1D9",
  "#EBE8E9",
  "#EDE8EA",
  "#6B4A50",
  "#7E434E",
  "#864F5A",
  "#984356",
  "#816469",
  "#966870",
  "#977F82",
  "#C16D7E",
  "#B18E93",
  "#D0929C",
  "#C1A4A9",
  "#D6B5B8",
  "#D3BFC1",
  "#E2CECF",
  "#E3DAD8",
  "#E9DAD9",
  "#F1E5E4",
  "#4E3D34",
  "#654330",
  "#5B4A41",
  "#66554D",
  "#765B4D",
  "#8F6C58",
  "#AE6335",
  "#AA8E7F",
  "#D9A387",
  "#BEAFA6",
  "#E1B7A3",
  "#DBCEC6",
  "#EACEC0",
  "#EDE7E1",
  "#F0E8E2",
  "#5A5335",
  "#787256",
  "#867B3D",
  "#918A70",
  "#A49B7A",
  "#AEA26B",
  "#B8B192",
  "#C9B96D",
  "#CFBF3B",
  "#CDC387",
  "#D4CFBC",
  "#D9D2B8",
  "#DED29C",
  "#E8D36D",
  "#E2D8AE",
  "#EDDDA2",
  "#E6DEC4",
  "#F4E291",
  "#ECE9E0",
  "#F2E8C9",
  "#3F4F72",
  "#004641",
  "#A1D3A2",
  "#ABDDAC",
  "#ECB8BE",
  "#F3EEDC",
  "#224373",
  "#5F373D",
  "#8A4B56",
  "#EFDFDF",
  "#546894",
  "#B6D4E0",
  "#A5CEA7",
  "#603960",
  "#A1948C",
  "#C2C7D6",
  "#9FD3E7",
  "#D4DEE1",
  "#BCCCC9",
  "#616760",
  "#442529",
  "#D86C80",
  "#E5DFDE",
  "#E1D2CA",
  "#F2D4C2",
  "#76908D",
  "#D2E6E2",
  "#E6E7E4",
  "#A25D2C",
  "#C77338",
  "#E1CBBE",
  "#CCC45A",
  "#F5EDCF",
  "#C4E0EB",
  "#DD939C",
  "#CD6F27",
  "#908B2C",
  "#ACA90C",
  "#448CA7",
  "#8DCCE7",
  "#90B9B5",
  "#DEEBE8",
  "#8F988F",
  "#46AC5F",
  "#CDD8CD",
  "#AB4357",
  "#F3C4C9",
  "#8A5631",
  "#BB7546",
  "#787336",
  "#BCB928",
  "#C6C13B",
  "#EEEDE5",
  "#555C5E",
  "#4E6C69",
  "#4B7B78",
  "#00837D",
  "#008C86",
  "#BAE3DF",
  "#CBEBE6",
  "#573B55",
  "#F0A9B1",
  "#F5CED1",
  "#ED8B45",
  "#F8D7C3",
  "#ECEADF",
  "#0097C4",
  "#BDD7E3",
  "#009B96",
  "#A0C6C2",
  "#C1E6E2",
  "#91A392",
  "#B5CAB6",
  "#C5C7C3",
  "#EBDEE8",
  "#826F63",
  "#EBDED4",
  "#8D8964",
  "#324169",
  "#38B1DB",
  "#154946",
  "#10514E",
  "#22625F",
  "#2A7C79",
  "#6DB0AC",
  "#A1D8D4",
  "#CBD5D3",
  "#3A5F42",
  "#33643E",
  "#B5BBB5",
  "#68303A",
  "#853643",
  "#F2DCDC",
  "#6C5141",
  "#8F5833",
  "#826A5C",
  "#A4673C",
  "#B4662F",
  "#8C7567",
  "#A08573",
  "#D77E44",
  "#D38043",
  "#DA8953",
  "#D08E61",
  "#EC9F6C",
  "#D6A78A",
  "#EAB696",
  "#E1BCA7",
  "#F0C8B0",
  "#E1CFC3",
  "#E5DAD3",
  "#E9DCD3",
  "#EFDDD1",
  "#EEE7E1",
  "#E8E38C",
  "#6C7AAB",
  "#848DB5",
  "#00546E",
  "#1B7694",
  "#B0CFDD",
  "#BDD9D6",
  "#496E51",
  "#E8DAE5",
  "#ED9AA3",
  "#C9B7B7",
  "#343333",
  "#B59F91",
  "#E5E0DC",
  "#EBEAE8",
  "#DEDDD3",
  "#E8E7E3",
  "#D6E5EB",
  "#006663",
  "#5D7861",
  "#D0E4D2",
  "#D2B6CC",
  "#5F4546",
  "#85686A",
  "#F6D8DA",
  "#D8BCAA",
  "#F7E2D3",
  "#D6D5CB",
  "#E4E184",
  "#343E61",
  "#7586C6",
  "#AFC5D0",
  "#7E9E84",
  "#7C4E75",
  "#963747",
  "#F19754",
  "#F6B180",
  "#EEC4A9",
  "#B2B1A5",
  "#F1F0E8",
  "#F2F1E5",
  "#B8BCD4",
  "#537686",
  "#CDD3D5",
  "#E0C0DA",
  "#E5D1E0",
  "#482E32",
  "#E8A06C",
  "#CCB19F",
  "#BBC9D0",
  "#D7E3E0",
  "#32583D",
  "#DDB1D4",
  "#E5DCDC",
  "#AF907B",
  "#F18517",
  "#FABC90",
  "#DEDEDA",
  "#F1EFCC",
  "#F3F2DA",
  "#5A638D",
  "#57B7DD",
  "#D6A4CC",
  "#F5A265",
  "#EED3C1",
  "#E8E3A8",
  "#E4E5EA",
  "#6B5253",
  "#5B5A58",
  "#F3CCB0",
  "#5D5D32",
  "#EEEDD5",
  "#0C4C62",
  "#00A4A6",
  "#C98EBD",
  "#B94657",
  "#D8D87C",
  "#E0DD90",
  "#C1DAE6",
  "#D0DDE3",
  "#EBD3E2",
  "#EAE2E6",
  "#D2D36F",
  "#E8E5AE",
  "#E7E6DD",
  "#454C6C",
  "#6E718E",
  "#68709F",
  "#71779E",
  "#8085AE",
  "#9194AB",
  "#9799B8",
  "#AEB0C8",
  "#BCBED5",
  "#C8CAE4",
  "#DBDBDD",
  "#E9E8E8",
  "#ECEAED",
  "#394A53",
  "#005F7D",
  "#007096",
  "#587381",
  "#1883A7",
  "#5E93AD",
  "#84939C",
  "#7D98A6",
  "#8F9EA5",
  "#99AFBC",
  "#A7B1B6",
  "#ADC8D7",
  "#C7D0D4",
  "#CBDEE8",
  "#C9DEE9",
  "#007A7A",
  "#6C9393",
  "#609C9B",
  "#64B1AF",
  "#8CADAC",
  "#44BFBE",
  "#88C8C6",
  "#A1CCCA",
  "#C8E2DF",
  "#C3E3DF",
  "#E6E9E6",
  "#DDEDEA",
  "#D9EDEA",
  "#32523D",
  "#57725E",
  "#34794D",
  "#238E52",
  "#5B9A70",
  "#7F9584",
  "#57A972",
  "#7AA888",
  "#51B074",
  "#A9B4AB",
  "#80C194",
  "#93C1A1",
  "#8BCEA0",
  "#C5D4C8",
  "#A6DEB7",
  "#BEDAC4",
  "#B7E2C3",
  "#D5DED6",
  "#D2DED4",
  "#C8E6CE",
  "#E3E9E1",
  "#E5EBE4",
  "#DAEDDC",
  "#D8EFDC",
  "#533F4F",
  "#734D6C",
  "#9E7594",
  "#B897AF",
  "#E1D1DC",
  "#E5DBE0",
  "#EDEAEB",
  "#EEE9EB",
  "#EEE9EB",
  "#EEE8EA",
  "#84474B",
  "#9E555C",
  "#AC4B57",
  "#B87C7E",
  "#A78E8E",
  "#DB7680",
  "#A99898",
  "#DB9599",
  "#EAB0B2",
  "#DDB8B8",
  "#EBBABB",
  "#E6C4C5",
  "#D5CECD",
  "#ECD0CF",
  "#E3DBD8",
  "#EEDCDA",
  "#ECE8E5",
  "#ECE7E4",
  "#EEE7E5",
  "#F0E7E5",
  "#363635",
  "#664D3B",
  "#AE6830",
  "#9E8472",
  "#D77E29",
  "#B1937D",
  "#A8998E",
  "#D48B4C",
  "#DD883A",
  "#C1A28B",
  "#E29859",
  "#BAA79A",
  "#E0A678",
  "#CCB7A8",
  "#D3BAA7",
  "#F4AC71",
  "#E7B794",
  "#F0BC94",
  "#D9C4B6",
  "#D6CEC7",
  "#E9C9B2",
  "#E1D0C3",
  "#F3D4BD",
  "#E8DCD2",
  "#F4DDCC",
  "#F0E4DB",
  "#F0E8E0",
  "#F4E5D9",
  "#484737",
  "#6C6B3E",
  "#747264",
  "#7E7F3A",
  "#A09E64",
  "#BBB786",
  "#B9BB58",
  "#C2C28F",
  "#C9CC75",
  "#D7D4BB",
  "#DDDA87",
  "#E1DBAE",
  "#EDE9D3",
  "#EDECCD",
  "#EDE9C5",
  "#333D6B",
  "#F4A6A8",
  "#5A4A3D",
  "#7D8234",
  "#A2AF1D",
  "#EAEBBA",
  "#F0F0E0",
  "#3D4448",
  "#89D6D5",
  "#AFBB34",
  "#BAC348",
  "#C5CF5A",
  "#D7DC88",
  "#64727A",
  "#7F847F",
  "#B973A8",
  "#F9CECD",
  "#A17247",
  "#ECE5DF",
  "#F2ECE6",
  "#B9C546",
  "#F1F1ED",
  "#E6BDD9",
  "#DD646D",
  "#C49F80",
  "#E9EAD9",
  "#767F84",
  "#B2B8BA",
  "#D4E4E1",
  "#E4B6D6",
  "#EBD2E2",
  "#6B2C31",
  "#E48286",
  "#A4A967",
  "#AE639A",
  "#514C47",
  "#BDB1A6",
  "#F79A38",
  "#BEC198",
  "#D3D3CB",
  "#385142",
  "#EEDBE5",
  "#B5A08F",
  "#FCAE63",
  "#E9EAD7",
  "#7FB7D6",
  "#AA7E54",
  "#DDB694",
  "#E8E0D8",
  "#0087BD",
  "#B1D2E6",
  "#AF7026",
  "#E7C4A6",
  "#F3C49B",
  "#F3E6D9",
  "#F4E6DA",
  "#E2E3D2",
  "#E8EAD0",
  "#F0DCC9",
  "#F7F5EE",
  "#705F68",
  "#8D6E5A",
  "#DC7525",
  "#645636",
  "#DFD3C5",
  "#F0ECDF",
  "#9A5C38",
  "#E2CD9E",
  "#EFE7DA",
  "#3C3E3E",
  "#E7DCD5",
  "#D8E5D4",
  "#EAE7C1",
  "#D6EAE2",
  "#B9C9E1",
  "#83A89A",
  "#F8EDE1",
  "#B6AB9D",
  "#CCBDA6",
  "#F0EDDF",
  "#B6AB9D",
  "#F0E8E1",
  "#A29182",
  "#F3E7CD",
  "#E9EAD9",
  "#FEB572",
  "#F9D1B5",
  "#F2E3D2",
  "#F1D4D5",
  "#5D3F36",
  "#A0C6C2",
  "#CAC0B8",
  "#BDBFC0",
  "#A6908B",
  "#D8CBC0",
  "#D49C9B",
  "#E4E1DB",
  "#B5D3D2",
  "#CDDBE0",
  "#5F5569",
  "#A85958",
  "#C16130",
  "#C3CACD",
  "#E56F5C",
  "#F0BD00",
  "#514961",
  "#E1DACA",
  "#E7CBC7",
  "#E8D3B7",
  "#D2A36C",
  "#A2AE8E",
  "#FFCF73",
  "#EDE3CD",
  "#32628C",
  "#494D52",
  "#E9D8BE",
  "#8E5637",
  "#28A2B7",
  "#06A5AE",
  "#C9CBC9",
  "#DEDCC1",
  "#D4BFA5",
  "#658185",
  "#746357",
  "#991B25",
  "#C16D7E",
  "#AE5367",
  "#D37998",
  "#F4D3CB",
  "#D2DDE1",
  "#9F9899",
  "#D5C4B7",
  "#6A4D33",
  "#2D2D2D",
  "#282829",
  "#3B343F",
  "#524F63",
  "#2C3241",
  "#2E4A58",
  "#6A4A3E",
  "#BFD1E4",
  "#C57463",
  "#E5DBD7",
  "#EEE2DF",
  "#5E7C86",
  "#92B8DC",
  "#005B8E",
  "#1C3C43",
  "#567EBE",
  "#413048",
  "#D8E0E9",
  "#99BDD0",
  "#D1DDE3",
  "#005476",
  "#7F8A9C",
  "#B5CBDA",
  "#154367",
  "#737B84",
  "#457697",
  "#88B7BF",
  "#E1DBD2",
  "#E6D8D1",
  "#7093AB",
  "#F3A9A4",
  "#D5E9E9",
  "#D1DDE3",
  "#9E713E",
  "#9DB19E",
  "#6D5E4D",
  "#735237",
  "#A48561",
  "#9D8E7E",
  "#B0C4D3",
  "#A96E4D",
  "#CCCCCB",
  "#C19659",
  "#E1C09D",
  "#F7B260",
  "#7D623B",
  "#9A5238",
  "#F7DA99",
  "#FFD17D",
  "#FEDFA1",
  "#F0DFBC",
  "#EBC68E",
  "#594B3F",
  "#F58B52",
  "#FFD17D",
  "#F4C272",
  "#E8E8E5",
  "#A49B7A",
  "#E4BE9B",
  "#E0A767",
  "#EDE3D5",
  "#F8E8DC",
  "#ECD9CA",
  "#505354",
  "#87846E",
  "#C498AC",
  "#C9A02E",
  "#D7A762",
  "#C5AA9B",
  "#D7C6B4",
  "#C4B591",
  "#DBCAA4",
  "#CBC890",
  "#C26430",
  "#E6E7A3",
  "#8FA6C6",
  "#E6E9E9",
  "#E6E9E9",
  "#F2D7B4",
  "#F9E3C1",
  "#C19659",
  "#D3BAA7",
  "#5D3E3F",
  "#DDB5BA",
  "#453432",
  "#BABAB9",
  "#DFE2E7",
  "#9B3D3F",
  "#DFDCD5",
  "#EEEFEA",
  "#C6D6B2",
  "#452B33",
  "#646350",
  "#8A7662",
  "#7A4D3A",
  "#C87F3C",
  "#AD6C55",
  "#724232",
  "#A8D4D7",
  "#D0C738",
  "#FFB54F",
  "#FBEDBA",
  "#DAB955",
  "#63655D",
  "#D5E1E2",
  "#F3F2EC",
  "#EBEAE4",
  "#9DAAAE",
  "#A8DAE5",
  "#ECEDE7",
  "#B3D6DC",
  "#F8EAD5",
  "#B8C7CC",
  "#AFC3CC",
  "#005184",
  "#343639",
  "#E6D9B7",
  "#FBDCB1",
  "#B28D80",
  "#676162",
  "#908874",
  "#BCC7B5",
  "#9D9E9D",
  "#F3E7DE",
  "#37423B",
  "#BEA18E",
  "#AFB1B3",
  "#C4DBE4",
  "#79433D",
  "#CC907B",
  "#7D362A",
  "#C2886B",
  "#ECDED4",
  "#C27470",
  "#D16965",
  "#F7E6E4",
  "#C27470",
  "#D66B76",
  "#E19B8D",
  "#59A4D1",
  "#7CA8BF",
  "#DCE1DF",
  "#E2DDCB",
  "#C9B9C9",
  "#ECE9D9",
  "#DFE5F0",
  "#F0E8E1",
  "#F7F0DF",
  "#63584C",
  "#E2CCAB",
  "#B8C7CC",
  "#896A46",
  "#E8CDA5",
  "#EFEBD1",
  "#C7BDB6",
  "#A32E39",
  "#EFDAB9",
  "#F8EFD8",
  "#FAEBD1",
  "#899596",
  "#C1BEA2",
  "#BF7567",
  "#BDE0A9",
  "#FAD9AF",
  "#B7AFA4",
  "#00533F",
  "#F6EBCD",
  "#6E6867",
  "#A05155",
  "#CBD7E3",
  "#5A3732",
  "#3B343F",
  "#5D3944",
  "#503E37",
  "#3E2A27",
  "#674332",
  "#C3AD94",
  "#F6F5D9",
  "#ECD461",
  "#46383E",
  "#4A5A88",
  "#8F908F",
  "#833733",
  "#7F4C3C",
  "#295078",
  "#82C8E3",
  "#5C9BCC",
  "#EAE6E1",
  "#7C8D95",
  "#938564",
  "#F9F1E4",
  "#A7B9A5",
  "#C79E9C",
  "#87846E",
  "#728D73",
  "#5F708A",
  "#F5EBD7",
  "#3A4357",
  "#D0D7C7",
  "#68695B",
  "#ECD1AD",
  "#F2E8CE",
  "#4A423A",
  "#C3DEE7",
  "#2C5663",
  "#E8CCBD",
  "#C3C4C8",
  "#E3E2D9",
  "#388597",
  "#D3D9D9",
  "#915165",
  "#A29F7F",
  "#DBE0E0",
  "#CDB288",
  "#B2CCC5",
  "#8D3926",
  "#4D2F27",
  "#A3652D",
  "#3D2923",
  "#553F2F",
  "#372B27",
  "#833622",
  "#39332F",
  "#7F4F27",
  "#9C6D39",
  "#6A2B24",
  "#CB8C39",
  "#62372A",
  "#C98122",
  "#6A2B24",
  "#59382A",
  "#5F3828",
  "#7D3D23",
  "#502C26",
  "#A94C1C",
  "#5A3423",
  "#CABB9E",
  "#90969C",
  "#C3B3B8",
  "#A99898",
  "#6E8799",
  "#CD4A38",
  "#A0A9AE",
  "#C33F28",
  "#AD588F",
  "#2D2D2D",
  "#E8E8E4",
  "#D8D1C5",
  "#642A33",
  "#FADEAE",
  "#E8DCC6",
  "#0081B8",
  "#706D74",
  "#2F7769",
  "#6E8A7F",
  "#4B9C8C",
  "#A57B76",
  "#7A655D",
  "#BEA488",
  "#B66E59",
  "#304B38",
  "#932F55",
  "#CBB3AD",
  "#D8CFCD",
  "#5E717B",
  "#E0D9AF",
  "#DBCFD0",
  "#B0C4D3",
  "#DDEDD3",
  "#C6B3AA",
  "#819BB4",
  "#F8A476",
  "#97A1CF",
  "#E5E9DF",
  "#336C72",
  "#F6F2E5",
  "#503137",
  "#009E82",
  "#AE684A",
  "#9A7259",
  "#3E4334",
  "#AFD2E5",
  "#CFD0C2",
  "#A45D6A",
  "#7B90A0",
  "#C8C6BD",
  "#E18D93",
  "#E3D7C4",
  "#E3DDD2",
  "#7D7F80",
  "#949488",
  "#D6C0BE",
  "#6B2230",
  "#987623",
  "#976856",
  "#A16C79",
  "#D4DADD",
  "#03664F",
  "#646967",
  "#A09591",
  "#878A83",
  "#57624D",
  "#6289A3",
  "#F6CE62",
  "#007067",
  "#DEDACB",
  "#B6B4A9",
  "#EEE7DF",
  "#C7C9D5",
  "#A3A78D",
  "#D6D9E7",
  "#E0B7A4",
  "#1B80B8",
  "#915B24",
  "#847B72",
  "#E3F0DD",
  "#C1BEA2",
  "#E5EADE",
  "#EBE9BA",
  "#F5EBD9",
  "#98A9A4",
  "#D0CD98",
  "#23693B",
  "#DAB6AB",
  "#BCC7B5",
  "#DCCE8D",
  "#D3EDEF",
  "#F7F6EE",
  "#CCCCCB",
  "#AF98B0",
  "#CD8161",
  "#D6DCE0",
  "#B8BFBA",
  "#F1E8D4",
  "#5DAB70",
  "#4D7A79",
  "#D9CEC4",
  "#CDCCE1",
  "#D8D4CE",
  "#D09D6E",
  "#D4D4D2",
  "#CADEE1",
  "#F29F00",
  "#CF966E",
  "#D1BE8E",
  "#FDC582",
  "#EBCA9C",
  "#DDC9B0",
  "#D7B468",
  "#C9CBC9",
  "#AEAEAB",
  "#95C268",
  "#EEE9DE",
  "#EAE2CC",
  "#D4CFBC",
  "#E1D5BB",
  "#AAC089",
  "#C7D2CE",
  "#C8CDC7",
  "#525353",
  "#737B84",
  "#9C968B",
  "#DADAD9",
  "#AA8E7F",
  "#777B5B",
  "#E7DFD3",
  "#F9E4AE",
  "#D4B773",
  "#D7B468",
  "#B4B3B9",
  "#B68D2C",
  "#9B8987",
  "#777899",
  "#B6A5A6",
  "#B6A379",
  "#C4CCC9",
  "#A2AE8E",
  "#9DA298",
  "#DAB955",
  "#B0CFDE",
  "#28373A",
  "#3C5949",
  "#17407D",
  "#FBEAD6",
  "#8B7267",
  "#C7582E",
  "#F4EEDB",
  "#E6AF47",
  "#D6BB82",
  "#F2DEC2",
  "#D2C6A8",
  "#D7DDE1",
  "#F8B8A1",
  "#A99A8C",
  "#F2DCDC",
  "#F3F2EC",
  "#EEE0E2",
  "#CD8161",
  "#D8C7B2",
  "#E8E8E5",
  "#315368",
  "#567195",
  "#364A55",
  "#617482",
  "#34435C",
  "#5270A7",
  "#444038",
  "#E8D6BB",
  "#F7EDDA",
  "#384A33",
  "#DFEBE6",
  "#D1D4E6",
  "#E8E4E0",
  "#F8ECE6",
  "#F2EFE5",
  "#575253",
  "#A09180",
  "#ECDFA3",
  "#A3AC74",
  "#D5D6B5",
  "#C1BEA2",
  "#3E6256",
  "#3E3E34",
  "#E0DAD5",
  "#D7C2B6",
  "#BDD176",
  "#475538",
  "#CBC4B8",
  "#594B3F",
  "#EDC9CC",
  "#CBF0E8",
  "#F5E4DA",
  "#EDE1D0",
  "#32A5BB",
  "#5E555F",
  "#CFD7E3",
  "#E5E2E5",
  "#EBE5F0",
  "#C6CEDB",
  "#B8B9C8",
  "#C9CBE5",
  "#7D7D7C",
  "#D9DCDD",
  "#97CD87",
  "#9B6D54",
  "#ECD96A",
  "#FFC032",
  "#FFE087",
  "#EECD40",
  "#F8D483",
  "#F8F3C2",
  "#F4E6C0",
  "#F9E09C",
  "#FFD562",
  "#E1E2DD",
  "#00918B",
  "#9EB4CB",
  "#D6DCE0",
  "#A3C0CB",
  "#EFEFF1",
  "#BCB6BD",
  "#D1B098",
  "#A79DC8",
  "#C8AEC0",
  "#DCDFE4",
  "#BCB6BD",
  "#E6EBB9",
  "#DEECAA",
  "#EAECD4",
  "#30673F",
  "#F3F2DA",
  "#FCE2AF",
  "#9FAE36",
  "#EDE8E2",
  "#EBE9E0",
  "#A2967F",
  "#4F3841",
  "#C15A57",
  "#7BADAB",
  "#E4E1DB",
  "#7C6655",
  "#FCDE93",
  "#F9F4DA",
  "#C0C1B5",
  "#C7CA56",
  "#2E8F3D",
  "#905636",
  "#F4E7D4",
  "#006872",
  "#2D3D39",
  "#CFC1CB",
  "#EAE8E5",
  "#D1C2B9",
  "#D2CFC6",
  "#BA977C",
  "#C2794F",
  "#D08E61",
  "#EAE9EA",
  "#FFBE7A",
  "#8BD6D3",
  "#699093",
  "#FFAE62",
  "#BB565C",
  "#9C7851",
  "#B6B4A9",
  "#423B64",
  "#D1D2DC",
  "#807A7C",
  "#ECE8C6",
  "#55B7AC",
  "#29524D",
  "#D7CCC7",
  "#D9DCB8",
  "#D0CD98",
  "#60696C",
  "#29394C",
  "#6D837D",
  "#373635",
  "#223A53",
  "#445A66",
  "#B69F90",
  "#4E5B66",
  "#E4DABF",
  "#C3D8E3",
  "#999997",
  "#646967",
  "#B9D3D1",
  "#F2F3E2",
  "#FACAAB",
  "#84939C",
  "#A29F7F",
  "#C8CED4",
  "#B7C3C5",
  "#E5B600",
  "#833532",
  "#D7DDE1",
  "#F6F7EE",
  "#98977B",
  "#D1DFDD",
  "#F8F2E4",
  "#CECCC3",
  "#E36811",
  "#CBC5B1",
  "#F5E3CD",
  "#ECF1E2",
  "#968A3B",
  "#7B8178",
  "#BEA99D",
  "#817B73",
  "#654657",
  "#B89441",
  "#E3B383",
  "#D5CBC6",
  "#B0A498",
  "#BFBFA8",
  "#445A66",
  "#3B4966",
  "#768299",
  "#B0AAA0",
  "#202C3A",
  "#ECE2D2",
  "#E1D5C6",
  "#909396",
  "#C5BBAB",
  "#EDE0D1",
  "#DC9C86",
  "#B8632A",
  "#627775",
  "#F0ECDF",
  "#D6D3E0",
  "#3A5267",
  "#4D4F52",
  "#6C6B3E",
  "#B8C4CC",
  "#7DB0C2",
  "#EBF5E4",
  "#C2794F",
  "#BCAE9A",
  "#E3DCD4",
  "#DECEBE",
  "#DCF3EE",
  "#32759A",
  "#99AFBC",
  "#CF7B1C",
  "#CA9A51",
  "#C39E4B",
  "#ECE6D8",
  "#5C5A47",
  "#9E967E",
  "#615B3C",
  "#9E967E",
  "#9F9288",
  "#AAA48F",
  "#EDC687",
  "#E2712B",
  "#525234",
  "#F4E9D4",
  "#528580",
  "#B1AC96",
  "#B9A99F",
  "#4F4C80",
  "#E5C586",
  "#E9E6DA",
  "#E3DCD4",
  "#CFCFAC",
  "#E5EEE4",
  "#E7DDDE",
  "#D2CDC6",
  "#D8D0D9",
  "#D4CABD",
  "#384137",
  "#E8EAE4",
  "#DFDAD5",
  "#CCBDA5",
  "#71A63F",
  "#D699B9",
  "#865C7D",
  "#DAE2E8",
  "#E6DDE6",
  "#F1DAD2",
  "#FED6AB",
  "#F4E8DA",
  "#BF8E63",
  "#DFCCB1",
  "#E0D2CD",
  "#A2AE8E",
  "#BAB3AC",
  "#D2CFC6",
  "#AFB4AC",
  "#024A7F",
  "#CEDFDD",
  "#BDE8DA",
  "#B33E3F",
  "#C5BEBA",
  "#F5DAD0",
  "#DAD2D8",
  "#AEB5D4",
  "#9D9E9D",
  "#F1EDE0",
  "#96B0B7",
  "#EFD886",
  "#4A413E",
  "#D2E5E0",
  "#2A493F",
  "#E2D4CB",
  "#D48594",
  "#CEA9AA",
  "#CBB3AD",
  "#C79CA3",
  "#C49F9A",
  "#EFE7E0",
  "#E2BEC0",
  "#D5D6B5",
  "#72404F",
  "#484253",
  "#8D84B5",
  "#877678",
  "#E6B580",
  "#D4C9B5",
  "#9E3147",
  "#72B671",
  "#D8D8D7",
  "#E7D098",
  "#CFAD78",
  "#B6CCD8",
  "#BE3B30",
  "#D6CCCA",
  "#F4DCCF",
  "#D4D2CB",
  "#DFCECB",
  "#A09591",
  "#D9B7AF",
  "#E9DCD3",
  "#D9DCC0",
  "#847B72",
  "#5B4A41",
  "#546386",
  "#BC9795",
  "#C0B4AB",
  "#E4D2E2",
  "#F3ECD1",
  "#C6C0D9",
  "#3F8685",
  "#93383F",
  "#C9BDB7",
  "#D4CBC8",
  "#867091",
  "#594786",
  "#8C8B95",
  "#BF7567",
  "#D5D0C7",
  "#E4E7E9",
  "#888C29",
  "#B9CACE",
  "#482E32",
  "#53504D",
  "#CCBA87",
  "#CFB084",
  "#D1AA6D",
  "#F7A800",
  "#E29E00",
  "#CA8F00",
  "#E09000",
  "#E78C00",
  "#AF8152",
  "#DCAF2F",
  "#E1D8C4",
  "#DBC399",
  "#E4D1B4",
  "#EFDC3B",
  "#F3A852",
  "#F8CA3A",
  "#A48F79",
  "#A18F65",
  "#F4B600",
  "#F5B500",
  "#B98F4E",
  "#A78020",
  "#FF9C00",
  "#E0A312",
  "#F69824",
  "#E99C54",
  "#EE920A",
  "#D96F0B",
  "#B94A24",
  "#BE3C28",
  "#F3782E",
  "#E05313",
  "#EB6C2A",
  "#DB5417",
  "#CE5D2A",
  "#E17021",
  "#D3654D",
  "#A52F28",
  "#9B2A2A",
  "#9A2928",
  "#852227",
  "#6E252B",
  "#5C252A",
  "#43292A",
  "#6F3A33",
  "#7A2D2C",
  "#C5866E",
  "#97332B",
  "#CA7475",
  "#D6A0A5",
  "#A74236",
  "#CA565D",
  "#C5424D",
  "#B9271F",
  "#CE6A55",
  "#AA2C40",
  "#A6393D",
  "#836384",
  "#8D414E",
  "#C3638C",
  "#67263D",
  "#786A9A",
  "#913A75",
  "#4D2D41",
  "#864F82",
  "#9E8691",
  "#BC4579",
  "#33516F",
  "#194E65",
  "#0C3E7D",
  "#1C3753",
  "#232830",
  "#005688",
  "#3B6C8C",
  "#303E47",
  "#225E77",
  "#00527D",
  "#223241",
  "#0789B4",
  "#223656",
  "#637C94",
  "#007DAF",
  "#005D8C",
  "#158C8B",
  "#006083",
  "#00474F",
  "#007777",
  "#2F355E",
  "#466B8D",
  "#6193AB",
  "#407561",
  "#3A6939",
  "#385D31",
  "#535640",
  "#174947",
  "#194536",
  "#413F36",
  "#33392B",
  "#3B392F",
  "#2C3A2F",
  "#50703C",
  "#6E7E5C",
  "#313F3C",
  "#7D775C",
  "#4C4539",
  "#41413A",
  "#006B4E",
  "#5B8041",
  "#62993D",
  "#B8CCAA",
  "#3D4736",
  "#8B9A78",
  "#423C31",
  "#058554",
  "#607041",
  "#006150",
  "#7CB8B2",
  "#365746",
  "#007141",
  "#2A8054",
  "#498880",
  "#7BADAB",
  "#7B898E",
  "#8C969B",
  "#837A66",
  "#7B786A",
  "#9A9B9B",
  "#6E706D",
  "#786C5F",
  "#766141",
  "#5E6158",
  "#5B5E58",
  "#555C5E",
  "#5B6162",
  "#5A5347",
  "#53575C",
  "#3D4448",
  "#36393A",
  "#504E49",
  "#818177",
  "#494D52",
  "#3D484A",
  "#928F85",
  "#5F6B6F",
  "#B5B0A0",
  "#808374",
  "#938870",
  "#C5C7C3",
  "#989492",
  "#7D7E7C",
  "#AFB1A8",
  "#6D6961",
  "#989FA1",
  "#8F9391",
  "#525654",
  "#B7B3A8",
  "#8E9495",
  "#7E8589",
  "#C7C7C5",
  "#8B6C44",
  "#9D6432",
  "#7B5142",
  "#804F2F",
  "#8E4E38",
  "#724A32",
  "#744F2F",
  "#5D3D2E",
  "#693A33",
  "#4E3C30",
  "#61362E",
  "#51332B",
  "#483530",
  "#433C3B",
  "#2A2524",
  "#A55B33",
  "#7A543D",
  "#765B4B",
  "#544033",
  "#E7E0D1",
  "#D6D5CA",
  "#EAEAE6",
  "#323233",
  "#202021",
  "#EEEBE1",
  "#2D2F31",
  "#EEEEE7",
  "#2C2A29",
  "#C8CBC4",
  "#8F353A",
  "#BF4F5C",
  "#B27782",
  "#C95D73",
  "#A86D86",
  "#333A3E",
  "#343639",
  "#D4C9B5",
  "#CC9089",
  "#672529",
  "#974951",
  "#97534D",
  "#B84B1B",
  "#89242B",
  "#B47761",
  "#614466",
  "#423B64",
  "#006AA8",
  "#007499",
  "#AAB2B9",
  "#65635E",
  "#D57471",
  "#693838",
  "#2C2B2B",
  "#25313D",
  "#7F6948",
  "#54494B",
  "#605F5E",
  "#C1B8A8",
  "#5D4C30",
  "#E0CDD1",
  "#7C7C7A",
  "#9AB4BA",
  "#7C625C",
  "#AB4C4C",
  "#D35338",
  "#906A46",
  "#B7B3AC",
  "#E9EAE9",
  "#B87C7E",
  "#DBCFBB",
  "#CDC2C4",
  "#EDE8E2",
  "#DEDCD7",
  "#E4CAA7",
  "#CBC0A7",
  "#7B6364",
  "#D6C0BE",
  "#98A9A4",
  "#EADDD4",
  "#D9A397",
  "#A56A61",
  "#F2E7DB",
  "#492D35",
  "#4D73A1",
  "#6C645F",
  "#782E34",
  "#8F969B",
  "#A4726D",
  "#70482F",
  "#5B4941",
  "#B3A897",
  "#E2AD72",
  "#E48320",
  "#375754",
  "#9EAD9E",
  "#CD6555",
  "#D8C7B2",
  "#BBA17B",
  "#DDCEC4",
  "#324965",
  "#3B424C",
  "#B6D1E2",
  "#8B5545",
  "#DE6546",
  "#B9A08B",
  "#C5A762",
  "#005A56",
  "#4C4E48",
  "#E5E2CD",
  "#829E96",
  "#39595F",
  "#8A8B54",
  "#C2D0DF",
  "#4D3F38",
  "#B0C7D4",
  "#B7C3C5",
  "#AFA490",
  "#817B72",
  "#E7BBB0",
  "#E7EAE0",
  "#69662F",
  "#DCD1C0",
  "#C9CBC9",
  "#D7CFBC",
  "#DFCD45",
  "#A68E86",
  "#ABA18D",
  "#BEC2C2",
  "#717376",
  "#D2D0C6",
  "#DCDFD8",
  "#AFB3A5",
  "#BAB9B5",
  "#DCDFD8",
  "#BEBCBA",
  "#DFDBDA",
  "#93BEC0",
  "#599FB7",
  "#83A8C1",
  "#32523D",
  "#E9E9E7",
  "#CCB7A8",
  "#C6BDBD",
  "#626976",
  "#CEAF96",
  "#807A7C",
  "#DAE0E2",
  "#E2E5E4",
  "#E9E8E9",
  "#EDF2E9",
  "#A3C0DA",
  "#E3DAD6",
  "#E6EACB",
  "#FBECDE",
  "#E4E1DB",
  "#F6D9BE",
  "#97B1DA",
  "#D6C2B7",
  "#B9A99F",
  "#44483D",
  "#F2EAC0",
  "#A38061",
  "#A43E2D",
  "#DDDCD3",
  "#E3E7DE",
  "#4E4A45",
  "#F7F1EF",
  "#7C8BAE",
  "#DFEBC1",
  "#C3CDE1",
  "#949235",
  "#F3E7EF",
  "#D6C387",
  "#D6D5CB",
  "#48433F",
  "#C5E4E9",
  "#AD6368",
  "#B6B4A9",
  "#6794A5",
  "#8F9391",
  "#838C86",
  "#9CBFD7",
  "#ECD5AF",
  "#10A1CF",
  "#E8E8E8",
  "#FCE462",
  "#DDC9B0",
  "#57363F",
  "#BEC1D6",
  "#E88683",
  "#EAE3D7",
  "#983660",
  "#E0B595",
  "#FFBB93",
  "#FBB847",
  "#B0B655",
  "#DC9C86",
  "#FBCAAA",
  "#CBCCCB",
  "#E2E2DB",
  "#E7EAEB",
  "#626F83",
  "#88625A",
  "#D9C15B",
  "#D6CCCA",
  "#E8BDD3",
  "#E4C5C1",
  "#E1C5CB",
  "#E8C4DB",
  "#D9D8DA",
  "#C76090",
  "#E8E1CB",
  "#F08948",
  "#A14A45",
  "#5F5A4C",
  "#136777",
  "#00939F",
  "#0F4C4B",
  "#5A8487",
  "#D7C3B9",
  "#EAEBBA",
  "#5A3732",
  "#873A2B",
  "#9A4C3C",
  "#A09591",
  "#E1DADF",
  "#676A6B",
  "#909998",
  "#F0EDE4",
  "#B8C2C3",
  "#E4D8CE",
  "#E7D4BC",
  "#C6BAA8",
  "#1D577E",
  "#5C615A",
  "#BDC3B9",
  "#62A3AD",
  "#E8E7E3",
  "#9E7043",
  "#CD8161",
  "#DDDAD8",
  "#3F3934",
  "#C6D0C8",
  "#9BA99A",
  "#00836E",
  "#6F6550",
  "#D7D9D6",
  "#EFBFA1",
  "#808080",
  "#41464B",
  "#8A8376",
  "#4C413A",
  "#F4ECD6",
  "#FBE5AD",
  "#F0E8DA",
  "#F6F2DE",
  "#606573",
  "#6E3936",
  "#6B3C50",
  "#A4A93A",
  "#B8B192",
  "#229064",
  "#7A6B81",
  "#F3EED9",
  "#62859D",
  "#7EA28F",
  "#D59883",
  "#3B6035",
  "#796C61",
  "#C49F9A",
  "#66605C",
  "#A493AC",
  "#BFB6BF",
  "#DFDDE2",
  "#7090C9",
  "#D3D0D6",
  "#898D9B",
  "#B4B3B9",
  "#DEDCE6",
  "#ECDFCA",
  "#9B8987",
  "#BDA68A",
  "#AFA490",
  "#817B73",
  "#A2A5A5",
  "#D6C9AD",
  "#D7DDDD",
  "#25313D",
  "#7B8178",
  "#D5CCC4",
  "#57B5A2",
  "#CDD4CE",
  "#818278",
  "#DBEDCF",
  "#E4DDCE",
  "#AAA8AE",
  "#F1F1E8",
  "#EEEFEA",
  "#EEEFEB",
  "#E3E7DE",
  "#E8E8E4",
  "#EDECE7",
  "#C4B591",
  "#4E4653",
  "#636040",
  "#8D9275",
  "#68655D",
  "#C9464F",
  "#F4E3B8",
  "#6F7A70",
  "#C4B591",
  "#CAC8A8",
  "#C9D7C4",
  "#6C645F",
  "#EAE9E7",
  "#EEE9E4",
  "#DFDBD8",
  "#B3C5D1",
  "#D06740",
  "#E1E7EA",
  "#7D98A6",
  "#4E5A60",
  "#85A6AB",
  "#AFB1B3",
  "#E8E7E3",
  "#ABBCDC",
  "#3A7D9A",
  "#98958D",
  "#807A7C",
  "#6C645F",
  "#A09591",
  "#BBC3BB",
  "#9D948B",
  "#BEB1AB",
  "#9E9890",
  "#8B7267",
  "#494538",
  "#CCD9CA",
  "#E7D9C7",
  "#F5BC5D",
  "#CED06A",
  "#64533d",
  "#716d65",
  "#292a27",
  "#5d2d1e",
  "#babbbb",
  "#b04923",
  "#dce1d6",
  "#171b1c",
  "#e3dbce",
  "#c7c2bc",
  "#DACBAF",
  "#756048",
  "#655E49",
  "#655e49",
  "#B2B4AC",
  "#CBCFCA",
  "#404B4E",
  "#A19E93",
  "#B1B6B2",
  "#B1B6B2",
  "#ACB2AF",
  "#AEB1AB",
  "#494A44",
  "#F0EDDD",
  "#303533",
  "#5D5748",
  "#BAC0C0",
  "#898887",
  "#898887",
  "#4F4B47",
  "#3A4145",
  "#3A4145",
  "#423933",
  "#E1DAC7",
  "#AFB0B0",
  "#4D5352",
  "#2B2B2C",
  "#ACADAC",
  "#ACADAC",
  "#B9BEBC",
  "#ACADAC",
  "#A9A092",
  "#F0F4EF",
  "#E0E7EB",
  "#E0E8ED",
  "#5B5C54",
  "#575851",
  "#5B5C54",
  "#586D90",
  "#2D3231",
  "#525659",
  "#4D5153",
  "#ACA598",
  "#0B1574",
  "#D7C8B3",
  "#E5DBC4",
  "#5B5D5D",
  "#5B5D5D",
  "#5B5D5D",
  "#5B5D5D",
  "#5B5D5D",
  "#666D6B",
  "#F2C137",
  "#E5ECE7",
  "#C9BCA3",
  "#4F5257",
  "#4F5257",
  "#D16C37",
  "#2D2E2E",
  "#2D2E2E",
  "#2A2A2B",
  "#2C2D2D",
  "#333937",
  "#3B3C3C",
  "#2A2B2B",
  "#2A2B2B",
  "#2A2B2B",
  "#2A2B2B",
  "#2A2B2B",
  "#2C2D2E",
  "#404645",
  "#404645",
  "#323334",
  "#303031",
  "#006AB2",
  "#006AB2",
  "#0083BE",
  "#162159",
  "#294A62",
  "#4F606B",
  "#4B5D69",
  "#566C76",
  "#566C76",
  "#67767D",
  "#bb9b82",
  "#968D72",
  "#3083C1",
  "#3083C1",
  "#57453C",
  "#4B2B48",
  "#491217",
  "#60595B",
  "#B6BCBB",
  "#A1A3A4",
  "#E1E9F0",
  "#E1E9F0",
  "#EFFBFF",
  "#F5DF3D",
  "#F5DF3D",
  "#4C433D",
  "#7A163C",
  "#564D39",
  "#4D4738",
  "#976E61",
  "#8A8680",
  "#7C7873",
  "#5D4B47",
  "#EAC066",
  "#48403C",
  "#8B8D7E",
  "#8B8D7E",
  "#756048",
  "#7c453e",
  "#F3E7C8",
  "#452430",
  "#CBC8BD",
  "#CBC8BD",
  "#838469",
  "#EFEAD9",
  "#EFEAD9",
  "#A19E99",
  "#9D978E",
  "#9D978E",
  "#8C8478",
  "#B2B4AC",
  "#B2B4AC",
  "#BDB8A7",
  "#373B3E",
  "#373B3E",
  "#373B3E",
  "#3A3D40",
  "#232725",
  "#3D4546",
  "#3C4143",
  "#3D4546",
  "#404041",
  "#444743",
  "#3F423F",
  "#3F3F3D",
  "#A6ABAE",
  "#B4BCBD",
  "#B4B8B4",
  "#D6CF72",
  "#533939",
  "#E3D2B0",
  "#E3D2B0",
  "#E3D2B0",
  "#EFE2C0",
  "#EFE2C0",
  "#2D4338",
  "#F2F5F1",
  "#F2F5F1",
  "#A3A7A9",
  "#936548",
  "#b17861",
  "#936548",
  "#888075",
  "#92867C",
  "#92867C",
  "#29382F",
  "#926346",
  "#8F6244",
  "#2F3433",
  "#323735",
  "#4E6263",
  "#365045",
  "#365045",
  "#365045",
  "#455E50",
  "#455E50",
  "#90886F",
  "#90886F",
  "#9E987E",
  "#4AA590",
  "#313634",
  "#2C312F",
  "#524C40",
  "#4D453F",
  "#513A70",
  "#4A4846",
  "#2F3D36",
  "#2F3D36",
  "#32443C",
  "#3D4954",
  "#3D4954",
  "#3D4954",
  "#45565F",
  "#45565F",
  "#4A5862",
  "#009390",
  "#C6905A",
  "#aa8578",
  "#E5E7E5",
  "#C3AA80",
  "#CEB78E",
  "#DED0AF",
  "#D0D5D2",
  "#AAA398",
  "#AAA398",
  "#AAA398",
  "#B8B4A8",
  "#B8B4A8",
  "#3D3D3D",
  "#313433",
  "#325053",
  "#64635C",
  "#2F487C",
  "#A1A29E",
  "#595449",
  "#959C99",
  "#524A3E",
  "#524A3E",
  "#A8ABA8",
  "#A8ABA8",
  "#373637",
  "#373637",
  "#ACB0B3",
  "#ACB0B3",
  "#DEDBCF",
  "#DEDBCF",
  "#A59E92",
  "#A59E92",
  "#7C8181",
  "#7C8181",
  "#979A9C",
  "#979A9C",
  "#9C9F9F",
  "#595B58",
  "#595B58",
  "#BCB7A3",
  "#BDB7A3",
  "#BCB7A3",
  "#CDC9B5",
  "#CDC9B5",
  "#98292C",
  "#A33733",
  "#BA4432",
  "#ECF0ED",
  "#2E53A1",
  "#3665AD",
  "#A4A9AB",
  "#8A795E",
  "#DFB465",
  "#AB8F5F",
  "#A78B5D",
  "#998053",
  "#9B7F51",
  "#545454",
  "#6EA743",
  "#606964",
  "#6E7173",
  "#BEB9A5",
  "#756F64",
  "#756F64",
  "#837F71",
  "#3D3C3C",
  "#565551",
  "#514842",
  "#483C39",
  "#3B7AAB",
  "#BFA981",
  "#324B3C",
  "#915241",
  "#915241",
  "#34453C",
  "#EAD590",
  "#EFEEE5",
  "#2B302F",
  "#424A4B",
  "#B3BCBD",
  "#FBFFFC",
  "#0D5E86",
  "#0D5E86",
  "#8B392E",
  "#8B392E",
  "#26603E",
  "#26603E",
  "#B42C29",
  "#B42C29",
  "#4B8941",
  "#4B8941",
  "#EECF41",
  "#EECF41",
  "#2769B8",
  "#2769B8",
  "#2A334F",
  "#2A334F",
  "#E65A23",
  "#E7AB36",
  "#E7AB36",
  "#576D69",
  "#4A4E55",
  "#4A4E55",
  "#4A4E55",
  "#525A5E",
  "#525A5E",
  "#F0EDDD",
  "#60503F",
  "#675C51",
  "#675C51",
  "#675C51",
  "#736C5F",
  "#736C5F",
  "#736C5F",
  "#1B6193",
  "#1B6193",
  "#3C3E41",
  "#9e7269",
  "#C5C0B2",
  "#416947",
  "#F1D650",
  "#FEDF47",
  "#C5BEAD",
  "#C1BAA5",
  "#C8DED1",
  "#A5382D",
  "#A6392D",
  "#A5382D",
  "#544F4C",
  "#544F4C",
  "#ADA899",
  "#ADA490",
  "#C8D954",
  "#C8D954",
  "#5E5548",
  "#2F2925",
  "#DBCEB2",
  "#E4DCC0",
  "#676756",
  "#646554",
  "#717662",
  "#2D2E2F",
  "#9C9E9A",
  "#C4BFB5",
  "#F0F2ED",
  "#693832",
  "#693832",
  "#693832",
  "#676D60",
  "#676D60",
  "#764841",
  "#303634",
  "#DFB465",
  "#7E6B52",
  "#675D50",
  "#C1C8C7",
  "#7b4844",
  "#3C3F3E",
  "#4A4745",
  "#A5ABAE",
  "#5D5F5D",
  "#546069",
  "#0D6938",
  "#0D6938",
  "#A6987E",
  "#424343",
  "#424343",
  "#424343",
  "#2A2B2B",
  "#3E3B38",
  "#424343",
  "#424343",
  "#424343",
  "#424343",
  "#424343",
  "#3E3B38",
  "#3E3B38",
  "#3E3B38",
  "#3E3B38",
  "#BDB6AB",
  "#E4DFD6",
  "#514F4D",
  "#A1A29E",
  "#58462C",
  "#A6A9A7",
  "#2D3B50",
  "#354B5E",
  "#A9A092",
  "#303533",
  "#303533",
  "#9AA09C",
  "#959593",
  "#9AA09C",
  "#5E6265",
  "#5E6265",
  "#6A7273",
  "#5C6063",
  "#959C9C",
  "#D9D9CD",
  "#D9D9CD",
  "#E7E9DF",
  "#6A6D70",
  "#6A6D70",
  "#787F80",
  "#7A7D80",
  "#3D3E40",
  "#E2672A",
  "#E2672A",
  "#88473C",
  "#BEC0B9",
  "#BEC0B9",
  "#D4DAD4",
  "#A8BFC8",
  "#78816A",
  "#78816A",
  "#868F78",
  "#868F78",
  "#DADAD7",
  "#939894",
  "#C7E2E3",
  "#9CA0A1",
  "#12273A",
  "#C2B198",
  "#C2B198",
  "#C2B198",
  "#D1C5AD",
  "#D1C5AD",
  "#727C6F",
  "#836F4A",
  "#EFF3F2",
  "#EFF3F2",
  "#F9FFFF",
  "#F9FFFF",
  "#F4F7F5",
  "#F7F8F4",
  "#F9FFFF",
  "#797D7D",
  "#898F8D",
  "#AAB269",
  "#D9DBD8",
  "#A19E98",
  "#1F4E81",
  "#9C8B70",
  "#B9AD97",
  "#877F72",
  "#434138",
  "#85775C",
  "#575042",
  "#BABEBD",
  "#303533",
  "#434138",
  "#BABEBD",
  "#708185",
  "#A98D5F",
  "#7A7363",
  "#696D6E",
  "#EDDBB5",
  "#EDDBB5",
  "#F8E9C2",
  "#F8E9C2",
  "#ECD8B0",
  "#554737",
  "#b9a499",
  "#E6E7DF",
  "#D4A892",
  "#E5BE01",
  "#E98C1A",
  "#E3D9C6",
  "#E3BBA6",
  "#ECC6C1",
  "#FBC651",
  "#AF8C88",
  "#F3B300",
  "#FAD201",
  "#6A5D4D",
  "#DC6F32",
  "#C53940",
  "#F97748",
  "#ED6A40",
  "#B12D42",
  "#A52019",
  "#A72842",
  "#952842",
  "#6F3545",
  "#7B4248",
  "#781F19",
  "#C1876B",
  "#CC0605",
  "#D72D6D",
  "#8673A1",
  "#40428B",
  "#434569",
  "#1E2D6E",
  "#32508D",
  "#4D80C1",
  "#434267",
  "#3A73BA",
  "#063971",
  "#3A5D92",
  "#1D334A",
  "#29748B",
  "#4D644A",
  "#424632",
  "#3D504F",
  "#464748",
  "#35682D",
  "#7B7F6C",
  "#5D4E4C",
  "#709A57",
  "#308446",
  "#9E91A9",
  "#969992",
  "#80737E",
  "#6D6552",
  "#696170",
  "#6E6472",
  "#665C6D",
  "#534E5A",
  "#4F4751",
  "#62565C",
  "#5E5463",
  "#9F8A92",
  "#726C7E",
  "#C2AAAE",
  "#C2AAAE",
  "#D1BBCE",
  "#D1BBCE",
  "#A58F9F",
  "#8E7E8C",
  "#BBA7B3",
  "#7D6C72",
  "#9DA1AA",
  "#8D948D",
  "#4E5452",
  "#CAC4B0",
  "#909090",
  "#82898F",
  "#D0D0D0",
  "#898176",
  "#99524C",
  "#5E4748",
  "#5D4248",
  "#57474F",
  "#4E3B31",
  "#FAF4E3",
  "#E0C6D5",
  "#F4F4F4",
  "#282828",
  "#433C42",
  "#A5A5A5",
  "#A1A1A0",
  "#8F8F8F",
  "#F7D9ED",
  "#463C45",
  "#F6F6F6",
  "#F6F6F6",
  "#D7D7D7",
  "#828282",
  "#493D3B",
  "#634037",
  "#583838",
  "#B3B8B5",
  "#313735",
  "#323735",
  "#595D5A",
  "#C0C5BF",
  "#D0C9B1",
  "#8F9990",
  "#636C6D",
  "#CED5D2",
  "#E7EBDA",
  "#FBFFFF",
  "#E97237",
  "#E5DFCE",
  "#D9CEBE",
  "#9F8E7D",
  "#9F8E7D",
  "#9C9282",
  "#8E573D",
  "#8E573D",
  "#586063",
  "#6C5853",
  "#B9BEBC",
  "#565750",
  "#565750",
  "#4D5453",
  "#4D5453",
  "#353A38",
  "#626663",
  "#626663",
  "#5F483A",
  "#5F483A",
  "#8D9450",
  "#D5D5CA",
  "#D5D5CA",
  "#545040",
  "#545040",
  "#40554C",
  "#AAB1AC",
  "#AAB1AC",
  "#F1A121",
  "#F1A121",
  "#F8AC32",
  "#6C8472",
  "#768A81",
  "#C3B18C",
  "#C3B18C",
  "#E6EAEA",
  "#898C87",
  "#DB9A5D",
  "#4F5C62",
  "#766E63",
  "#B9AD9C",
  "#FFDBD4",
  "#48544F",
  "#DE6A31",
  "#DE6A31",
  "#B3B5AF",
  "#B3B5AF",
  "#B3B5AF",
  "#C2C5BF",
  "#C2C5BF",
  "#476E40",
  "#476E40",
  "#9FA2A2",
  "#91887D",
  "#E2DDD4",
  "#E2DDD4",
  "#F4F4E9",
  "#AE372C",
  "#AE372C",
  "#A94035",
  "#B7B6B2",
  "#919597",
  "#B6BCBB",
  "#969A99",
  "#B1B6B2",
  "#A5ACA8",
  "#ABB2B0",
  "#909190",
  "#E1A98C",
  "#91B0B6",
  "#1B2228",
  "#A48D6A",
  "#3C3B3B",
  "#F5F5EB",
  "#363B4E",
  "#DAC18B",
  "#2C3972",
  "#2C4674",
  "#593435",
  "#F4F4F8",
  "#EAF2F3",
  "#B1ACA3",
  "#454647",
  "#575C5D",
  "#4E5052",
  "#C4BFB9",
  "#909293",
  "#946B3A",
  "#C2AA8D",
  "#CCBCA0",
  "#C5B29B",
  "#908E8A",
  "#908E8A",
  "#616660",
  "#94A19A",
  "#7C8983",
  "#A0A5A7",
  "#618682",
  "#ADC0CA",
  "#DAC9A0",
  "#85898A",
  "#D5D5CD",
  "#D5D5CD",
  "#D5D5CD",
  "#D5D5CD",
  "#D5D5CD",
  "#D6D4C9",
  "#E6E9E0",
  "#E6E9E0",
  "#D6DAD4",
  "#91A79A",
  "#55585B",
  "#E5E2D8",
  "#E5E2D8",
  "#504139",
  "#644133",
  "#644133",
  "#6A4C3B",
  "#45565F",
  "#B8B4A8",
  "#525A5E",
  "#736C5F",
  "#3E3B38",
  "#D1C5AD",
  "#F8E9C2",
  "#2E3332",
  "#9EA09E",
  "#E6E9E0",
  "#5C6059",
  "#616560",
  "#616560",
  "#DADAD6",
  "#E1E4E3",
  "#7D8A85",
  "#909D95",
  "#999F9E",
  "#999F9E",
  "#7C8083",
  "#44767C",
  "#9d6355",
  "#595A57",
  "#303535",
  "#AEB7B9",
  "#A5A9AB",
  "#2F4239",
  "#7B7D7E",
  "#68A842",
  "#68A842",
  "#6D6B67",
  "#6D6B67",
  "#767872",
  "#51493F",
  "#56331E",
  "#5A7990",
  "#6386A0",
  "#43553B",
  "#F3F5F1",
  "#F3F5F1",
  "#E7E8DF",
  "#F3F2EA",
  "#F6F8F5",
  "#F4F4EE",
  "#A1A8A7",
  "#FAFFFD",
  "#F9ECD6",
  "#F5ECD8",
  "#FFFDE7",
  "#F8EED8",
  "#FBF5E0",
  "#53595F",
  "#F5F8F3",
  "#627062",
  "#6E7E6E",
  "#DFB465",
  "#6E7E6E",
  "#7E8481",
  "#7E8481",
  "#7E8481",
  "#8D9592",
  "#8D9592",
  "#6E555A",
  "#516A71",
  "#52524D",
  "#52524D",
  "#52524D",
  "#52524E",
  "#5C6059",
  "#5C6059",
  "#E47433",
  "#2A2A2B",
  "#A19E99",
  "#3A3D40",
  "#A3A7A9",
  "#919597",
  "#E7E8DF",
  "#F6A713",
  "#F6A713",
  "#FFB51C",
  "#2C2C2D",
  "#2C2C2D",
  "#3C3F43",
  "#3C3F43",
  "#3B4044",
  "#3B4044",
  "#6C6F72",
  "#6C6F72",
  "#2D2D2E",
  "#2D2D2E",
  "#E3E1D8",
  "#E3E1D8",
  "#ADB1B2",
  "#ABAFB1",
  "#545450",
  "#545450",
  "#F0F4F2",
  "#F0F4F2",
  "#9d958c",
  "#d1cdca",
  "#dfded3",
  "#d4d0ca",
  "#9e968b",
  "#4d423d",
  "#484343",
  "#fcecc5",
  "#6d6c65",
  "#ede8d1",
  "#000000",
  "#c3b9a8",
  "#81725e",
  "#aab4ab",
  "#434542",
  "#616158",
  "#8f9489",
  "#594d3e",
  "#6b6f62",
  "#6d3e36",
  "#5e5348",
  "#ffffff",
  "#63737d",
  "#9ea08a",
  "#3e5d73",
  "#dcceb0",
  "#576161",
  "#c9bfaa",
  "#73796b",
  "#514138",
  "#8299a3",
  "#e7e5d5",
  "#d1cec3",
  "#333c45",
  "#48453c",
  "#808481",
  "#928e82",
  "#a39685",
  "#c3b7a0",
  "#d0c6b4",
  "#aca0a0",
  "#dedfd8",
  "#e0dde8",
  "#891a20",
  "#a3927d",
  "#504541",
  "#605b5d",
  "#2f483b",
  "#25446a",
  "#4f3936",
  "#6b3933",
  "#aa7350",
  "#494d55",
  "#9f9181",
  "#314a40",
  "#abbcc3",
  "#1c4b60",
  "#486c83",
  "#eae3ed",
  "#1a4339",
  "#c8b6aa",
  "#534940",
  "#1f2021",
  "#3e3a38",
  "#385a6b",
  "#cfcfdc",
  "#863e39",
  "#b59380",
  "#a02223",
  "#777570",
  "#cdd0d2",
  "#505255",
  "#100f0f",
  "#979695",
  "#d0c9cc",
  "#4e2c2f",
  "#010005",
  "#393335",
  "#583b35",
  "#948d87",
  "#eae6cd",
  "#4c2f27",
  "#33362d",
  "#c3c3c1",
  "#2e453f",
  "#463f39",
  "#a52a23",
  "#9a9a98",
  "#bbb1a7",
  "#fbfaf8",
  "#876a4f",
  "#51514f",
  "#968e83",
  "#95928e",
  "#696a67",
  "#4c535b",
  "#a3816d",
  "#8d5937",
  "#7d6e5d",
  "#403c39",
  "#925437",
  "#bf9e75",
  "#5b6d76",
  "#a37c59",
  "#564033",
  "#ccc5b7",
  "#d9d9d9",
  "#83654f",
  "#ffffff",
  "#e4e2d8",
  "#aa9a88",
  "#dcd0b5",
  "#cdc8c2",
  "#9a948c",
  "#cbbeb3",
  "#93999c",
  "#f0e9d1",
  "#8397a5",
  "#c1b49e",
  "#e0cbae",
  "#fff1cf",
  "#d2cdbb",
  "#e1e1dd",
  "#5f474b",
  "#686057",
  "#575a5c",
  "#a6a9a8",
  "#4e4c49",
  "#754944",
  "#514b46",
  "#6e6d6d",
  "#4e6157",
  "#4c677b",
  "#4f5c58",
  "#574b47",
  "#424344",
  "#a2a29c",
  "#8f6a45",
  "#afbec3",
  "#818c77",
  "#9a3e43",
  "#c1c2b4",
  "#a99a88",
  "#638391",
  "#84817f",
  "#d2d8d6",
  "#9c5b4f",
  "#595954",
  "#e5dccb",
  "#040707",
  "#751b16",
  "#332c28",
  "#9b8c78",
  "#afb6b5",
  "#183f2e",
  "#726659",
  "#ffffff",
  "#393b3a",
  "#4c3e2f",
  "#997d62",
  "#8b694c",
  "#69493a",
  "#8a4f3c",
  "#242f2d",
  "#4a4739",
  "#d0d0c3",
  "#979a9b",
  "#FFFFFF",
  "#f9ead3",
  "#decfb0",
  "#100c0b",
  "#695e58",
  "#49281f",
  "#64142d",
  "#3e2c14",
  "#7f6661",
  "#c8ba9f",
  "#b5b9bc",
  "#0c452f",
  "#153149",
  "#5d7486",
  "#6b1d11",
  "#afa292",
  "#8f6d4a",
  "#fbf6f2",
  "#eeeef0",
  "#968a76",
  "#868683",
  "#838a91",
  "#857e75",
  "#3d4445",
  "#655541",
  "#585747",
  "#2c3c55",
  "#804039",
  "#58554f",
  "#5a6c7c",
  "#3d505a",
  "#5f6860",
  "#6a7c7e",
  "#e5ddcd",
  "#edeadf",
  "#c0cecd",
  "#cfd2c3",
  "#39311e",
  "#e8e5d1",
  "#363332",
  "#000000",
  "#f5f4ed",
  "#7b7562",
  "#5b3738",
  "#4b4940",
  "#485b65",
  "#99a6a7",
  "#863826",
  "#3f351a",
  "#2a4b37",
  "#2f5b48",
  "#474742",
  "#1d584d",
  "#51736f",
  "#004677",
  "#3f4442",
  "#4b2d02",
  "#675b43",
  "#373432",
  "#3f7898",
  "#737577",
  "#282c2d",
  "#3f7897",
  "#398c73",
  "#eef7f5",
  "#e1dbca",
  "#e7e4d1",
  "#99a6a7",
  "#e7e6de",
  "#00676c",
  "#b45414",
  "#ae9076",
  "#54372f",
  "#98887c",
  "#313132",
  "#313132",
  "#313132",
  "#d3cab7",
  "#010101",
  "#a2978a",
  "#ffffff",
  "#90623d",
  "#6e786f",
  "#000000",
  "#f3f3eb",
  "#475b65",
  "#3f351a",
  "#dbdee1",
  "#e7e6dd",
  "#ada18e",
  "#ebe8dc",
  "#949587",
  "#d4d1c7",
  "#fdfdf8",
  "#555551",
  "#4f4535",
  "#253d37",
  "#292817",
  "#6d503d",
  "#514a3d",
  "#454543",
  "#1a1b1c",
  "#3c4233",
  "#6f695d",
  "#5d6060",
  "#76332d",
  "#2b322e",
  "#38484f",
  "#565656",
  "#3a423f",
  "#60757a",
  "#adb8c0",
  "#1a363f",
  "#8f8f7e",
  "#924a36",
  "#633d30",
  "#928b82",
  "#7f5944",
  "#7f807d",
  "#f5f4f0",
  "#a3a284",
  "#4d555e",
  "#dfd5ba",
  "#8b857f",
  "#5f5248",
  "#727f83",
  "#596356",
  "#998475",
  "#9e998f",
  "#b1aea6",
  "#fbefd5",
  "#dfdbce",
  "#77382f",
  "#4d5765",
  "#c9a983",
  "#b3a798",
  "#697453",
  "#a8b4bb",
  "#5e6972",
  "#6e5e54",
  "#6e5e50",
  "#ece9de",
  "#ccbea2",
  "#9fa095",
  "#504f4d",
  "#636058",
  "#7a766c",
  "#757c5f",
  "#c0bfbb",
  "#2f2b2a",
  "#9c908c",
  "#887771",
  "#6a858c",
  "#efefef",
  "#2a2625",
  "#05030b",
  "#39342a",
  "#a59e90",
  "#c1b7a2",
  "#fff6ee",
  "#a18062",
  "#424e53",
  "#615b5d",
  "#26262a",
  "#d0d3dc",
  "#F7F6EF",
  "#e2ddd3",
  "#b8b4a8",
  "#2f2e31",
  "#443a35",
  "#a1a09b",
  "#737373",
  "#625852",
  "#737373",
  "#66676a",
  "#cdc5a5",
  "#262325",
  "#39312c",
  "#b9b09b",
  "#f8f8f8",
  "#000000",
  "#aea590",
  "#dcd1ba",
  "#ffffff",
  "#9d6844",
  "#d9c9af",
  "#f5faf4",
  "#e7d7b3",
  "#1e1e1e",
  "#45403c",
  "#c0b6a5",
  "#384e47",
  "#928986",
  "#9b927f",
  "#858078",
  "#e6e0de",
  "#000000",
  "#6e634d",
  "#602a2a",
  "#36251b",
  "#154535",
  "#f2e8cd",
  "#000000",
  "#65838e",
  "#436585",
  "#9d836b",
  "#4e4a48",
  "#521c01",
  "#403929",
  "#0f3c2b",
  "#2f4e38",
  "#000000",
  "#373530",
  "#717c7b",
  "#a9a897",
  "#9b8d6e",
  "#2b4164",
  "#f1f5f8",
  "#797f65",
  "#b39c85",
  "#444c4d",
  "#235272",
  "#7c402e",
  "#746f66",
  "#695c49",
  "#423e22",
  "#666662",
  "#dcd4bf",
  "#0c0c0e",
  "#19221f",
  "#c6bfad",
  "#f1faf7",
  "#242424",
  "#29231b",
  "#f4f4f2",
  "#736d63",
  "#d7cdb9",
  "#646561",
  "#682e2a",
  "#61544c",
  "#683418",
  "#545e67",
  "#864f29",
  "#a09b8f",
  "#53514e",
  "#725147",
  "#6f6154",
  "#746349",
  "#595755",
  "#4b3828",
  "#555b57",
  "#9a8771",
  "#b6afa7",
  "#a28a75",
  "#555554",
  "#976824",
  "#8d847a",
  "#bbbab3",
  "#434c57",
  "#6d7b82",
  "#80806a",
  "#434446",
  "#a99d8d",
  "#888986",
  "#b9aa92",
  "#796e5f",
  "#626564",
  "#736f66",
  "#574841",
  "#e1e1da",
  "#a6a39a",
  "#543546",
  "#000000",
  "#982721",
  "#3f3928",
  "#5f5e5b",
  "#9c927c",
  "#344f41",
  "#1f4963",
  "#4a6e7d",
  "#1a4535",
  "#ded0b3",
  "#5f453a",
  "#c3bba3",
  "#8c5d2c",
  "#f1f2f0",
  "#7f2f13",
  "#af9778",
  "#5a6265",
  "#fff5c9",
  "#717f65",
  "#accccb",
  "#bd6e50",
  "#3f382e",
  "#5e7270",
  "#e7b26e",
  "#060503",
  "#434746",
  "#212526",
  "#9d9483",
  "#323433",
  "#f9eed8",
  "#493f3d",
  "#274b41",
  "#afa397",
  "#776a61",
  "#ebebe9",
  "#c8c3af",
  "#7e745b",
  "#5f4736",
  "#352b21",
  "#6e3623",
  "#8b8e8c",
  "#6c748c",
  "#141211",
  "#ad9b7a",
  "#55534b",
  "#083931",
  "#5b5d5d",
  "#e6ddcb",
  "#4e2f21",
  "#e1d3b6",
  "#675d43",
  "#ffffff",
  "#54473b",
  "#242021",
  "#2b312f",
  "#b6b3a5",
  "#e8dcc7",
  "#f2f1f7",
  "#0a0203",
  "#837b68",
  "#ede7db",
  "#140b01",
  "#f8f0df",
  "#000000",
  "#48473a",
  "#d7d3cb",
  "#7e8083",
  "#28291f",
  "#b7b09b",
  "#433b35",
  "#0a3210",
  "#9a948c",
  "#3d4445",
  "#f5efe4",
  "#f5efe4",
  "#7f5432",
  "#757561",
  "#a39382",
  "#d3cdbc",
  "#9e8e76",
  "#766340",
  "#572700",
  "#ffffff",
  "#c6b9a0",
  "#dad6d8",
  "#ddbf9c",
  "#7d695d",
  "#9d805f",
  "#633c28",
  "#d2ab7b",
  "#3c434b",
  "#bd8b68",
  "#aa7a47",
  "#774820",
  "#83715b",
  "#93663b",
  "#23211f",
  "#5a4b44",
  "#e8e8e8",
  "#98896f",
  "#9b7c4a",
  "#633b29",
  "#9d8d82",
  "#1e1a15",
  "#8e5c2f",
  "#67402e",
  "#cca778",
  "#97673a",
  "#40392e",
  "#b37f45",
  "#b6aa9c",
  "#8f837b",
  "#232323",
  "#5d5956",
  "#c46623",
  "#66331a",
  "#443730",
  "#1c2317",
  "#000000",
  "#a9a18f",
  "#181717",
  "#e1dbc4",
  "#f9f7f7",
  "#463829",
  "#e1d4c2",
  "#030505",
  "#bebebe",
  "#f5f5f5",
  "#000000",
  "#eef0f0",
  "#7e7f84",
  "#5e4330",
  "#e4d4c1",
  "#ffffff",
  "#4a1711",
  "#4d4b40",
  "#694414",
  "#C97F31",
  "#B1871C",
  "#8A4C11",
  "#9C5634",
  "#2E2927",
  "#786256",
  "#5A5652",
  "#A56F4B",
  "#693424",
  "#5C3B28",
  "#BB8342",
  "#5D3D2E",
  "#242223",
  "#442E26",
  "#593328",
  "#3A3C47",
  "#7A7777",
  "#CDB9B2",
  "#1A1617",
  "#841000",
  "#534B40",
  "#8E867B",
  "#562D01",
  "#B3BAC0",
  "#004833",
  "#D2C9B6",
  "#70665A",
  "#FFFFFF",
  "#55514A",
  "#C4BAAA",
  "#EFEEE5",
  "#DDD9CE",
  "#EEECE1",
  "#504A46",
  "#A59484",
  "#888782",
  "#8A5A4C",
  "#E6E0DB",
  "#684F46",
  "#AEAA9D",
  "#313132",
  "#41433C",
  "#ACA7A1",
  "#563638",
  "#554C46",
  "#575C60",
  "#743733",
  "#413D3E",
  "#A7A9A9",
  "#40574C",
  "#394542",
  "#6B7972",
  "#4C3C38",
  "#27292D",
  "#5F544B",
  "#828A75",
  "#1F5371",
  "#A23032",
  "#E8ECEE",
  "#D1CABC",
  "#AD9883",
  "#537C8D",
  "#7E7B77",
  "#E8E7DC",
  "#D8DBDA",
  "#B8A28D",
  "#A34C38",
  "#3B3833",
  "#CABAA0",
  "#010005",
  "#454A4D",
  "#9B8E7E",
  "#F4F1E8",
  "#D9C8AD",
  "#1D181D",
  "#D5D1C9",
  "#BCAE9F",
  "#736242",
  "#423B28",
  "#4C4139",
  "#BAAB96",
  "#424244",
  "#4A443A",
  "#36393B",
  "#DDD9D3",
  "#E7E0CC",
  "#1A1517",
  "#524B3E",
  "#752716",
  "#094536",
  "#C5CDD7",
  "#F7F8F8",
  "#987856",
  "#704F46",
  "#C1BFBA",
  "#494A4B",
  "#A59A8D",
  "#695B52",
  "#514946",
  "#B0A89C",
  "#2B2726",
  "#87898C",
  "#494542",
  "#363621",
  "#757A6C",
  "#425966",
  "#e8e4d9",
  "#473933",
  "#6e5a49",
  "#60554c",
  "#5b4f41",
  "#c0b5a0",
  "#c5baa6",
  "#6b6a5b",
  "#acb4ac",
  "#99a098",
  "#67716e",
  "#4e5856",
  "#435454",
  "#3c4d51",
  "#2a2b2c",
  "#7f878a",
  "#626869",
  "#423f3b",
  "#463e3b",
  "#81796f",
  "#72695e",
  "#c0bbae",
  "#4d483d",
  "#d9d9d1",
  "#3d5463",
  "#f2f2eb",
  "#797979",
  "#867d6e",
  "#6e726a",
  "#f2f4f1",
  "#676662",
  "#e3e2da",
  "#f4f6f1",
  "#030303",
  "#f8f0ca",
  "#4c4e4a",
  "#cecece",
  "#ffffff",
  "#3b3020",
  "#98a0ac",
  "#a0917e",
  "#6e3831",
  "#365f76",
  "#8f8c78",
  "#403f41",
  "#a2a298",
  "#695b52",
  "#595c53",
  "#8f8780",
  "#a6998f",
  "#265d79",
  "#2c3c55",
  "#203c51",
  "#475662",
  "#514946",
  "#cecccb",
  "#fafafa",
  "#7b2c06",
  "#636a6d",
  "#777a74",
  "#576c58",
  "#919599",
  "#d5c1a7",
  "#cfd0cc",
  "#6c7275",
  "#5b6163",
  "#746759",
  "#8f5a40",
  "#979784",
  "#494542",
  "#58554f",
  "#f8e4c4",
  "#907460",
  "#595c53",
  "#253739",
  "#79343c",
  "#b57c45",
  "#976645",
  "#a67c4b",
  "#debe98",
  "#6f5241",
  "#ebdfce",
  "#ebe9e0",
  "#eae9e0",
  "#e8e7df",
  "#ad9785",
  "#e5dfd4",
  "#837363",
  "#615447",
  "#bfb5a9",
  "#60544b",
  "#dbd3c6",
  "#d6c3a8",
  "#f3f1e7",
  "#c0beaf",
  "#9ca18d",
  "#868b81",
  "#c2c9bd",
  "#92a098",
  "#7c9392",
  "#596e6b",
  "#617475",
  "#455454",
  "#9dabab",
  "#4b4042",
  "#3f4445",
  "#dae5df",
  "#b3c7c8",
  "#7f9a9f",
  "#5d6d76",
  "#c7cbce",
  "#aab1b6",
  "#555c64",
  "#2a2b2c",
  "#e5e4de",
  "#b7bbba",
  "#7f878a",
  "#3a3b3b",
  "#d5d4d0",
  "#c6c3c0",
  "#b3b1ae",
  "#828080",
  "#c6c7c5",
  "#efece1",
  "#d5cabd",
  "#948c83",
  "#eae5dc",
  "#d5d1c6",
  "#a6a39a",
  "#d9d8d1",
  "#b7b7af",
  "#838682",
  "#61635e",
  "#4b4b45",
  "#235083",
  "#ecefec",
  "#557280",
  "#6b877a",
  "#fedc98",
  "#de9777",
  "#a55b3f",
  "#3f373e",
  "#c3b39a",
  "#13171c",
  "#e9e4da",
  "#bdc4c5",
  "#eadfc8",
  "#f3f3f0",
  "#efedea",
  "#efefec",
  "#e6e3da",
  "#eeeee7",
  "#e7e4dd",
  "#424242",
  "#84837d",
  "#5e5b56",
  "#6f645c",
  "#5d5651",
  "#938c7c",
  "#dac988",
  "#bbc0a9",
  "#c8cbc5",
  "#9ca19a",
  "#979f9b",
  "#767a72",
  "#4e5351",
  "#cccfcd",
  "#8da09f",
  "#698587",
  "#42676f",
  "#425862",
  "#b5c2c5",
  "#81959d",
  "#64737a",
  "#424547",
  "#a7aeb0",
  "#5c6568",
  "#565f6b",
  "#515b63",
  "#4e535c",
  "#5e5b5d",
  "#4b4042",
  "#5f444a",
  "#624c4d",
  "#9fa8ac",
  "#a6a19a",
  "#dedede",
  "#e2dcc0",
  "#aeae9a",
  "#f7f1cc",
  "#cbd0c9",
  "#d8d4bf",
  "#bbc2aa",
  "#f0ead6",
  "#c5bea2",
  "#fbf9f9",
  "#343032",
  "#5b433b",
  "#584d45",
  "#a29d8a",
  "#ffffff",
  "#bcb6a1",
  "#4a494a",
  "#ffffff",
  "#cec6ba",
  "#74655a",
  "#46413c",
  "#c4b6a2",
  "#bcb6b1",
  "#615347",
  "#605951",
  "#8b8882",
  "#222944",
  "#7d4037",
  "#777a74",
  "#c0b6a7",
  "#8a8f92",
  "#838a92",
  "#e4d7c6",
  "#778d99",
  "#4e606d",
  "#b1a693",
  "#d3bea1",
  "#515557",
  "#857e75",
  "#5f6860",
  "#79797a",
  "#efdab3",
  "#000000",
  "#4e4539",
  "#9b917f",
  "#d1bf9f",
  "#ffffff",
  "#141414",
  "#39311d",
  "#69735a",
  "#e9e8d3",
  "#363432",
  "#004583",
  "#231f20",
  "#f6f5f1",
  "#7c7562",
  "#5b3838",
  "#b93232",
  "#ccc4af",
  "#485b65",
  "#9aa7a9",
  "#943c29",
  "#c6701b",
  "#3f351a",
  "#2e5c48",
  "#6b7b84",
  "#b3ada5",
  "#1b584e",
  "#537878",
  "#004678",
  "#404543",
  "#4b2d05",
  "#675b44",
  "#1d1c0f",
  "#3f7998",
  "#747577",
  "#366889",
  "#378c73",
  "#e2dccb",
  "#c6b291",
  "#8e8f92",
  "#919392",
  "#e8e8e1",
  "#00686d",
  "#b55513",
  "#7b868e",
  "#000000",
  "#414141",
  "#314d43",
  "#f9feff",
  "#483c22",
  "#e5dbc7",
  "#d5c4b6",
  "#aba79f",
  "#efede9",
  "#f4f4f7",
  "#48292f",
  "#463f32",
  "#545657",
  "#a1a4a2",
  "#2e4f39",
  "#692a2c",
  "#524f4e",
  "#474647",
  "#273d1e",
  "#6e7e77",
  "#422c1f",
  "#544b3a",
  "#6c6d6d",
  "#9a9990",
  "#921a2c",
  "#335369",
  "#c8c4b6",
  "#c9b9a2",
  "#6a8f9e",
  "#84817d",
  "#dfddd5",
  "#3e6a62",
  "#a6592c",
  "#83a684",
  "#dad6b4",
  "#9e9687",
  "#a72225",
  "#030203",
  "#eaecda",
  "#194726",
  "#6c2b11",
  "#181b15",
  "#969b93",
  "#0e291b",
  "#3d241c",
  "#5b4f30",
  "#4e463a",
  "#6b7f56",
  "#e1e8e3",
  "#15335f",
  "#cdcdb5",
  "#a99474",
  "#4f7483",
  "#686355",
  "#f4f4e6",
  "#dae1da",
  "#a84729",
  "#928d8a",
  "#828486",
  "#79563f",
  "#8d8581",
  "#956e4f",
  "#bbb3af",
  "#906d4b",
  "#978b81",
  "#514946",
  "#6e3831",
  "#375348",
  "#cecccb",
  "#365f76",
  "#79343c",
  "#203c51",
  "#695b52",
  "#8f5a40",
  "#87898c",
  "#664f40",
  "#626869",
  "#71706d",
  "#3f3a34",
  "#ffffff",
  "#ded9c9",
  "#dfe1de",
  "#aeafac",
  "#5e6367",
  "#1d4933",
  "#30291f",
  "#a9abac",
  "#000013",
  "#5e4f2a",
  "#dfe1de",
  "#ded9ca",
  "#827870",
  "#a5978b",
  "#130600",
  "#831002",
  "#524c3f",
  "#b1a89c",
  "#562e04",
  "#b5bbc0",
  "#004833",
  "#d3ccb9",
  "#71675b",
  "#57493e",
  "#d8b689",
  "#50433b",
  "#e8e8e8",
  "#e8d5b7",
  "#d2d9d5",
  "#000000",
  "#babcb4",
  "#c9a585",
  "#ca2c38",
  "#d3dedc",
  "#9a7c61",
  "#4c1b1b",
  "#d4d5cf",
  "#ded2c3",
  "#665f5a",
  "#574139",
  "#3b3533",
  "#282a2a",
  "#233835",
  "#a9242f",
  "#007a6e",
  "#007864",
  "#cfa269",
  "#004e62",
  "#3a4040",
  "#004063",
  "#004b34",
  "#5f4d47",
  "#93ac92",
  "#2f8777",
  "#a99b8c",
  "#e3dfd8",
  "#919898",
  "#0078a5",
  "#6a7960",
  "#00a7b8",
  "#1b797f",
  "#006c4a",
  "#a9a29a",
  "#bfbcb7",
  "#ad9b7c",
  "#b2352b",
  "#009484",
  "#cac8c4",
  "#c8b79f",
  "#6e4729",
  "#73392f",
  "#4e2b1b",
  "#362218",
  "#b07540",
  "#d09041",
  "#d39c57",
  "#b96e3a",
  "#892c23",
  "#9d6134",
  "#9b3b26",
  "#000000",
  "#351900",
  "#aea295",
  "#bcaf9f",
  "#5b5b59",
  "#8d3428",
  "#000000",
  "#ffffff",
  "#573d2b",
  "#4f2a30",
  "#383a2c",
  "#565656",
  "#ada48a",
  "#a87548",
  "#851c23",
  "#215134",
  "#1a4766",
  "#a1a8a5",
  "#2a6e88",
  "#e2ebe6",
  "#d8d3b6",
  "#c3a67f",
  "#6b7289",
  "#231f20",
  "#aa9977",
  "#545149",
  "#003830",
  "#595b5b",
  "#e5dbc9",
  "#4c2d21",
  "#e0d1b5",
  "#665b42",
  "#ffffff",
  "#b58c6a",
  "#57341e",
];
